import React, { Component, Fragment } from 'react';
import { renderToString } from 'react-dom/server';
import { Redirect } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isAdmin, showNewRealEstateUI } from 'utils/state';
import { filterNonGuestUsers } from 'utils/users';
import { stripHTML } from 'utils/string';
import { openIntercomChat } from 'utils/intercom';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Header from '../../components/Header';
import RealEstatePackages from '../../components/RealEstatePackages';
import { hideModal } from 'redux/modules/modal';
import StickyHeader from '../../components/StickyHeader/StickyHeader';
import RolesTooltip from '../../components/RolesTooltip';
import { 
	isValidNonZeroQuantity,
	getSubscriptionsAndAddons,
	getMembersPaidQuantity,
	getCurrencyUsedInCB,
	getTotalProductsForCompany,
	getNonObsoleteMemberAddonForPlan,
	getSubscriptionRedirectUrl
} from '../../utils/subscription';
import { Info, CheckIcon2, XIcon, VoucherIcon, IconNoPackage, WeAcceptIcon, WeAcceptEurIcon } from '../../theme/icons';

import PromoForm from '../../components/PromoForm';
import QuantityField from '../../components/QuantityField';
import { clearAppliedDiscount, changeCouponType, applyDiscountUsingCouponId } from 'redux/modules/discount';
import { changeMagixDiscountProdType } from 'redux/modules/crs';
import {
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	Button,
	Select,
	MenuItem,
	Paper,
	Link,
	FormControlLabel,
	Radio,
	RadioGroup,
	IconButton,
	Tooltip,
	ExpansionPanel,
	ExpansionPanelDetails,
	ExpansionPanelSummary
} from '@material-ui/core';

import ExpandMore from '@material-ui/icons/ExpandMore';
import SelectArrow from '@material-ui/icons/KeyboardArrowDown';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import {
	PHOTO_PERPETUAL_LATEST_VERSION,
	WEB_PERPETUAL_LATEST_VERSION,
	DESIGNER_PERPETUAL_LATEST_VERSION,
	SUBSCRIPTION_PLAN,
	SUBSCRIPTION_PLAN_UPGRADE_OPTIONS,
	SUBSCRIPTION_PERIOD,
	SUBSCRIPTION_VIEW,
	CURRENCIES,
	SUBSCRIPTION_PRICES,
	PLAN_CATEGORIES,
	PACKAGES_CONFIG,
	PACKAGE_DESCRIPTION_ITEM_TYPE,
	CAP_KEY,
	DEFAULT_SUBSCRIPTION,
	DISCOUNTS_CONFIG,
	DISCOUNT_TYPE,
	DISCOUNT_KEY,
	USER_DISCOUNT_BANNER_SETTING_KEY,
	FOREVER_HIDDEN_KEY,
	PRODUCT_PREFIX_TO_PACKAGE_MAP,
	PRODUCT_CATEGORY_TO_PACKAGE_MAP,
	PERPETAUL_PRODUCT_CATEGORY_TO_PACKAGE_MAP,
	STANDARD_OVERVIEW_PLAN_ID,
	REAL_ESTATE_OVERVIEW_PLAN_ID,
	MAP_ADDON_TO_LATEST_VERSION,
	BUY_MORE_POPUP_TYPE,
	COUPON_TYPE,
	QUANTITY_TYPE,
	ADDONS_LIST,
	ADDONS_CONFIG,
	CB_API_FETCH_CURRENCY,
	MAXIC_DISCOUNT_PROD_TYPE,
	PRODUCT_CATEGORY,
	HOSTING_BUTTON_URL_EN,
	HOSTING_BUTTON_URL_DE,
	REAL_ESTATE_INDUSTY_ID,
	FORCE_RE_CHECKOUT_WITH_ALL_USERS
} from '../../config';
import { ChargeBee } from '../../redux/modules/chargebee';
import { showModal } from '../../redux/modules/modal';
import {
	createChargeBeeSession,
	createChargeBeeSubscription,
	sendEmailNotification,
	writeCompanySettings,
	purchaseSeats,
	showPackageDiscontinuedMessage,
	showRateLimitError,
	showErrorPopup,
	getUpcomingInvoiceEstimate,
	getSubscriptionEstimation
} from 'redux/modules/companies';
import { writeUserSettings } from '../../redux/modules/session';
import { 
	isDiscountBannerTemporarilyHidden,
	saveHideDiscountBannerFlag,
	saveReUpgradePopupPlan,
	saveMagixDiscountCredentials,
	clearMagixDiscountCredentials,
	saveCheckoutPlan,
	saveCheckoutLang,
	saveCheckoutSeatsQuantity,
	setIsFirstOrder,
	clearFirstOrder
} from '../../utils/storage';
import { setErrorId } from 'redux/modules/error';
import { showPreloader, hidePreloader } from 'redux/modules/preloader';
import { showChargebeeLoader, hideChargebeeLoader } from 'redux/modules/chargebeeLoader';
import { 
	trackClickSubscriptionUpgrade,
	trackVisitedPlusOverview,
	trackVisitedPerpetualOverview,
	trackVisitedStandardOverview,
	trackVisitedRealEstateOverview,
	trackCategoryChange,
	trackDurationChange,
	trackVisitedReactivateRouteFromEmail
} from 'lib/Segment/customTrackers';
import { getTrackingOptions } from 'lib/Segment/helpers';
import i18n from 'i18n/i18n';
import _ from 'lodash';
import CenteredContent from 'components/CenteredContent/CenteredContent';
import { getCurrentPlanId, convertPlanIdIntoSubscription } from '../../utils/subscription';
import { parseQuery } from '../../utils/url';
import { USERS, SUBSCRIPTION, getRoute } from 'routes';
import { actionButtonDebounceTimeout } from 'theme/uiConfig';
import AppError from '../../errors/apperror';
import Logger from '../../logger/logger';
import ERROR from 'errors/errorids';
import { 
	setAllPackagesShownFlag,
	setSubscriptionCategory,
	setSubscriptionView,
	setSubscriptionPeriod,
	setSubscriptionCurrency,
	setSeatsQuantity,
	setLicensesQuantity,
	setAppStateParams,
	clearSubscriptionState,
	setPendingTriggerCheckout,
	clearReduceUsersApiErrorState,
	setReduceUsersApiErrorState,
	setRenewalPopupWasShown
} from 'redux/modules/app';

const localize = i18n.loc.localize;
const log = Logger.get('Subscription');

const localeDateStringOptions = { year: 'numeric', month: 'short', day: 'numeric' };

// Use this to create breakpoint when screen is smaller for 200px compared to LG MUI breakpont 
const BREAKPOINT_1100_DIFFERENCE = 200;
const PERIOD_AND_CURRENCY_SELECTOR_DIFFERENCE = 10;
const CLEAR_PENDING_SUBSCRIPTION_TIMEOUT = 30000;
const PACKAGE_COLUMN_WIDTH_TRESHOLD_CLOUD = 300;
const PACKAGE_COLUMN_WIDTH_TRESHOLD_DESKTOP = 225;

const itemRefPrefix = [
	'ProductPriceInfo',
	'ProductShortDescriptionDesktop',
	'ProductShortDescriptionCloud'];

const styles = theme => ({
	stickyHeader: {
		marginBottom: 45,
		marginLeft: -10,
		marginRight: -10,
		paddingLeft: 10,
		paddingRight: 10,
		width: 'calc(100% + 20px)',
		maxWidth: 1360,
		background: theme.palette.common.white
	},
	header: {
		paddingBottom: 20
	},
	/* product list */
	productsList: {
		//maxWidth: 1350,
		flexDirection: 'column',
	},
	productsListVerticalWrapper: {
		width: '100%'
	},
	productsListVertical: {
		position: 'relative',
		flexDirection: 'row',
		flexWrap: 'nowrap',
		justifyContent: 'space-between',
		'&.columns2 .productVerticalColumn': {
			flex: '0 0 calc(50% - 18px)',
			'&:last-child': {
				marginLeft: 18,
				marginRight: 'auto'
			}
		},
		'&.columns3 .productVerticalColumn': {
			flex: '0 0 calc(33% - 18px)'
		},
		'&.columns4 .productVerticalColumn': {
			flex: '0 0 calc(25% - 18px)',
			'& .productContentVertical': {
				padding: 18
			}
		},
		'&.mobilePackageList': {
			display: 'block',
			'& .productVerticalColumn': {
				margin: '0 0 10px !important'
			}
		}
	},
	product: {
		width: '100%',
		marginBottom: 20
	},
	productVerticalColumn: {
		maxWidth: 427,
		display: 'flex'
	},
	productWrapperVertical: {
		borderRadius: 20,
		boxShadow: '0px 0px 10px 1px rgba(0, 0, 0, 0.10);',
		padding: 8,
		display: 'flex',

		'&.isCloudCategory.scaleBox:not(.activeProductContent)':  {
			background: 'linear-gradient(to bottom, #FF00B1, #632ACD)'
		}
	},
	productContent:  {
		borderRadius: 0,
		boxShadow: '0px 0px 10px 1px rgba(0, 0, 0, 0.10);',
		padding: 25
	},
	ownedProductContent: {
		position: 'relative',
		paddingTop: 55,
		paddingBottom: 55,
		'&.hasAddons': {
			position: 'relative',
			margin: '0 0 30px'
		},
		'&.hasAddons:after': {
			position: 'absolute',
			bottom: '-25px',
			left: 0,
			content: '""',
			height: 1,
			width: '100%',
			background: '#ebebeb',
		},
		'&.hasCancellationDate': {
			paddingTop: 25,
			paddingBottom: 25
		},
		'&.hasReactivateLink': {
			paddingTop: 16,
			paddingBottom: 0
		},
		'&.isMonthly': {
			paddingTop: 16, 
			paddingBottom: 0
		}
	},
	activeProductContent: {
		'& .productContentVertical': {
			background: '#F4F4F4'
		},
		'& .packageDetailsTag': {
			background: '#e1e1e1'
		}
	},
	productColumns: {
		[theme.breakpoints.down('sm')]: {
			flexDirection: 'column'
		}
	},
	productContentVertical: {
		display: 'flex',
		background: '#fff',
		flexDirection: 'column',
		borderRadius: 14,
		padding: '24px 24px 10px'
	},

	/* column name / price */
	gridProductHeader: {
		position: 'relative',
		marginBottom: 10
	},
	gridProducPriceAndDescription: {
	},
	productTag:  {
		background: '#FF00B1',
		color: '#fff',
		fontSize: 13,
		lineHeight: 1.2,
		textTransform: 'uppercase',
		borderRadius: 5,
		opacity: 1,
		padding: '2px 7px',
		position: 'absolute',
		top: 5,
		right: 0
	},
	productTagCurrent: {
		background: '#000'
	},
	columnProductIcon: {
		width: '60px',
		marginRight: '10px',
		display: 'flex',
		alignItems: 'center',
		'& img': {
			display: 'block'
		}
	},
	columnProductTitle: {
		width: 'calc(100% - 70px)',
		justifyContent: 'center',
	},
	columnProductTitleSimple: {
		fontSize: 24,
		lineHeight: 1
	},
	productTitle: {
		color: '#000',
		fontSize: '20px',
		fontWeight: 700,
		lineHeight: 1
	},
	productTitleLarge: {
		fontSize: '24px'
	},	
	productTitleUnlimited: {
	},
	productQuantityPerUser:  {
		color: '#000',
		fontSize: '14px',
		opacity: 1
	},
	productPriceInfo: {
		[theme.breakpoints.down('sm')]: {
			width: '100%'
		}		
	},
	productPriceInfoVertical: {
		width: '100%'
	},
	productMembersIncludedInfo: {

	},
	productPriceInfoPending: {
		color: '#000',
		fontSize: '14px',
		opacity: 1,
		margin: '20px 0 37px',
		fontStyle: 'italic'
	},
	productPrice: {
		paddingTop: '10px',
		color: '#000',
		marginBottom: 7,
		fontSize: '32px',
		lineHeight: 1,
		fontWeight: 700,
		'&:before': {
			content: 'attr(data-icon)'
		}
	},
	productMonthLabel: {
		fontSize: '15px',
		fontWeight: 400
	},
	itemsVatLabel: {
		fontSize: '15px',
		fontWeight: 400,
		marginLeft: 5,
		lineHeight: 1,
		whiteSpace: 'nowrap'
	},
	itemsQuantityabel: {
		fontSize: '15px',
		fontWeight: 400,
		marginLeft: 5,
		lineHeight: 1
	},
	productSavedAmount: {
		background: '#FDD8D8',
		marginBottom: '5px',
		color: '#FF4D4D',
		fontSize: '11px',
		lineHeight: '14px',
		padding: '5px',
		opacity: 1
	},

	productPriceBilledAnualy: {
		width: '100%',
		marginBottom: 5,
		fontSize: '14px',
		lineHeight: '1.4',
		opacity: 1,
		color: '#858585'
	},
	productPriceBilledAnualyValue: {
		marginLeft: 5,
		color: '#000'
	},
	columnProductShortDescriptionDesktop: {
		paddingBottom: 20
	},
	productShortDescriptionDesktop: {
		width: '100%',
		fontSize: '14px',
		lineHeight: 1.4,
		color: '#000',
		opacity: 1
	},
	productShortDescriptionCloud: {
		width: '100%',
		fontSize: '14px',
		lineHeight: 1.4,
		color: '#632ACF',
		opacity: 1,
		paddingBottom: 25
	},
	columnProductDescriptionMain: {
	},
	columnProductDescriptionSecondary: {
	},

	/* column description main */
	productDescriptionMainTitle: {
		color: '#000',
		fontSize: '20px',
		lineHeight: 1,
		fontWeight: 700,
		marginBottom: '20px'
	},

	button: {
		padding: '0 15px 1px',
		borderRadius: '21px',
		background: '#000',
		fontSize: '14px',
		lineHeight: '35px',
		fontWeight: 600,
		textTransform: 'uppercase',
		textShadow: 'none',
		'&:hover': {
			backgroundColor: theme.palette.colors.darkPurpleHover
		}
	},

	/* column description secondary */
	purchaseButton: {
		marginTop: '25px',
		marginBottom: '26px',
		minWidth: '200px',
		padding: '7px 15px 8px',
		lineHeight: 1.5,
		whiteSpace: 'wrap',
		[theme.breakpoints.down('md')]: {
			whiteSpace: 'wrap',
			minWidth: 0
		}		
	},

	viewCurrentPlanButtonContainer: {
	},

	viewCurrentPlanButton: {
		width: '100%',
		maxWidth: '200px',
		background: '#fff',
		color: '#000',
		border: '1px solid #000',
		'&:hover': {
			borderColor: theme.palette.colors.darkPurpleHover
		},
		marginTop: '25px',
		marginBottom: '26px',

		'html[lang="de"] &': {
			maxWidth: '230px'
		}
	},

	/* members included info */
	membersIncludedList: {
		padding: '10px 0 0'
	},
	membersIncludedListItem: {
		margin: '0 0 6px',
		padding: 0,
		alignItems: 'flex-start'
	},
	membersIncludedListItemText: {
		padding: 0
	},
	membersIncludedListItemTextItem: {
		fontSize: '14px',
		lineHeight: 1.4,
		color: '#000'		
	},
	membersIncludedListItemIcon:  {
		margin: '2px 5px 0 0',
		'& svg': {
			color: '#000 !important'
		}
	},

	/* features list */
	featuresList: {
	},
	featuresListItem: {
		margin: '0 0 6px',
		padding: 0
	},
	featuresListItemCloudStyle: {
		paddingLeft: 0,
		paddingRight: 0,
		'& svg': {
			color: '#000 !important'
		}
	},
	featuresListItemText: {
		padding: 0
	},
	featuresListItemTextCloudStyle: {
		padding: '0 0 0 6px'
	},
	featuresListItemTextItem: {
		fontSize: '14px',
		lineHeight: 1.4,
		color: '#000'
	},
	featuresListItemTextItemCloudStyle: {
		fontSize: '15px',
		lineHeight: 1.2,
		color: '#000',
		fontWeight: 600
	},
	featuresListItemIcon:  {
		margin: '0 5px 0 0'
	},
	essentialBox: {
		'& svg': {
			color: theme.palette.colors.zeta
		}
	},
	scaleBox: {
		'& svg': {
			color: theme.palette.colors.darkPurple
		},
		'&.isCloudCategory svg': {
			color: theme.palette.colors.zeta
		}
	},
	webBox: {
		'& svg': {
			color: theme.palette.colors.darkPurple
		}
	},
	photoBox: {
		'& svg': {
			color: '#2FE7CE'
		}		
	},
	designerBox: {
		'& svg': {
			color: '#2888C3'
		}		
	},
	featuresListItemIconIncluded: {
	},
	featuresListItemIconExcluded: {
		width: 16,	
		height: 16,
		color: 'red !important'
	},

	planCategoryTag: {
		color: '#632ace',
		padding: '1px 10px',
		margin: '0 0 15px',
		opacity: 1,
		display: 'inline-block',
		fontSize: '15px',
		lineHeight: 1.5,
		background: '#dfd3f4',
		borderRadius: 3
	},

	/* filters */
	periodAndCurrencySelectorContainer: {
		//maxWidth: 1350,
		borderTop: '1px solid #ebebeb',
		paddingTop: 17,
		paddingBottom: 17,
		justifyContent: 'flex-start',
		'&.layoutWithQuantityField': {
			justifyContent: 'space-between',
			'& .periodSelectorColumn': {
				order: 1
			},

			'& .currencySelectorColumn': {
				order: 2
			}
		},
		'&.layoutWithPeriodSelector': {
			[theme.breakpoints.down(theme.breakpoints.values.lg - PERIOD_AND_CURRENCY_SELECTOR_DIFFERENCE)]: {
				display: 'block',
			}
		},
	},
	periodSelectorColumn: {
		marginLeft: 'auto'
	},	
	categorySelector: {
		borderTop: '1px solid #ebebeb',
		paddingTop: 45,
		justifyContent: 'center',
		width: '100%',
		height: 'auto',
		padding: '0',
		marginBottom: '30px',
		'& + .periodAndCurrencySelectorContainer': {
			borderTop: 0
		}
	},
	categorySelectorColumn: {
		padding: '0 10px',
		width: 300
	},
	categorySelectorButton: {
		textDecoration: 'none',
		color: theme.palette.colors.colorWithAlpha(theme.palette.colors.zeta, 0.75),
		'&:hover': {
			textDecoration: 'none'
		},
		marginBottom: 10
	},
	categorySelectorButtonActive: {
		backgroundColor: theme.palette.colors.alpha,
		color: theme.palette.common.white,
		pointerEvents: 'none',
		'&:hover': {
			backgroundColor: theme.palette.colors.alpha,
			color: theme.palette.common.white,
		}
	},
	periodSelector: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		marginBottom: 10,
		marginRight: 15,
		[theme.breakpoints.down(theme.breakpoints.values.lg - PERIOD_AND_CURRENCY_SELECTOR_DIFFERENCE)]: {
			display: 'block',
		}
	},
	periodSelectorLabel: {
		'& span': {
			opacity: 1,
			color: '#000',
			fontSize: 15,
			lineHeight: 1
		}
	},
	periodSelectorLabelChecked: {
		'& span': {
			opacity: 1,
			color: '#2fa5e7',
			fontSize: 15,
			lineHeight: 1,
			'&[class*=MuiFormControlLabel-label]': {
				color: '#000'
			}
		},
	},
	periodSelectorLabelHover: {
		'&:hover span': {
			color: '#2888c3 !important'
		}	
	},
	periodSelectorDiscount: {
		background: '#E1F4FD',
		color: '#2888C3 !important',
		display: 'inline-block',
		padding: 5,
		opacity: 1,
		borderRadius: 5
	},
	radioButton: {
		root: {
			'&$checked': {
				color: '#2FA5E7'
			}
		},
		checked: {},
	},
	currencySelector: {
		border: 'none',
		boxShadow: 'none',
		position: 'relative',
		top: 0,
		marginBottom: 15	
	},
	currencySelectorSelect: {
		'& [class*=MuiSelect-selectMenu]': {
			fontSize: 15
		}
	},
	currencySelectorSelectItems: {
		'& li': {
			fontSize: 15
		}		
	},
	inline: {
		display: 'inline'
	},
	noMargins: {
		margin: 0
	},
	marginTop20: {
		marginTop: 20
	},
	marginBottom20: {
		marginBottom: 20
	},
	yourCurrentSubscription: {
	},

	/* owned products */
	columnActiveProductName: {
		width: '37.5%',
		paddingRight: '20px',
		[theme.breakpoints.down('sm')]: {
			width: '100%',
			paddingRight: 0
		}		
	},
	columnActiveProductDetails: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		width: '43.5%',
		paddingRight: '20px',
		[theme.breakpoints.down('sm')]: {
			width: '100%',
			paddingRight: 0,
			paddingTop: 10
		}
	},
	columnTextLarger: {
		fontFamily: '"Open Sans Xara", Arial, Helvetica, sans-serif',
		fontSize: 16,
		lineHeight: 1.5,
		fontWeight: 600,
		opacity: 1
	},
	columnTextSmaller: {
		fontFamily: '"Open Sans Xara", Arial, Helvetica, sans-serif',
		fontWeight: 'normal',
		fontSize: 14,
		lineHeight: 1.5,
		opacity: 1
	},
	columnActiveProductDetailsTitle: {
		paddingBottom: 10
	},
	columnActiveProductDetailsQuantity: {
		marginBottom: 10
	},
	columnActiveProductDetailsUsedInfo: {
	},	
	columnActiveProductDetailsBillingDate: {
		marginBottom: 10
	},
	columnActiveProductDetailsCurrentBillingPeriod: {
		marginBottom: 10
	},
	columnActiveProductDetailsSubscriptionRenewalDate:  {
		maxWidth: 323,
		borderTop: '1px solid #ebebeb',
		paddingTop: 15,
		marginTop: 4
	},
	columnActiveProductDetailsCancellationDate: {
		maxWidth: 323,
		color: '#F26600',
		borderTop: '1px solid #ebebeb',
		paddingTop: 15,
		marginTop: 4
	},
	columnActiveProductDetailsRevokeCancellationInfo: {
		maxWidth: 323,
		paddingTop: 7,
	},
	columnActiveProductDetailsSeatsStats: {
		marginBottom: 10
	},
	infoPendingSubscription: {
	},
	infoAccessToProducts: {
	},
	expiredProductsLists: {
		'& li': {
			position: 'relative',
			maxWidth: 300,
			padding: '0 0 0 10px',
			'&:before': {
				content: '""',
				display: 'inline-block',
				width: '3px',
				height: '3px',
				borderRadius: 3,
				background: '#000',
				marginRight: 5,
				position: 'absolute',
				top: 10,
				left: 0
			},
			'& p': {
			}
		}
	},
	columnActiveProductActions: {
		width: '18%',
		display: 'flex',
		[theme.breakpoints.down('sm')]: {
			width: '100%',
			paddingTop: 0,
			paddingRight: 0
		}		
	},
	columnActiveProductActionsList: {
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'column',
		'& li':  {
			padding: 0
		}
	},
	columnActiveProductActionsListItem: {
		marginTop: 10,
		'&:last-child': {
			marginBottom: 10
		}
	},
	activeProductActionLink: {
		fontSize: 16,
		lineHeight: 1.5,		
		textDecoration: 'underline',
		textAlign: 'left',
		'&:hover': {
			color: '#2888C3'
		}
	},
	upgradeLink: {
	},
	contactUsLink: {
	},
	viewDetailsAndManageLink: {
	},
	buyMoreSeatsLink: {
	},
	buyMoreSeatsLinkDisabled: {
		color: 'rgba(0, 0, 0, 0.87)',
		textDecoration: 'none',
		'&:hover': {
			color: 'rgba(0, 0, 0, 0.87)',
			textDecoration: 'none',
			cursor: 'default'
		}		
	},
	buyMoreLicenses: {
	},
	italic: {
		fontStyle: 'italic'
	},
	underlined: {
		borderBottom: '1px solid'
	},
	moreInfo: {
		display: 'inline-flex',
		cursor: 'pointer',
		'& svg': {
			marginTop: -2
		}
	},
	haveQuestionContainer: {
		paddingTop: 20
	},
	haveQuestionsMessage: {
	},
	haveQuestionsLink: {
		fontSize: 'inherit',
		'&:hover': {
			color: '#2888C3'
		}		
	},

	productCTASwitchOrReactivate: {
		background: '#CDEFFF',
		justifyContent: 'center',
		padding: '7px 20px',
		width: 'calc(100% + 50px)',
		margin: '13px -25px 0'
	},

	switchOrReactivateLink: {
		fontSize: 14,
		color: '#2E3F4F',
		opacity: 1,
		'&:hover': {
			color: '#2888C3'
		}
	},

	/* promo code / discount banner */
	promoFormAndDiscountBannerContainer: {
		//maxWidth: 1350,
		paddingBottom: 45,
		justifyContent: 'space-between',
		[theme.breakpoints.down(theme.breakpoints.values.lg - BREAKPOINT_1100_DIFFERENCE)]: {
			flexDirection: 'column'
		}
	},

	/* promo code form */
	columnPromoForm: {
		width: '55%',
		[theme.breakpoints.down(theme.breakpoints.values.lg - BREAKPOINT_1100_DIFFERENCE)]: {
			width: '100%',
			marginBottom: '30px'
		}
	},

	/* tooltip */
	arrow: {
		position: 'absolute',
		fontSize: 6,
		width: '3em',
		height: '1em',
		bottom: 0,
		left: '50%',
		transform: 'translateX(-50%)',
		marginBottom: '-0.95em',
		'&::before': {
			content: '""',
			margin: 'auto',
			display: 'block',
			width: 0,
			height: 0,
			borderStyle: 'solid',
			borderWidth: '1em 1em 0 1em',
			borderColor: `${theme.palette.common.black} transparent transparent transparent`,
		}
	},
	infoTooltip: {
		padding: 7,
		backgroundColor: theme.palette.common.black
	},
	infoTooltipText: {
		color: theme.palette.common.white,
		opacity: 1
	},
	infoIcon: {
		width: 15,
		height: 15,
		color: '#6F99BD',
		border: '1px solid #6F99BD',
		padding: 0,
		marginLeft: 10
	},
	infoIconQuantityField: {
		position: 'relative',
		top: 12
	},

	/* discount banner */
	columnDiscountBanner: {
		width: '40%',
		alignItems: 'center',

		[theme.breakpoints.down('md')]: {
			width: '45%'
		},
		[theme.breakpoints.down(theme.breakpoints.values.lg - BREAKPOINT_1100_DIFFERENCE)]: {
			width: '100%'
		}
	},
	discountBannerContainer: {
		flexWrap: 'nowrap',
		justifyContent: 'flex-end',
		[theme.breakpoints.down(theme.breakpoints.values.lg - BREAKPOINT_1100_DIFFERENCE)]: {
			justifyContent: 'center',
		}		
	},
	discountBannerQuestionColumn: {
	},
	discountBannerQuestion: {
		color: '#000',
		fontSize: 15,
		lineHeight: 1.2,
		opacity: 1,
		[theme.breakpoints.down(theme.breakpoints.values.lg - BREAKPOINT_1100_DIFFERENCE)]: {
			textAlign: 'center',
		}
	},
	discountBannerVoucherIconColumn: {
		padding: '0 10px 0 0',
		[theme.breakpoints.down('sm')]: {
			padding: '0 0 10px'
		}		
	},
	discountBannerVoucherIcon: {
		position: 'relative',
		top: '2px'
	},
	discountBannerDiscountAppliedColumn: {
		[theme.breakpoints.down('sm')]: {
			width: 'auto',
			textAlign: 'center',
			paddingLeft: '10px',
			paddingRight: '10px'
		}				
	},
	discountBannerDiscountApplied: {
		fontSize: 15,
		color: '#000',
		lineHeight: 1.2,
		opacity: 1,
		fontWeight: 600,
		fontFamily: 'Lato, "Open Sans Xara", Arial, Helvetica, sans-serif'		
	},
	
	discountBannerGetDiscountButtonColumn: {
		padding: '0 0 0 10px'
	},
	
	discountBannerTryAnotherSerialButtonColumn: {
		padding: '0 0 0 20px',
		textAlign: 'right',
		[theme.breakpoints.down('sm')]: {
			padding: '10px 0 0',
			textAlign: 'center'
		}			
	},
	discountBannerTryAnotherSerial: {
		fontSize: '11px'
	},	
	discountBannerLink: {
		fontSize: 14,
		color: '#000',
		lineHeight: 1.2,
		opacity: 1,
		fontWeight: 600,
		fontFamily: 'Lato, "Open Sans Xara", Arial, Helvetica, sans-serif',
		textTransform: 'uppercase'
	},

	/* see all products */
	seeAllProductsLink: {
		color: '#000',
		textTransform: 'uppercase',
		marginRight: 'auto',
		marginLeft: 18,
		alignSelf: 'flex-start',
		opacity: 1
	},
	/* main tabs at top */
	subscriptionViewSelector: {
		paddingTop: 25,
		paddingBottom: 45
	},
	subscriptionViewSelectorColumn: {
	},
	subscriptionViewSelectorLink: {
		position: 'relative',
		fontSize: 15,
		color: '#000',
		lineHeight: 1.2,
		opacity: 1,
		fontWeight: 600,
		fontFamily: 'Lato, "Open Sans Xara", Arial, Helvetica, sans-serif',
		padding: '0 19px 7px',
		display: 'inline-block',
		transition: 'color 0.2s',
		letterSpacing: 0,
		'&:hover': {
			color: theme.palette.colors.alpha
		}		
	},
	subscriptionViewSelectorLinkActive: {
		color: theme.palette.colors.alpha,
		'&:after': {
			position: 'absolute',
			display: 'block',
			content: '""',
			width: '100%',
			height: 2,
			bottom: 0,
			left: 0,
			background: theme.palette.colors.alpha
		}		
	},
	purchaseOptionsWrapper: {
		maxWidth: 1350,
		'& > .planBoxesWrapper:first-child': {
			'& > div:first-child': {
				paddingTop: 0,
				borderTop: 0
			}
		}
	},
	planBoxesWrapper: {
	},

	quantitySelectorColumn: {
		'& + .periodSelectorColumn': {
			order: 0,
			[theme.breakpoints.down(theme.breakpoints.values.lg - PERIOD_AND_CURRENCY_SELECTOR_DIFFERENCE)]: {
				marginLeft: 0
			}
		}
	},

	currencySelectorColumn: {
		[theme.breakpoints.down(theme.breakpoints.values.lg - PERIOD_AND_CURRENCY_SELECTOR_DIFFERENCE)]: {
			maxWidth: 200
		}
	},

	noProductsFound: {
		color: theme.palette.common.black,
		opacity: 1
	},

	/* Accepted payment methods */
	acceptedPaymentMethodsContainer:  {
		justifyContent: 'center',
		padding: '40px 0 20px'
	},
	acceptedPaymentMethods: {
		padding: '0 0 0 16px',
		color: '#000',
		fontSize: 15,
		lineHeight: 1.2,
		fontWeight: 600,
		opacity: 1
	},
	acceptedPaymentMethodsIcon: {
		height: '16px',
		position: 'relative',
		top: 3,
		margin: '0 0 0 20px'
	},
	/* Accordion */
	packageDetailsAccordion: {
		background: 'none',
		margin: '0 0 18px !important',
		boxShadow: 'none',
		border: 0,
		'&::before': {
			display: 'none'
		},
		'&.packageDetailsHighlighted': {
			'& .accordionTitle': {
				textTransform: 'uppercase',
				color: theme.palette.colors.darkPurpleHover
			},
			'& .expandAccordionIcon': {
				color: theme.palette.colors.darkPurpleHover
			}
		},
		'&.packageDetailsHasTag': {
			'& .accordionTitle': {
			}
		}
	},
	packageDetailsAccordionSummary: {
		padding: 0,
		margin: 0,
		minHeight: 0,
		'&.packageDetailsAccordionSummaryExpanded': {
			minHeight: 0
		},
		'& > div:first-child': {
			margin: 0,
		},
		'&:hover h2': {
		},
		'&:hover .expandAccordionIcon': {
		}
	},
	packageDetailsAccordionDetails: {
		padding: '10px 0 0'
	},
	packageDetailsAccordionContent: {
		padding: '0 0 0 26px',
		opacity: 1,
		color: '#000',
		'& span': {
			display: 'block',
			'&:not(:last-child)': {
				marginBottom: 6
			}
		}
	},
	packageDetailsAccordionExpanded: {
		'& .expandAccordionIcon': {
			transform: 'translateY(-50%) rotate(-180deg)'
		}
	},
	columnAccordionToggleIcon: {
		position: 'relative',
		flex: '0 0 20px'
	},
	columnAccordionToggleTitle: {
		paddingLeft: 6,
		flex: '1 1 calc(100% - 20px)',
		position: 'relative'
	},
	accordionTitle: {
		fontSize: 15,
		lineHeight: 1.2,
		fontWeight: 600,
		opacity: 1,
		color: '#000',
		'&:after': {
			content: '""',
			clear: 'both',
			display: 'table'
		}		
	},
	expandAccordionIcon: {
		'position': 'absolute',
		'top': '50%',
		transform: 'translateY(-50%) rotate(0deg)',
		'left': 0,
		transition: 'transform 0.2s'
	},
	packageDetailsTag:  {
		fontFamily: '"Open Sans Xara", Arial, Helvetica, sans-serif',
		fontWeight: 'normal',
		background: '#F4F4F4',
		color: '#616161',
		fontSize: 15,
		lineHeight: 1.2,
		borderRadius: 5,
		opacity: 1,
		padding: '1px 4px',
		marginLeft: 10,
		float: 'right',
		'html[lang="de"] &': {
			maxWidth: 120,
			textAlign: 'center'
		}
	},
	columnPackageDetailsSectionTitle: {
		position: 'relative'
	},
	packageDetailsSectionTitle: {
		color: theme.palette.colors.darkPurpleHover,
		textTransform: 'uppercase',
		fontWeight: 600,
		fontSize: 15,
		lineHeight: 1.2,
		marginBottom: '17px',
		'&:after': {
			content: '""',
			clear: 'both',
			display: 'table'
		}
	},
	packageDetailsSectionContent: {
		padding: '0 0 0 26px',
		margin: '-10px 0 20px 0',
		opacity: 1,
		color: '#000'
	},
	/* addons */
	addonsWrapper: {
		borderTop: '1px solid #ebebeb',
		marginTop: 40,
		paddingTop: 35
	},
	addonsTitleGrid: {
		paddingBottom: 30
	},
	addonsTitle: {
		fontFamily: 'Lato, "Open Sans Xara", Arial, Helvetica, sans-serif'		,
		fontSize: 24,
		lineHeight: 1.2,
		fontWeight: 700
	},
	addonContainer: {
		justifyContent: 'space-between',
		borderRadius: 20,
		boxShadow: '0px 0px 10px 1px rgba(0, 0, 0, 0.10);',
		padding: 25,
		marginBottom: 15,
		'&:last-child': {
			marginBottom: 0
		},
		'&.addonContainer-ai': {
			'& img': {
				width: 50
			}
		},
		[theme.breakpoints.down('sm')]: {
			display: 'block'
		}
	},
	addonTitleAndDescriptionColumn: {
		flex: '0 0 calc(33% - 18px)',
		[theme.breakpoints.down('sm')]: {
			paddingBottom: 20
		}
	},
	addonIconAndTitle: {
		marginBottom: 20
	},
	addonIconColumn: {
		width: 55,
		marginRight: '15px',
		display: 'flex',
		alignItems: 'center',
		'& img': {
			display: 'block',
			width: '100%'
		}		
	},
	addonTitleColumn: {
		width: 'calc(100% - 70px)',
		justifyContent: 'center',		
	},
	addonTitle: {
		fontFamily: 'Lato, "Open Sans Xara", Arial, Helvetica, sans-serif'		,
		fontSize: 20,
		lineHeight: 1.2,
		fontWeight: 700
	},
	addonTag: {
		background: '#F4F4F4',
		color: '#616161',
		fontSize: 15,
		lineHeight: 1.2,
		borderRadius: 5,
		opacity: 1,
		padding: '2px 4px',
		display: 'inline-block',
		marginBottom: 20
	},
	addonDescription: {
		fontSize: 15,
		lineHeight: 1.2,
		opacity: 1,
		color: '#2888C3',
		marginBottom: 15
	},
	addonDetails: {
		fontSize: 15,
		lineHeight: 1.2,
		opacity: 1,
		color: '#000'
	},
	addonDetailsListColumn: {
		flex: '0 0 calc(33% - 18px)',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		[theme.breakpoints.down('sm')]: {
			paddingBottom: 20
		}
	},
	addonDetailsList: {
	},
	addonDetailsListItem: {
		margin: '0 0 12px',
		padding: 0
	},
	addonDetailsListItemIcon: {
		margin: '0 10px 0 0',
		'& svg': {
			color: '#2888C3'
		}
	},
	addonDetailsListItemIconIncluded: {
	},
	addonDetailsListItemText: {
		padding: 0
	},
	addonDetailsListItemTextItem: {
		fontSize: '14px',
		lineHeight: 1.4,
		color: '#000'		
	},
	addonFeaturesNote: {
		fontSize: '12px',
		lineHeight: 1.2,
		color: '#000'				
	},
	addonActionsColumn: {
		flex: '0 0 calc(33% - 18px)',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center'
	},
	addonButtonContainer: {
	},
	addonButton: {
		minWidth: '200px',
		padding: '7px 15px 8px',
		lineHeight: 1.5,
		whiteSpace: 'wrap',
		[theme.breakpoints.down('md')]: {
			whiteSpace: 'wrap',
			minWidth: 0
		}		
	}
});

@withStyles(styles)
class Subscription extends Component {

	constructor(props) {
		super(props);

		this.updateDimensionsThrottled = _.throttle(this.updateDimensions.bind(this), 500);

		this.getSubscriptionEstimationDebounced = _.debounce(this.props.getSubscriptionEstimation, 350);

		Object.values(SUBSCRIPTION_PLAN).forEach(plan => {
			this[`${plan.toLowerCase()}ProductPriceInfoRef`] = React.createRef();
			this[`${plan.toLowerCase()}ProductShortDescriptionDesktopRef`] = React.createRef();
			this[`${plan.toLowerCase()}ProductShortDescriptionCloudRef`] = React.createRef();
		});
		this['productsListVerticalRef'] = React.createRef();

		const { email } = parseQuery(props.location.search);
		const { match: { params: { planId } } } = props;
		
		this.buyMoreSeatsCallback = this.buyMoreSeatsCallback.bind(this);
		this.reactivateMySubscriptionHandler = this.reactivateMySubscriptionHandler.bind(this);
		this.showSubscriptionDetails = this.showSubscriptionDetails.bind(this);
		this.calculateCheckoutData = this.calculateCheckoutData.bind(this);
		this.fetchSubscriptionEstimate = this.fetchSubscriptionEstimate.bind(this);
		this.getSubscriptionEstimationUrl = this.getSubscriptionEstimationUrl.bind(this);
		this.renderCurrencySelector = this.renderCurrencySelector.bind(this);
		this.handleCurrencyChange = this.handleCurrencyChange.bind(this);
		this.renderInfoTooltip = this.renderInfoTooltip.bind(this);
		this.getDiscountPrice = this.getDiscountPrice.bind(this);
		this.getDefaultQuantity = this.getDefaultQuantity.bind(this);
		this.getQuantityInputValue = this.getQuantityInputValue.bind(this);
		this.doCheckout = this.doCheckout.bind(this);
		this.changeRoute = this.changeRoute.bind(this);
		this.handleSwitchToPlansFromBuyMoreLicensesPopup = this.handleSwitchToPlansFromBuyMoreLicensesPopup.bind(this);
		this.routeToOneTimeCheckBoxAndShowDiscountPopup = this.routeToOneTimeCheckBoxAndShowDiscountPopup.bind(this);
		this.contactUsHandler = this.contactUsHandler.bind(this);
		this.shouldShowAppliedDiscountForCurrentPackage = this.shouldShowAppliedDiscountForCurrentPackage.bind(this);
		this.getQualifyingProductsForCoupon = this.getQualifyingProductsForCoupon.bind(this);
		this.getNumberOfQualifyingProductsForCoupon = this.getNumberOfQualifyingProductsForCoupon.bind(this);
		this.clearInvalidFieldsForBuyMorePopup = this.clearInvalidFieldsForBuyMorePopup.bind(this);
		this.addVersionToTitle = this.addVersionToTitle.bind(this);
		this.handleBuyRequest = this.handleBuyRequest.bind(this);
		this.getVatLabel = this.getVatLabel.bind(this);

		const stateFromProps = this.getStateFromProps(props); 
		const cbPlanIdAfterRedirect = _.get(this.props, 'location.state.cbPlanIdAfterRedirect');

		this.state = {
			accordion: {},
			...stateFromProps,
			willProceedToCheckout: false,
			redirectRoute: null,
			mobilePackageList: false,
			// [P9052-10176] The app will fill in add member input after upgrade to Team by this email into.
			email,
			hideDiscountBannerForeverChecked: false
		};

		if ([planId, cbPlanIdAfterRedirect].includes(STANDARD_OVERVIEW_PLAN_ID)) {
			trackVisitedStandardOverview(getTrackingOptions(this.props.company));
		}

		if ([planId, cbPlanIdAfterRedirect].includes(REAL_ESTATE_OVERVIEW_PLAN_ID)) {
			trackVisitedRealEstateOverview(getTrackingOptions(this.props.company));
		}

		let blockRedirectOnReRoute = true;
		if (planId) {
			const { plan } = convertPlanIdIntoSubscription(planId || cbPlanIdAfterRedirect);

			if (SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT === plan && filterNonGuestUsers(this.props.company.users).length > 1) {
				// block direct checkout link link to individual plan when admins + members > 1 
				// cap_url/#6925641cfbc87de97a5d5683/?chargebee-plan-id=individual_agent-monthly-usd
				blockRedirectOnReRoute = true;
			} else if ([SUBSCRIPTION_PLAN.BROKERAGES, SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT].includes(plan)) {
				blockRedirectOnReRoute = false;
			}
		}
		
		if (this.props.isCBPlanExternalRedirect &&
			showNewRealEstateUI(this.props.company, this.props.app.isDesktopTrial, this.props.app.isReAccessNoIndustry) &&
			blockRedirectOnReRoute) {
			this.state.shouldStartUpdate = false;
			
		} else {
			this.state.shouldStartUpdate = (planId || cbPlanIdAfterRedirect) &&
				this.shouldStartSubscriptionUpgrade(planId || cbPlanIdAfterRedirect);
		}

		if (planId && !cbPlanIdAfterRedirect) {
			// happens on both initial purchase AND upgrade but only when following link to CAP in format:
			// localhost:3000/#62c59dcd465cc44ca33f04e0/?chargebee-plan-id=teamplus-annual-usd

			if (this.state.shouldStartUpdate) {
				// this path happens also for initial purchase not just upgrade
				let { plan, period, currency } = convertPlanIdIntoSubscription(planId || cbPlanIdAfterRedirect);
				!this.hasPlan && this.props.showPreloader();

				const { subscription: pastSubscription } = getSubscriptionsAndAddons(this.props.company, true);
				if (!_.isEmpty(pastSubscription)) {
					({ currency } = convertPlanIdIntoSubscription(pastSubscription.planId));
				}

				const { freeSeatsIncluded, isPerpetual } = PACKAGES_CONFIG[plan];
				
				/*
				use freeSeatsIncluded for quantity for direct link
				to avoid THE_NUMBER_OF_THE_USERS_CANNOT_BE_LESS_THAN_THE_NUMBER_OF_USERS_OF_COMPANY error
				or quantity from url params 
				*/
				let useQuantity = Math.max(freeSeatsIncluded, this.props.productQuantity || 1);

				trackClickSubscriptionUpgrade(plan, period, isPerpetual, getTrackingOptions(this.props.company));

				const nonGuestUsers = filterNonGuestUsers(this.props.company.users);
				
				if (!this.props.currentPlanId &&
					showNewRealEstateUI(this.props.company, this.props.app.isDesktopTrial, this.props.app.isReAccessNoIndustry) &&
					nonGuestUsers.length > useQuantity) {
					// For real estate company, avoid triggering showModalInReduceUsersApiWorkflow after
					// THE_NUMBER_OF_THE_USERS_CANNOT_BE_LESS_THAN_THE_NUMBER_OF_USERS_OF_COMPANY error,
					// instead force to checkout with all filterNonGuestUsers().length
					useQuantity = nonGuestUsers.length;
				}
				
				this.proceedChargeBeeSubscription(
				plan,
				period,
				currency,
				!!this.activePlan,
				this.getCouponSetId(period, plan),
				this.props.couponId,
				useQuantity
				);
			}

			// P9052-15958: clear plan id from URL after triggering an upgrade
			props.history.push({
				pathname: getRoute(SUBSCRIPTION, props.company.id),
				state: { cbPlanIdAfterRedirect: planId }
			});

		}
	}

	componentDidMount() {
		if (this.isPlusOverviewMode) {
			trackVisitedPlusOverview(getTrackingOptions(this.props.company));
		} else if (this.isPerpetualOverviewMode) {
			trackVisitedPerpetualOverview(getTrackingOptions(this.props.company));
		}

		const preselectOpenCBDetails = _.get(this.props, 'location.state.preselectOpenCBDetails');
		if (preselectOpenCBDetails) {
			this.props.history.replace({
				pathname: getRoute(SUBSCRIPTION, this.props.company.id),
				state: { preselectOpenCBDetails: null, preselectSubscriptionView: null }
			});
			this.showSubscriptionDetails();
		}

		const preselectSubscriptionView = 
			!showNewRealEstateUI(this.props.company, this.props.app.isDesktopTrial, this.props.app.isReAccessNoIndustry) &&
			_.get(this.props, 'location.state.preselectSubscriptionView');

		if (preselectSubscriptionView) {
			this.props.history.replace({
				pathname: getRoute(SUBSCRIPTION, this.props.company.id),
				state: { preselectSubscriptionView: null }
			});
		}

		if (this.props.reactivateSubscription &&
			!this.props.wasRenewalPopupShown
		) {

			this.props.setSubscriptionView(SUBSCRIPTION_VIEW.CURRENT_PRODUCTS, true);
			if (!this.hasPlan) {
				// if cancellation is pending only show CURRENT_PRODUCTS view without triggering CB widget
				// as CURRENT_PRODUCTS contains text explaining how to cancel cancellation
				this.showSubscriptionDetails();
			}

			this.props.setRenewalPopupWasShown();
			trackVisitedReactivateRouteFromEmail(getTrackingOptions(this.props.company));
		}

		this.updatePendingSubscription();

		if ((!this.props.isCBPlanExternalRedirect ||
			!this.state.shouldStartUpdate ||
			this.props.isCBPlanExternalRedirect &&
			this.state.shouldStartUpdate && this.hasPlan) &&
			// don't fetch estimate when coupon is entered when Buy more perpetual licenses popup 
			// is opened and user proceedes to checkout
			this.props.discount.couponType !== COUPON_TYPE.LICENSES &&
			!this.state.willProceedToCheckout &&
			!this.isPerpetualOverviewMode && 
			!this.isPerpetualPeriodSelected && 
			(
				this.getSubscriptionEstimationUrl() !== this.props.companies.getSubscriptionEstimateUrl ||
				this.props.companies.getSubscriptionEstimateForPlan !== this.getPlanForSubscriptionEstimation() ||
				(!this.props.companies.subscriptionEstimation && !this.props.companies.getSubscriptionEstimateXhrInProgress)
			)
		) {
			this.fetchSubscriptionEstimate(false);
		}			

		
		if (!showNewRealEstateUI(this.props.company, this.props.app.isDesktopTrial, this.props.app.isReAccessNoIndustry)) {
			window.addEventListener('resize', this.updateDimensionsThrottled);
			this.updateDimensionsThrottled();
		}

		this.props.realEstatePlan && saveReUpgradePopupPlan(this.props.realEstatePlan);
	}

	getStateFromProps(props) {
		const { match, currentPlanId, company: { hasTrial, trialDays } } = props;
		const queryParams = parseQuery(props.location.search);
		const currencyFromUrl = match.params.currency || queryParams['currency'];
		let plan;
		let currentPackageCurrency;
		let currency;
		let seatsQuantity;
		let licensesQuantity;
		let category = null;
		let period = null;
		let subscriptionView = null;
		let hasPeriodAutoSet;
		let hasCategoryAutoSet;
		let hasCurrencyAutoSet;
		let hasSeatsQuantityAutoSet;
		let hasLicensesQuantityAutoSet;
		let hasSubscriptionViewAutoSet;
		
		// Get plan details, take into account only subscription as perpetual/addon is not shown
		// in standard CREATIVE_TOOLS/CLOUD_SUITE tabs
		const activeSubscription = convertPlanIdIntoSubscription(currentPlanId);

		if (currentPlanId) {
			plan = activeSubscription.plan;
		}

		// quantity
		if (this.props.productQuantity && !this.isPerpetualOverviewMode) {
			if (plan &&
				showNewRealEstateUI(this.props.company, this.props.app.isDesktopTrial, this.props.app.isReAccessNoIndustry)) {

				if (plan === SUBSCRIPTION_PLAN.BROKERAGES) {
					seatsQuantity = this.props.productQuantity -
					getMembersPaidQuantity(this.props.company) -
					PACKAGES_CONFIG[plan].freeSeatsIncluded;
				} else {
					
					seatsQuantity = this.props.productQuantity - getMembersPaidQuantity(this.props.company);
				}
			} else {
				seatsQuantity = this.props.productQuantity;
			}
		} else {
			seatsQuantity = this.getDefaultQuantity(
				props,
				QUANTITY_TYPE.SEATS,
				showNewRealEstateUI(this.props.company, this.props.app.isDesktopTrial, this.props.app.isReAccessNoIndustry)
			);
		}

		if (!plan &&
			FORCE_RE_CHECKOUT_WITH_ALL_USERS &&
			showNewRealEstateUI(this.props.company, this.props.app.isDesktopTrial, this.props.app.isReAccessNoIndustry)) {
			// for RE packages don't allow checkout with less users than members + admin length
			const nonGuestUsers = filterNonGuestUsers(props.company.users).length;
			if (seatsQuantity < nonGuestUsers && nonGuestUsers > 1) {
				seatsQuantity = nonGuestUsers;
			}
		}

		hasSeatsQuantityAutoSet = true;

		licensesQuantity = this.props.productQuantity && this.isPerpetualOverviewMode
			?
			this.props.productQuantity
			:
			this.getDefaultQuantity(props, QUANTITY_TYPE.LICENSES);
		hasLicensesQuantityAutoSet = true;

		// currency
		const alreadyUsedCurrency = getCurrencyUsedInCB(props.company);
		alreadyUsedCurrency && (currentPackageCurrency = alreadyUsedCurrency);

		// read curreny from URL, use it from existing plan or default to USD
		currency = currentPackageCurrency || currencyFromUrl || DEFAULT_SUBSCRIPTION.currency;
		hasCurrencyAutoSet = true;

		// subscriptionView
		subscriptionView = SUBSCRIPTION_VIEW.PURCHASE_OPTIONS;

		let seatsQuantityFinal;
		if (!props.app.isSeatsQuantityAutoApplied) {
			seatsQuantityFinal = props.app.seatsQuantity !== null ? props.app.seatsQuantity : seatsQuantity;
		} else if (hasSeatsQuantityAutoSet) {
			seatsQuantityFinal = seatsQuantity;
		}

		let licensesQuantityFinal;
		if (!props.app.isLicensesQuantityAutoApplied) {
			licensesQuantityFinal = props.app.licensesQuantity !== null ? props.app.licensesQuantity : licensesQuantity;
		} else if (hasLicensesQuantityAutoSet) {
			licensesQuantityFinal = licensesQuantity;
		}

		if (this.state) {
			const plansToRender = this.getPlansToRender(
				false,
				true,
				false,
				parseInt(
					this.isPerpetualOverviewMode || props.app.subscriptionPeriod === SUBSCRIPTION_PERIOD.PERPETUAL
						?
						licensesQuantityFinal
						:
						seatsQuantityFinal					
				));
	
			let preselectCategory;
			let preselectPeriod;

			if (this.state.pendingRouteChange) {
				preselectCategory = _.get(props, 'location.state.preselectCategory');
				hasCategoryAutoSet = true;
			}

			if (this.state.pendingUpgradePlanClicked) {
				preselectCategory = _.get(this.props, 'location.state.preselectCategory') || props.app.subscriptionCategory;
				hasCategoryAutoSet = true;
			} 
			if (this.state.pendingShowMagixDiscountForPerpetualClicked) {
				preselectPeriod = props.app.subscriptionPeriod;
				hasPeriodAutoSet = true;
			}

			if (this.state.pendingReactivatePlanId || this.state.pendingSeeAllProductsPlanClicked) {
				preselectCategory = props.app.subscriptionCategory;
				hasCategoryAutoSet = true;
			}
			if (this.state.pendingReactivatePeriod || this.state.pendingActivatePeriod) {
				preselectPeriod = props.app.subscriptionPeriod;
				hasPeriodAutoSet = true;
			}

			if (preselectCategory) {
				category = preselectCategory;
			} else {
				if (!this.state.isPeriodReset) {
					const { isCouponAppliedToCloud, isCouponAppliedToDesktop } = 
							this.getCategoryOfCoupon(props, plansToRender, currency);

					if (this.areCloudOnlyPlans(plansToRender) ||
						this.shouldRenderCategorySelector && isCouponAppliedToCloud && !isCouponAppliedToDesktop) {
						category = PLAN_CATEGORIES.CLOUD_SUITE;
						hasCategoryAutoSet = true;

					} else if (this.areDesktopOnlyPlans(plansToRender) || 
						this.shouldRenderCategorySelector && isCouponAppliedToDesktop && !isCouponAppliedToCloud) {
						category = PLAN_CATEGORIES.CREATIVE_TOOLS;
						hasCategoryAutoSet = true;
					}

					if ((isCouponAppliedToCloud && isCouponAppliedToDesktop) && !category) {
						// exclude productName and source=pricing
						if (this.props.productName && this.props.app.isDesktopApp || this.props.magixCat) {
							category = 	PLAN_CATEGORIES.CREATIVE_TOOLS;
							hasCategoryAutoSet = true;
						} else {
							if (props.app.subscriptionCategory) {
								// stay at current category
								category = props.app.subscriptionCategory;
								hasCategoryAutoSet = true;
							} else {
								if (this.isPlusOverviewMode || this.isPerpetualOverviewMode) {
									category = PLAN_CATEGORIES.CREATIVE_TOOLS;
								} else {
									if (plan) {
										category = this.getCategoryOfUpgradeOptionForActivePlan(
													activeSubscription.plan,
													activeSubscription.period
										);
									} else {
										category = PLAN_CATEGORIES.CLOUD_SUITE;
									}
								}
										
								hasCategoryAutoSet = true;
							}
						}
					}							
				}

			}

			if (preselectPeriod) {
				period = preselectPeriod;
			} else if (this.shouldRenderPeriodSelector && !this.state.isPeriodReset) {
				const { isCouponAppliedToMonthly, isCouponAppliedToAnnualy, isCouponAppliedToPerpetual } = 
					this.getPeriodOfCoupon(props, plansToRender, currency, category);

				if (props.app.subscriptionPeriod) {
					if (props.app.subscriptionPeriod === SUBSCRIPTION_PERIOD.MONTHLY && isCouponAppliedToMonthly ||
						props.app.subscriptionPeriod === SUBSCRIPTION_PERIOD.ANNUAL && isCouponAppliedToAnnualy ||
						props.app.subscriptionPeriod === SUBSCRIPTION_PERIOD.PERPETUAL && isCouponAppliedToPerpetual) {

						period = props.app.subscriptionPeriod;
						hasPeriodAutoSet = true;							
					}
				} 
				
				if (!period) {
					if (isCouponAppliedToMonthly && isCouponAppliedToAnnualy) {
						period = SUBSCRIPTION_PERIOD.ANNUAL;
						hasPeriodAutoSet = true;
					} else if (isCouponAppliedToMonthly) {
						period = SUBSCRIPTION_PERIOD.MONTHLY;
						hasPeriodAutoSet = true;
					} else if (isCouponAppliedToAnnualy) {
						period = SUBSCRIPTION_PERIOD.ANNUAL;
						hasPeriodAutoSet = true;
					} else if (isCouponAppliedToPerpetual) {
						period = SUBSCRIPTION_PERIOD.PERPETUAL;
						hasPeriodAutoSet = true;
					}
				}
				

			} else if (this.isPerpetualOverviewMode) {
				period = SUBSCRIPTION_PERIOD.PERPETUAL;
				hasPeriodAutoSet = true;
			} else {
				const { activeSubscription } = this.state;
				if (activeSubscription.period === SUBSCRIPTION_PERIOD.MONTHLY 
					&& activeSubscription.plan === SUBSCRIPTION_PLAN.TEAM_PLUS) {
					period = SUBSCRIPTION_PERIOD.ANNUAL;
				} else {
					
					period = activeSubscription.period;
					//period = props.app.subscriptionPeriod || activeSubscription.period;
				}
				hasPeriodAutoSet = true;
			}			
		}
		
		if (!category) {
			if (props.app.isPerpetualApp || this.isPerpetualOverviewMode) {
				category = PLAN_CATEGORIES.CREATIVE_TOOLS;
				hasCategoryAutoSet = true;	
			} else {
				// exclude productName and source=pricing
				if (this.props.productName && this.props.app.isDesktopApp || this.props.magixCat) {
					category = 	PLAN_CATEGORIES.CREATIVE_TOOLS;
					hasCategoryAutoSet = true;
				} else {

					// default
					if (!props.app.isCategoryAutoApplied && props.app.subscriptionCategory) {
						category = props.app.subscriptionCategory;
						hasCategoryAutoSet = false;
					} else {
						// isCategoryAutoApplied === true when clicking on "switch to yearly and save..."
						// or when applying discount
						// default for perpetual-overview and plus-overview

						if (props.app.subscriptionCategory) {
							category = props.app.subscriptionCategory;
						} else if (this.isPlusOverviewMode || this.isPerpetualOverviewMode) {
							category = PLAN_CATEGORIES.CREATIVE_TOOLS;
						} else {
							if (plan) {
								category = this.getCategoryOfUpgradeOptionForActivePlan(
									activeSubscription.plan,
									activeSubscription.period
								);
							} else {
								category = _.get(props, 'location.state.preselectCategory') || PLAN_CATEGORIES.CLOUD_SUITE;
							}
						}

						hasCategoryAutoSet = true;
					}
				}
			}
		}

		// User on subscription opening xara.com/welcome, then opening CAP with specific pcat which does not contain upgrade
		// options for that user. In that case show all upgrade options.
		// For example user on proplus plan opening pcat=web but he can only upgrade to Cloud Team+
		let preselectPackage;
		if (plan && this.preselectedPackage) {
			const isPerpetual = PACKAGES_CONFIG[this.preselectedPackage].isPerpetual;
			if (SUBSCRIPTION_PLAN_UPGRADE_OPTIONS[plan].includes(this.preselectedPackage) || isPerpetual) {
				preselectPackage = this.preselectedPackage;
			}
		} else if (!plan && this.preselectedPackage) {
			preselectPackage = this.preselectedPackage;
		}

		if (preselectPackage === SUBSCRIPTION_PLAN.SCALE) {
			preselectPackage = SUBSCRIPTION_PLAN.TEAM_PLUS;
		}

		if ([SUBSCRIPTION_PLAN.BROKERAGES, SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT].includes(preselectPackage)) {
			preselectPackage = null;
		}

		if (!period) {
			if (showNewRealEstateUI(this.props.company, this.props.app.isDesktopTrial, this.props.app.isReAccessNoIndustry))	{
				period = SUBSCRIPTION_PERIOD.MONTHLY;
				hasPeriodAutoSet = true;	
			} else if (props.app.isPerpetualApp || this.isPerpetualOverviewMode) {
				period = SUBSCRIPTION_PERIOD.PERPETUAL;
				hasPeriodAutoSet = true;
			} else {
				// default
				period = props.app.subscriptionPeriod || SUBSCRIPTION_PERIOD.ANNUAL;
				hasPeriodAutoSet = true;
			}
		}

		let subscriptionViewFinal;
		const preselectSubscriptionView = 
			!showNewRealEstateUI(this.props.company, this.props.app.isDesktopTrial, this.props.app.isReAccessNoIndustry) &&
			_.get(this.props, 'location.state.preselectSubscriptionView');

		if (preselectSubscriptionView) {
			subscriptionViewFinal = preselectSubscriptionView;
			this.props.setSubscriptionView(preselectSubscriptionView, true);
		} else if (!props.app.isSubscriptionViewAutoApplied) {
			// if user clicked on view, use user defined view
			subscriptionViewFinal = props.app.subscriptionView || subscriptionView;
		} else if (hasSubscriptionViewAutoSet) {
			//use auto set view
			subscriptionViewFinal = subscriptionView;
			this.props.setSubscriptionView(subscriptionView, true);
		} else {
			subscriptionViewFinal = SUBSCRIPTION_VIEW.CURRENT_PRODUCTS;
		}

		let categoryFinal;
		if (props.company.hasUnlimitedTeamSubscription) {
			categoryFinal = this.isPlusOverviewMode || this.isPerpetualOverviewMode
				?
				PLAN_CATEGORIES.CREATIVE_TOOLS
				:
				PLAN_CATEGORIES.CLOUD_SUITE;

		} else if (!props.app.isCategoryAutoApplied) {
			// if user clicked on category, use user defined category
			categoryFinal = props.app.subscriptionCategory || category;
		} else if (hasCategoryAutoSet) {
			//use auto set category
			categoryFinal = category;
			this.props.setSubscriptionCategory(category, true);
		}

		let isPeriodReset = false;
		if (categoryFinal === PLAN_CATEGORIES.CLOUD_SUITE &&
			this.state && this.isPerpetualPeriodSelected && this.shouldRenderCategorySelector
		) {
			// when Desktop tab > One-Time purchase is selected and user clicks on Cloud
			period = _.get(this.allPeriods, '[0]');
			isPeriodReset = true;
		}

		let periodFinal;
		if (isPeriodReset) {
			periodFinal = period;
			this.props.setSubscriptionPeriod(period, true);
			//props.perpetualOverview
		} else if (!props.app.isPeriodAutoApplied) {
			// if user clicked on period, use user defined period
			periodFinal = props.app.subscriptionPeriod || period;
		} else if (hasPeriodAutoSet) {
			//use auto set period
			periodFinal = period;
			this.props.setSubscriptionPeriod(period, true);
		}

		let currencyFinal;
		if (!props.app.isCurrencyAutoApplied) {
			currencyFinal = props.app.subscriptionCurrency || currency;
		} else if (hasCurrencyAutoSet) {
			currencyFinal = currency;
			this.props.setSubscriptionCurrency(currency, true);
		}



		if (this.props.productQuantity && !this.isPerpetualOverviewMode && this.props.app.seatsQuantity === null) {
			this.props.setSeatsQuantity(seatsQuantity, true);
		} else if (props.app.isSeatsQuantityAutoApplied && hasSeatsQuantityAutoSet) {
			this.props.setSeatsQuantity(seatsQuantity, true);
		}
		
		if (this.props.productQuantity && this.isPerpetualOverviewMode && this.props.app.licensesQuantity === null) {
			this.props.setLicensesQuantity(licensesQuantity, true);
		} else if (props.app.isLicensesQuantityAutoApplied && hasLicensesQuantityAutoSet) {
			this.props.setLicensesQuantity(licensesQuantity, true);
		}

		let pendingSubscription, pendingSeatsQuantity;
		if (_.get(props.company, 'settings.pendingSubscription') && 
			props.currentPlanId &&
			_.get(props.company, 'settings.pendingSubscription') !== props.currentPlanId) {
			pendingSubscription = _.get(props.company, 'settings.pendingSubscription');
			pendingSeatsQuantity = _.get(props.company, 'settings.pendingSeatsQuantity');
		}

		let showPromoForm = true;
		if (props.isDiscountTakeoverFromWebsite ||
			props.company.hasUnlimitedTeamSubscription) {
			showPromoForm = false;
		} else if (activeSubscription.plan) {
			if (activeSubscription.plan === SUBSCRIPTION_PLAN.TEAM_PLUS &&
				activeSubscription.period === SUBSCRIPTION_PERIOD.ANNUAL &&
				periodFinal !== SUBSCRIPTION_PERIOD.PERPETUAL &&
				!this.isPerpetualOverviewMode && !props.app.isPerpetualApp) {
				showPromoForm = false;
			}
		}

		let showDiscountBanner = true;
		if (this.props.company.hasUnlimitedTeamSubscription ||
			this.props.isDiscountTakeoverFromWebsite ||
			// eslint-disable-next-line max-len
			_.get(this.props, `settings.cap[${USER_DISCOUNT_BANNER_SETTING_KEY}][${props.company.id}][${FOREVER_HIDDEN_KEY}]`, false) ||
			isDiscountBannerTemporarilyHidden()) {
			// Permanently disable banner
			showDiscountBanner = false;
		} else if (periodFinal === SUBSCRIPTION_PERIOD.PERPETUAL) {
			// Always show banner on perpetual route or when One-Time Purchase checkbox is checked
			showDiscountBanner = true;
		} else if (activeSubscription.plan) {

			const desktopUpgradeOptions = [];
			SUBSCRIPTION_PLAN_UPGRADE_OPTIONS[activeSubscription.plan].forEach(upgradeOptionPlan => {
				if (PACKAGES_CONFIG[upgradeOptionPlan].isDesktopTag &&
					!PACKAGES_CONFIG[upgradeOptionPlan].isCloudTag) {
					desktopUpgradeOptions.push(upgradeOptionPlan);
				}
			});

			if (PACKAGES_CONFIG[activeSubscription.plan].isDesktopTag &&
				!PACKAGES_CONFIG[activeSubscription.plan].isCloudTag &&
				activeSubscription.period === SUBSCRIPTION_PERIOD.MONTHLY) {
				desktopUpgradeOptions.push(activeSubscription.plan);
			}
			
			let isRenderingAnyDesktopPlan;
			if (props.plusOverview) {
				desktopUpgradeOptions.length > 0 && (isRenderingAnyDesktopPlan = true);
			} else if (desktopUpgradeOptions.length && 
				(
					this.state && !this.shouldRenderCategorySelector || 
					this.state && this.shouldRenderCategorySelector && categoryFinal === PLAN_CATEGORIES.CREATIVE_TOOLS ||
					!this.state
				)) {
				isRenderingAnyDesktopPlan = true;
			}

			if (!isRenderingAnyDesktopPlan) {
				showDiscountBanner = false;
			}
		} else {
			// Trial or free plan
			if (categoryFinal === PLAN_CATEGORIES.CLOUD_SUITE ||
				_.get(this.props.company, 'settings.mxDiscountUsed', false)
			) {
				showDiscountBanner = false;
			}			
		}

		const result = {
			isPeriodReset,
			activeSubscription,
			hasTrial,
			trialDays,
			period: periodFinal,
			currency: currencyFinal,
			category: categoryFinal,
			subscriptionView: subscriptionViewFinal,
			preselectPackage,
			isPerpetualApp: props.app.isPerpetualApp,
			seatsQuantity: seatsQuantityFinal,
			licensesQuantity: licensesQuantityFinal,
			pendingUpgradePlanClicked: false,
			pendingSeeAllProductsPlanClicked: false,
			pendingShowMagixDiscountForPerpetualClicked: false,
			pendingRouteChange: false,
			pendingSubscription,
			pendingSeatsQuantity,
			showPromoForm,
			showDiscountBanner
		};

		return result;
	}

	componentDidUpdate(prevProps, prevState) {
		if ((this.props.isCBPlanExternalRedirect || this.props.productName) &&
				showNewRealEstateUI(this.props.company, this.props.app.isDesktopTrial, this.props.app.isReAccessNoIndustry)) {

			window.location.href = getSubscriptionRedirectUrl(REAL_ESTATE_OVERVIEW_PLAN_ID, this.props.selectedCompanyId);
			return; 		
		}

		this.handleUpdateLastPageVisited();
		// take into account that call crs-web might come after initial call to estimation session, 
		// in that case we update prices
		// same thing if user enters different seats quantity to input 
		// field then we ignore previous request to getSubscriptionEstimation and make new request
		const { couponAppliedWithoutValidation } = this.props.discount;
		const isPerpetualCheckbox = this.isPurchaseOptionsView && this.isPerpetualPeriodSelected && !this.isPerpetualOverviewMode;

		if ((
			(!this.props.companies.subscriptionEstimation && !this.props.companies.getSubscriptionEstimateXhrInProgress) ||
				this.getSubscriptionEstimationUrl() !== this.props.companies.getSubscriptionEstimateUrl ||
				this.props.companies.getSubscriptionEstimateForPlan !== this.getPlanForSubscriptionEstimation()) && 
				// don't fetch estimate when coupon is entered on perpetual route;
				// on One-Time checkbox route this.props.discount.couponType will be SEATS
				this.props.discount.couponType !== COUPON_TYPE.LICENSES &&
				!this.state.willProceedToCheckout && // Buy more perpetual licenses popup is opened and user proceedes to checkout
				(
					!this.props.companies.getSubscriptionEstimateErrorId 
					||
					(this.props.companies.getSubscriptionEstimateErrorId === ERROR.OFFLINE || 
						this.props.companies.getSubscriptionEstimateErrorId === ERROR.API_REQUEST_LIMIT_EXCEEDED)
					&& couponAppliedWithoutValidation
				) &&
				!this.isPerpetualOverviewMode &&
				(!this.isPerpetualPeriodSelected || isPerpetualCheckbox) &&
				(!this.props.isCBPlanExternalRedirect ||
				!this.state.shouldStartUpdate ||
				this.props.isCBPlanExternalRedirect && this.state.shouldStartUpdate && !this.hasPlan)
		) {
			this.fetchSubscriptionEstimate(false);
		}

		if (this.hasPlan &&
			!_.get(getSubscriptionsAndAddons(this.props.company), 'subscription.cancellationPending') &&
			!this.props.companies.upcomingInvoiceEstimationXhrInProgress &&
			!this.props.company.hasUnlimitedTeamSubscription &&
			!this.props.companies.upcomingInvoiceEstimation &&

			(
				!this.props.companies.getUpcomingInvoiceErorId 
				||
				(this.props.companies.getUpcomingInvoiceErorId !== ERROR.OFFLINE &&
					this.props.companies.getUpcomingInvoiceErorId !== ERROR.API_REQUEST_LIMIT_EXCEEDED)					
			)
		) {
			this.props.getUpcomingInvoiceEstimate();
		}

		const isUpgradeViaQueryParam = this.hasPlan &&
			(
				this.props.couponId ||
				this.props.app.isUpgradePopup ||
				this.props.isDiscountTakeoverFromWebsite && this.props.magixCat && this.isPlusOverviewMode
			);

		// User opened perpetual route and entered serial/email to get discount,
		// when switching to /subscriptions/ we should send same coupon code to estimationSession but not for active plan
		const isChangeFromPerpetualToSubscriptionWithMagixDiscountApplied = this.hasPlan &&
			this.props.discount.appliedProdTypeOfLastValidCombination === MAXIC_DISCOUNT_PROD_TYPE.PERPETUAL &&
			!this.isPerpetualOverviewMode;

		const shouldRequestActiveAccountData = 
			(isUpgradeViaQueryParam || isChangeFromPerpetualToSubscriptionWithMagixDiscountApplied) &&
			!this.props.modalShown &&
			!this.props.companies.getSubscriptionEstimateActivePlanXhrInProgress &&
			!this.props.companies.subscriptionEstimationActivePlan;

		const isPlanUpgrade = this.props.currentPlanId !== prevProps.currentPlanId && prevProps.currentPlanId !== undefined;

		if (this.hasPlan && (shouldRequestActiveAccountData || isPlanUpgrade)) {
			const { plan, period } = convertPlanIdIntoSubscription(this.props.currentPlanId);
			if (!_.get(this.props.companies, `subscriptionEstimation[${plan}-${period}-${CB_API_FETCH_CURRENCY}].estimation`)) {
				this.fetchSubscriptionEstimate(true, true);
			}
		}		

		if (_.get(this.state, 'pendingShowMagixDiscountForPerpetualClicked')) {
			this.showMagixDiscountPopup(true);
		}

		const reactivatePlanId = _.get(this.state, 'pendingReactivatePlanId');
		const reactivateQuantity = _.get(this.state, 'pendingReactivateQuantity');
		const reactivatePeriod = _.get(this.state, 'pendingReactivatePeriod');

		// wait until client re-fetches data for correct setas quantity and period
		if (reactivatePlanId &&
			this.period === reactivatePeriod &&
			this.state.seatsQuantity === reactivateQuantity &&
			this.props.companies.subscriptionEstimation &&
			!this.props.companies.getSubscriptionEstimateXhrInProgress &&
			this.props.companies.getSubscriptionEstimateForPlan === this.getPlanForSubscriptionEstimation() &&
			this.getSubscriptionEstimationUrl(false, false) === this.props.companies.getSubscriptionEstimateUrl &&

			// wait until changeMagixDiscountProdType() updates redux state to match subscription route
			!(this.props.discount.isDiscountApplied &&
					this.props.discount.discountType === DISCOUNT_TYPE.MAGIX &&
					this.props.discount.appliedProdTypeOfLastValidCombination === MAXIC_DISCOUNT_PROD_TYPE.PERPETUAL)
		) {

			this.setState({
				pendingReactivatePlanId: null,
				pendingReactivateQuantity: null,
				pendingReactivatePeriod: null,
			}, () => {
				let { plan, period } = convertPlanIdIntoSubscription(reactivatePlanId);
				const quantity = this.getQuantityInputValue(QUANTITY_TYPE.SEATS);

				let {
					checkoutPricePerMonth,
					showDiscountForPlan,
					annualPriceTotal,
					errorLoadingSubscriptionEstimationData,
					planIsTaxed
				} = this.calculateCheckoutData(plan, period, false /*isPerpetual*/, quantity);

				this.showConfirmChoiceModal(
						() => this.doCheckout(
							plan,
							period,
							false, // isUpgrade
							showDiscountForPlan, //useDiscount
							false, //isPerpetual
							false //isUserNumberMismatch
						),
						PACKAGES_CONFIG[plan].title,
						plan,
						quantity,
						this.currency,
						this.period,
						checkoutPricePerMonth,
						annualPriceTotal,
						errorLoadingSubscriptionEstimationData,
						planIsTaxed
				);					
			});
		}

		const activatePlanId = _.get(this.state, 'pendingActivatePlanId');
		const activatePeriod = _.get(this.state, 'pendingActivatePeriod');

		if (activatePlanId) {
			const { isPerpetual, freeSeatsIncluded } = PACKAGES_CONFIG[activatePlanId];
			const { pendingRequest, isDiscountApplied } = this.props.discount;
			
			if (
				// wait for couponId to be applied to perpetual product
				(isPerpetual && (!this.props.couponId || this.props.couponId && !pendingRequest && isDiscountApplied))
				|| 
				(
					// wait until client re-fetches data for correct getSubscriptionEstimationUrl
					(!activatePeriod || this.period === activatePeriod) &&
					this.props.companies.subscriptionEstimation &&
					!this.props.companies.getSubscriptionEstimateXhrInProgress &&
					this.props.companies.getSubscriptionEstimateForPlan === this.getPlanForSubscriptionEstimation() &&
					this.getSubscriptionEstimationUrl(false, false) === this.props.companies.getSubscriptionEstimateUrl
				)
			) {
				this.setState({
					pendingActivatePlanId: null,
					pendingActivatePeriod: null
				}, () => {
					const quantity = this.getQuantityInputValue(isPerpetual ? QUANTITY_TYPE.LICENSES : QUANTITY_TYPE.SEATS);
					let {
						checkoutPricePerMonth,
						showDiscountForPlan,
						annualPriceTotal,
						errorLoadingSubscriptionEstimationData,
						planIsTaxed
					} = this.calculateCheckoutData(activatePlanId, this.period, isPerpetual, quantity);

					const displayTitle = this.addVersionToTitle(activatePlanId, PACKAGES_CONFIG[activatePlanId].title);
					
					this.handleBuyRequest(
						activatePlanId,
						this.period,
						this.hasPlan,
						isPerpetual,
						displayTitle,
						showDiscountForPlan,
						quantity,
						freeSeatsIncluded,
						checkoutPricePerMonth,
						annualPriceTotal,
						errorLoadingSubscriptionEstimationData,
						planIsTaxed
					);
				});
			}			
		}

		if (this.props.discount.appliedProdTypeOfLastValidCombination) {
			const isPerpetualMode = this.isPerpetualOverviewMode || this.isPerpetualPeriodSelected || this.isCurrentProductsView;
			if (isPerpetualMode &&
				this.props.discount.appliedProdTypeOfLastValidCombination !== MAXIC_DISCOUNT_PROD_TYPE.PERPETUAL) {
				this.props.changeMagixDiscountProdType(
					MAXIC_DISCOUNT_PROD_TYPE.PERPETUAL,
					this.props.crs.prodCatOfLastValidCombination,
					null,
					true
				);
			} else if (!isPerpetualMode &&
					this.props.discount.appliedProdTypeOfLastValidCombination === MAXIC_DISCOUNT_PROD_TYPE.PERPETUAL) {
				this.props.changeMagixDiscountProdType(
					MAXIC_DISCOUNT_PROD_TYPE.SUBSCRIPTION,
					null,
					this.props.crs.tierOfLastValidCombination,
					// use cached object as it contains data for valid discount which might be rendered on the screen
					// props.crs.areCredentialsValid is related to most recent request which might be invalid and have false false
					_.get(this.props.crs, 'crsResponseCache.valid') && !_.get(this.props.crs, 'crsResponseCache.used_for_sub')
				);
			}
		}

		if (this.props.app.reduceUsersApiState && !prevProps.app.reduceUsersApiState) {
			this.showModalInReduceUsersApiWorkflow();
		}

		if (!showNewRealEstateUI(this.props.company, this.props.app.isDesktopTrial, this.props.app.isReAccessNoIndustry)) {
			this.updateDimensionsThrottled();
		}
	}

	componentWillUnmount() {
		if (showNewRealEstateUI(this.props.company, this.props.app.isDesktopTrial, this.props.app.isReAccessNoIndustry)) {
			const defaultQuantity = this.getDefaultQuantity(this.props, QUANTITY_TYPE.SEATS, true);
			this.props.setSeatsQuantity(defaultQuantity);
		} else {
			window.removeEventListener('resize', this.updateDimensionsThrottled);
		}
	}
	
	componentWillMount() {
		this.handleUpdateLastPageVisited();
	}

	componentWillReceiveProps(nextProps) {
		let werePerpetualAddonsChanged = false;

		const { perpetualAddons: nextPerpetualAddons } = getSubscriptionsAndAddons(nextProps.company);
		const { perpetualAddons } = getSubscriptionsAndAddons(this.props.company);

		if ((nextPerpetualAddons || []).length != (perpetualAddons || []).length) {
			werePerpetualAddonsChanged = true;
		}

		if (this.state.pendingRouteChange ||
			werePerpetualAddonsChanged ||
			this.props.isStandardProductOverview !== nextProps.isStandardProductOverview ||
			this.props.app.wasPerpetualOverviewPageVisited !== nextProps.app.wasPerpetualOverviewPageVisited ||
			this.props.app.wasPlusOverviewPageVisited !== nextProps.app.wasPlusOverviewPageVisited ||
			this.props.productQuantity !== nextProps.productQuantity ||
			this.props.productSource !== nextProps.productSource ||
			this.props.productPeriod !== nextProps.productPeriod ||
			this.props.currentPlanId !== nextProps.currentPlanId ||
			this.props.currency !== nextProps.currency ||
			this.props.app.showAllPackages !== nextProps.app.showAllPackages ||
			this.props.app.isUpgradePopup !== nextProps.app.isUpgradePopup ||
			this.props.app.isCouponIdProvided !== nextProps.app.isCouponIdProvided ||
			this.props.app.isPerpetualApp !== nextProps.app.isPerpetualApp ||
			this.props.app.subscriptionPeriod !== nextProps.app.subscriptionPeriod ||
			this.props.app.subscriptionCategory !== nextProps.app.subscriptionCategory ||
			this.props.app.subscriptionCurrency !== nextProps.app.subscriptionCurrency ||
			this.props.app.seatsQuantity !== nextProps.app.seatsQuantity ||
			this.props.app.licensesQuantity !== nextProps.app.licensesQuantity ||
			this.props.app.subscriptionView !== nextProps.app.subscriptionView ||
			this.props.app.isPeriodAutoApplied !== nextProps.app.isPeriodAutoApplied ||
			this.props.app.isCategoryAutoApplied !== nextProps.app.isCategoryAutoApplied ||
			this.props.app.isSubscriptionViewAutoApplied !== nextProps.app.isSubscriptionViewAutoApplied ||
			this.props.app.isCurrencyAutoApplied !== nextProps.app.isCurrencyAutoApplied ||
			this.props.app.isSeatsQuantityAutoApplied !== nextProps.app.isSeatsQuantityAutoApplied ||
			this.props.app.isLicensesQuantityAutoApplied !== nextProps.app.isLicensesQuantityAutoApplied ||
			!_.isEmpty(nextProps.discount) && this.props.discount.couponConfig !== nextProps.discount.couponConfig ||
			!_.isEmpty(nextProps.discount) && this.props.discount.couponType !== nextProps.discount.couponType) {
				
			this.setState({
				...this.getStateFromProps(nextProps)
			});
		}

		if (nextProps.isCBPlanInternalRedirect &&
			nextProps.app.pendingTriggerCheckout !== true &&
			this.preselectedPackage &&
			// for subscription open Confirm order popup only if period param is send from XC
			(this.props.productPeriod || PACKAGES_CONFIG[this.preselectedPackage].isPerpetual)) {

			let canBeUpgraded;
			if (this.props.company.hasUnlimitedTeamSubscription) {
				canBeUpgraded = false;
			} else if (!this.hasPlan || PACKAGES_CONFIG[this.preselectedPackage].isPerpetual) {
				canBeUpgraded = true;
			} else {
				const plansToRender = this.getPlansToRender(true, true, false);
				const planToActivate = this.preselectedPackage === SUBSCRIPTION_PLAN.SCALE
					? SUBSCRIPTION_PLAN.TEAM_PLUS : this.preselectedPackage;
				const { activeSubscription } = this.state;
		
				if ((this.activePlan !== planToActivate || activeSubscription.period !== this.props.productPeriod) &&
					// don't allow downgrade from annual to monthly
					!(activeSubscription.period === SUBSCRIPTION_PERIOD.ANNUAL &&
						this.props.productPeriod === SUBSCRIPTION_PERIOD.MONTHLY) &&
					plansToRender.includes(planToActivate)) {
					canBeUpgraded = true;
				}
			}

			if (canBeUpgraded) {
				this.props.setPendingTriggerCheckout(true);
				this.setState({
					pendingActivatePlanId: this.preselectedPackage === SUBSCRIPTION_PLAN.SCALE
						? SUBSCRIPTION_PLAN.TEAM_PLUS : this.preselectedPackage,
					pendingActivatePeriod: this.props.productPeriod
				}, () => {
					if (this.props.productPeriod && this.period !== this.props.productPeriod) {
						this.props.setAppStateParams(
							{
								subscriptionPeriod: this.props.productPeriod
							}
						);		
					}
				});
			}
		}

		if (_.get(nextProps, 'location.state.showInvalidQueryPlanIdMessage')) {
			this.props.showPackageDiscontinuedMessage();

			this.props.history.replace({
				pathname: getRoute(SUBSCRIPTION, this.props.company.id),
				state: { showInvalidQueryPlanIdMessage	: null }
			});			
		}

		// close any modals which might be open when industry change (confirm checkout popup etc.)
		// as popup they might not be applicable or relavant any more
		if (this.props.company.industryId !== nextProps.company.industryId &&
			[this.props.company.industryId, nextProps.company.industryId].includes(REAL_ESTATE_INDUSTY_ID)) {
			this.props.hideModal();
		}
	}

	//#region Rendering

	render() {
		const { redirectRoute, email } = this.state;
		const { isAdmin, classes } = this.props;

		if (this.state.pendingReactivatePlanId && (this.isPerpetualOverviewMode || this.isPlusOverviewMode)) {
			// When user clicks on Reactivate plan link while on plus-overview or perpetual-overview route
			return (<Redirect 
				to={{
					pathname: getRoute(SUBSCRIPTION, this.state.selectedId),
					state: { 
						pendingReactivatePlanId: this.state.pendingReactivatePlanId,
						pendingReactivateQuantity: this.state.pendingReactivateQuantity,
						pendingReactivatePeriod: this.state.pendingReactivatePeriod,
					}
				}}			
			/>);
		}

		if (redirectRoute) {
			return <Redirect to={redirectRoute} />;
		}

		// [P9052-10177] Redirect to Users & Permissions to add a member
		if ((this.isEssentialPlan || this.isScalePlan) && email) {
			
			const usersRoute = getRoute(USERS, this.state.selectedId) + `?email=${email}`;
			return <Redirect to={usersRoute} />;
		}

		const renderView = isAdmin
			?
			this.renderAdminView(
				showNewRealEstateUI(this.props.company, this.props.app.isDesktopTrial, this.props.app.isReAccessNoIndustry)
			)
			:
			this.renderMemberView();

		return (
			<CenteredContent>
				<StickyHeader className={classes.stickyHeader}>
					<Header className={classes.header}>{localize('subscription-header')}</Header>
					{isAdmin &&
						!showNewRealEstateUI(
							this.props.company,
							this.props.app.isDesktopTrial,
							this.props.app.isReAccessNoIndustry
						) &&
						this.renderSubscriptionViewSelector()}
				</StickyHeader>
				{renderView}
			</CenteredContent>
		);
	}

	isRealEstateIndustry() {
		return this.props.company.industryId === REAL_ESTATE_INDUSTY_ID;
	}

	renderMemberView() {
		const { classes } = this.props;
		const sendEmailNotificationFn = _.debounce(() =>
			this.props.sendEmailNotification(
				'explicit_upgrade_teamplus',
				localize('subscription-admin-notified')
			), actionButtonDebounceTimeout
		);

		return (
			<Fragment>
				<Typography
					variant='body1'
					className={classes.marginBottom20}
					dangerouslySetInnerHTML={{__html: localize('subscription-not-admin')}}
				/>

				<Button
					onClick={sendEmailNotificationFn}
					variant='contained'
					data-tid='button-notify-team-admin'
					color='primary'
					title={localize('subscription-notify-admin')}
				>
					{localize('subscription-notify-admin')}
				</Button>
			</Fragment>
		);
	}

	renderPromoFormAndDiscountBanner() {
		const { classes } = this.props;
		const { showDiscountBanner, showPromoForm } = this.state;
		const { appliedProdTypeOfLastValidCombination } = this.props.discount;
		
		// qualifying products in current route not in all routes
		const nrOfQualifyingProductsForCoupon = this.getNumberOfQualifyingProductsForCoupon(false, false, false);
		const nrOfQualifyingProductsForCouponInAllCurrencies = this.getNumberOfQualifyingProductsForCoupon(true, false, false);
		const nrOfQualifyingSubscriptions = this.getNumberOfQualifyingProductsForCoupon(true, true, false);
		const nrOfQualifyingPerpetualProducts = this.getNumberOfQualifyingProductsForCoupon(true, false, true);

		return (
			<Grid
				container
				direction="row"
				className={classes.promoFormAndDiscountBannerContainer}>
				<Grid item className={classes.columnPromoForm}>
					{showPromoForm &&
						<PromoForm 
							isPerpetualCheckbox={this.isPerpetualPeriodSelected && !this.isPerpetualOverviewMode}
							contactUsHandler={this.contactUsHandler} 
							addVersionToTitle={this.addVersionToTitle}
							currency={this.currency}
							changeRoute={this.changeRoute}
							getQualifyingProductsForCoupon={this.getQualifyingProductsForCoupon}
							type={
								this.isPerpetualOverviewMode || this.isPerpetualPeriodSelected
									?
									COUPON_TYPE.LICENSES
									:
									COUPON_TYPE.SEATS
							}
							category={this.category}
							appliedProdTypeOfLastValidCombination={appliedProdTypeOfLastValidCombination}
							nrOfQualifyingSubscriptions={nrOfQualifyingSubscriptions}
							nrOfQualifyingPerpetualProducts={nrOfQualifyingPerpetualProducts}
							nrOfQualifyingProductsForCouponInAllCurrencies={nrOfQualifyingProductsForCouponInAllCurrencies}
							nrOfQualifyingProductsForCoupon={nrOfQualifyingProductsForCoupon} />}
				</Grid>
				<Grid item container className={classes.columnDiscountBanner}>
					{showDiscountBanner && this.renderDiscountBanner()}
				</Grid>								
			</Grid>
		);
	}

	renderAdminView(showRealEstateUi) {
		if (showRealEstateUi) {
			const { plan } = convertPlanIdIntoSubscription(this.props.currentPlanId);

			let cancelledPlanId;
			let cancelledSubscription;
			if (!plan) {
				({ subscription: cancelledSubscription } = getSubscriptionsAndAddons(this.props.company, true));
				if (!_.isEmpty(cancelledSubscription)) {
					({ plan: cancelledPlanId } = convertPlanIdIntoSubscription(cancelledSubscription.planId));
				}
			}

			return (
				<Fragment>
					<RealEstatePackages
						isTrial={this.state.hasTrial}
						membersPaidQuantity={getMembersPaidQuantity(this.props.company)}
						nonGuestUsersNumber={filterNonGuestUsers(this.props.company.users).length}
						getVatLabel={this.getVatLabel}
						totalNumberOfSeats={this.getTotalNumberOfSeats()}
						buyMoreSeatsCallback={this.buyMoreSeatsCallback}
						reactivateMySubscriptionHandler={this.reactivateMySubscriptionHandler}
						nextBillingDate={this.getNextBillingDate()}
						pendingCancellationDate={this.getCancellationDate()}
						showSubscriptionDetails={this.showSubscriptionDetails}
						cancelledPlanId={cancelledPlanId}
						cancelledSubscription={cancelledSubscription}
						currentPlanId={plan}
						quantity={this.getQuantityIntegerValue(QUANTITY_TYPE.SEATS)}
						realEstatePlan={this.props.realEstatePlan}
						fetchSubscriptionEstimate={this.fetchSubscriptionEstimate}
						calculateCheckoutData={this.calculateCheckoutData}
						handleBuyRequest={this.handleBuyRequest}
						showErrorPopup={this.props.showErrorPopup}
						symbol={this.currency.symbol}
						shouldRenderCurrencySelector={this.shouldRenderCurrencySelector}
						renderCurrencySelector={this.renderCurrencySelector} />							
				</Fragment>
			);
		} else {
			return this.isCurrentProductsView ? this.renderProductsView() : this.renderPurchaseOptionsView();
		}
	}

	renderPurchaseOptionsView() {
		const { classes } = this.props;
		const { showDiscountBanner, showPromoForm } = this.state;

		return (
			<div className={
				classNames({
					[classes.purchaseOptionsWrapper]: true,
					['purchaseOptionsWrapper']: true					
				}
				)
			}>
				{this.shouldRenderPlanBoxes && 
				(showDiscountBanner || showPromoForm) && 
				this.renderPromoFormAndDiscountBanner()}

				{
					this.shouldRenderPlanBoxes
						? this.renderPlanBoxes()
						: (
							<Typography
								variant='body2'
								className={classes.italic}
								dangerouslySetInnerHTML={{__html: localize('subscription-no-upgrade-options')}}
							/>
						)
				}
			</div>
		);		
	}
	
	renderProductsView() {
		const { classes } = this.props;

		return (
			<Grid container className={classNames(classes.yourCurrentSubscription)}>
				{this.renderCurrentPlans()}
			</Grid>
		);
	}

	toggleDiscountBanner(event) {
		this.setState({
			hideDiscountBannerForeverChecked: event.target.checked
		});
	}

	updateDimensions() {

		const switchToMobilePackageList = () => {

			const currentListRef = this['productsListVerticalRef'];
			if (!currentListRef || !currentListRef.current) return;

			if (this.props.navOpen) {
				if (this.state.mobilePackageList !== false) {
					this.setState({
						mobilePackageList: false
					});					
				}

			} else {
				let nrOfDesktopPlansInContainer = 0;
				let nrOfCloudPlansInContainer = 0;
				Object.values(SUBSCRIPTION_PLAN).forEach(plan => {
					const currentRefDesktop = this[`${plan.toLowerCase()}ProductShortDescriptionDesktopRef`];
					if (currentRefDesktop && currentRefDesktop.current) {
						nrOfDesktopPlansInContainer++;
					}

					const currentRefCloud = this[`${plan.toLowerCase()}ProductShortDescriptionCloudRef`];
					if (currentRefCloud && currentRefCloud.current) {
						nrOfCloudPlansInContainer++;
					}
				});

				let containerWidth = 0;
				

				if (currentListRef.current) {
					const { width } = currentListRef.current.getBoundingClientRect();
					containerWidth = width;
				}

				if ((nrOfDesktopPlansInContainer || nrOfCloudPlansInContainer) > 0 && containerWidth > 0) {
					const approxPlanWidth = Math.round(containerWidth / 
						(nrOfDesktopPlansInContainer || nrOfCloudPlansInContainer));

					const tresholdWidth = nrOfDesktopPlansInContainer > 0
						?
						PACKAGE_COLUMN_WIDTH_TRESHOLD_DESKTOP
						:
						PACKAGE_COLUMN_WIDTH_TRESHOLD_CLOUD;

					const result = approxPlanWidth < tresholdWidth;
					if (this.state.mobilePackageList !== result) {
						this.setState({
							mobilePackageList: result
						});
					}
				}
			}
		};
		
		const setMinHeight = (refPrefix) => {
			let descriptionHeight = 0;
			Object.values(SUBSCRIPTION_PLAN).forEach(plan => {
				const currentRef = this[`${plan.toLowerCase()}${refPrefix}Ref`];

				if (currentRef && currentRef.current) {
					currentRef.current.style.minHeight = 'auto';

					const { height } = currentRef.current.getBoundingClientRect();
					descriptionHeight = Math.max(height, descriptionHeight);
				}
			});

			if (descriptionHeight !== 0) {
				Object.values(SUBSCRIPTION_PLAN).forEach(plan => {
					const currentRef = this[`${`${plan}${refPrefix}Ref`}`];
					if (currentRef && currentRef.current) {
						currentRef.current.style.minHeight = `${descriptionHeight}px`;
					}
				});
			}
		};

		switchToMobilePackageList();

		itemRefPrefix.forEach(refPrefix => {
			setMinHeight(refPrefix);
		});
	}

	closeDiscountBanner() {
		if (this.state.hideDiscountBannerForeverChecked) {
			// hide banner permanently

			const discountBannerSetting = _.get(this.props.settings,
				`${CAP_KEY}.${USER_DISCOUNT_BANNER_SETTING_KEY}`, {});
			const companySettings = discountBannerSetting[this.props.company.id] || {};

			companySettings[FOREVER_HIDDEN_KEY] || (companySettings[FOREVER_HIDDEN_KEY] = true);

			discountBannerSetting[this.props.company.id] = companySettings;

			this.props.writeUserSettings({
				[USER_DISCOUNT_BANNER_SETTING_KEY]: discountBannerSetting
			});
		} else {
			// hide banner temporarily
			saveHideDiscountBannerFlag();
		}
		this.setState({
			showDiscountBanner: false
		});		
	}

	showMagixDiscountPopup(isPerpetualProductType) {

		const modalProps = {
			magixDiscountProdType: isPerpetualProductType || this.isPerpetualOverviewMode || this.isPerpetualPeriodSelected
				?
				MAXIC_DISCOUNT_PROD_TYPE.PERPETUAL
				:
				MAXIC_DISCOUNT_PROD_TYPE.SUBSCRIPTION
		};

		this.props.showModal('DISCOUNT_MODAL', modalProps);
	}

	routeToOneTimeCheckBoxAndShowDiscountPopup() {
		this.setState({
			pendingShowMagixDiscountForPerpetualClicked: true
		}, () => {
			this.clearInvalidFieldsForBuyMorePopup(true);
	
			this.props.setAppStateParams(
				{
					subscriptionView: SUBSCRIPTION_VIEW.PURCHASE_OPTIONS,
					subscriptionPeriod: SUBSCRIPTION_PERIOD.PERPETUAL,
					subscriptionCategory: PLAN_CATEGORIES.CREATIVE_TOOLS
				}
			);		
		});			
	}

	getDiscountPercent() {
		const { discountType, couponSetKey, couponConfig } = this.props.discount;

		if (discountType === DISCOUNT_TYPE.MAGIX || discountType === DISCOUNT_TYPE.COUPON_SET_ID) {
			return DISCOUNTS_CONFIG[couponSetKey].discount;
		} else if (discountType === DISCOUNT_TYPE.COUPON_ID) {
			if (_.get(couponConfig, 'discount_type') === 'percentage') {
				return couponConfig.discount_percentage / 100;
			} else if (_.get(couponConfig, 'discount_type') === 'fixed_amount') {
				return couponConfig.discount_amount / 100;
			}
		}
	}

	getDiscountPrice(currentPrice, plan) {
		const { discountType, couponConfig } = this.props.discount;
		
		if (plan && discountType === DISCOUNT_TYPE.MAGIX) {
			// Calculate price for perpetual from env variables
			const couponTier = _.invert(PERPETAUL_PRODUCT_CATEGORY_TO_PACKAGE_MAP)[plan];
			const discountPerc = DISCOUNTS_CONFIG[`tier_${couponTier}`].discount;
			return parseFloat(discountPerc > 0 && (currentPrice * (1 - discountPerc)).toFixed(2));

		} else if (discountType === DISCOUNT_TYPE.COUPON_SET_ID || discountType === DISCOUNT_TYPE.MAGIX) {
			const discountPerc = this.getDiscountPercent();
			return parseFloat(discountPerc > 0 && (currentPrice * (1 - discountPerc)).toFixed(2));

		} else if (discountType === DISCOUNT_TYPE.COUPON_ID) {
			const discountPerc = this.getDiscountPercent();
			if (_.get(couponConfig, 'discount_type') === 'percentage') {
				// Coupon set it does not provide leading numbers - don't show any discount
				return parseFloat(discountPerc > 0 && (currentPrice * (1 - discountPerc)).toFixed(2));

			} else if (_.get(couponConfig, 'discount_type') === 'fixed_amount') {
				return parseFloat((currentPrice - discountPerc).toFixed(2));
			}
		}
	}

	getDefaultQuantity(props, type, showNewRealEstateUI) {
		const { currentPlanId, company } = props;
		// On /perpetual-overview/ route in quantity box we put
		// - number on members + admins if user has no addons
		// - if user has already purchased any addon we use 1
		// On non-perpetual route default is number of users
		const { perpetualAddons } = getSubscriptionsAndAddons(company);

		const nonGuestUsers = filterNonGuestUsers(company.users);

		if (type === QUANTITY_TYPE.LICENSES) {
			return _.isEmpty(perpetualAddons) ? nonGuestUsers.length : 1;
		} else if (type === QUANTITY_TYPE.SEATS) {

			// Subscription page
			if (showNewRealEstateUI) {
				// if user has plan set additional quantity to 0
				// if there is no plan then set quantity to 0 for single admin user or match team size

				return currentPlanId 
					?
					0
					:
					nonGuestUsers.length === 1
						?
						0
						:
						nonGuestUsers.length;
			} else {
				return this.hasPlan ? 1 : nonGuestUsers.length;
			}

		}
	}

	renderDiscountBanner() {
		const { classes } = this.props;
		const { isDiscountApplied, discountType } = this.props.discount;
		const isMagixDiscountApplied = isDiscountApplied && discountType === DISCOUNT_TYPE.MAGIX;
		const discountPerc = isMagixDiscountApplied && this.getDiscountPercent();

		// eslint-disable-next-line no-unused-vars
		return (
			
			<Grid
				container
				direction="row"
				className={classNames(classes.discountBannerContainer, isMagixDiscountApplied && classes.hasAppliedDiscount)}>
				{
					isMagixDiscountApplied
						?
						(
							<Fragment>
								<Grid item className={classes.discountBannerVoucherIconColumn}>
									<VoucherIcon className={classes.discountBannerVoucherIcon} />
								</Grid>
								<Grid item className={classes.discountBannerDiscountAppliedColumn}>
									<Typography
										variant='body2'
										className={classes.discountBannerDiscountApplied}
									>
										{
											this.isPerpetualOverviewMode || this.isPerpetualPeriodSelected
												? 
												this.props.discount.appliedProdTypeOfLastValidCombination === 
													MAXIC_DISCOUNT_PROD_TYPE.PERPETUAL &&
												_.get(this.props.crs, 'isFallbackProductReturnedLastValidCombination')
													?
													localize('subscription-discount-applied-perpetual-generic')
													:
													localize('subscription-discount-applied-perpetual', discountPerc * 100)
												:
												localize('subscription-discount-applied', discountPerc * 100)
										}
									</Typography>
								</Grid>
								<Grid item className={classes.discountBannerTryAnotherSerialButtonColumn}>
									<Link
										underline='hover'
										data-tid={'button-discount-banner'}
										className={classNames(classes.discountBannerTryAnotherSerial,
											classes.discountBannerLink)}
										onClick={() => this.showMagixDiscountPopup()}
									>
										{localize('subscription-discount-try-another-serial')}
									</Link>								
								</Grid>
							</Fragment>
						)
						:
						(
							<Fragment>
								<Grid item className={classes.discountBannerQuestionColumn}>
									<Typography
										variant='body2'
										className={classes.discountBannerQuestion}
										dangerouslySetInnerHTML={{ __html: localize('subscription-discount-magix') }}
									/>
								</Grid>
								<Grid item className={classes.discountBannerGetDiscountButtonColumn}>
									<Link
										underline='hover'
										data-tid={'button-discount-banner'}
										className={classNames(classes.discountBannerGetDiscountButton,
											classes.discountBannerLink)}
										onClick={() => this.showMagixDiscountPopup()}
									>
										{localize('subscription-discount-get')}
									</Link>					
								</Grid>
							</Fragment>
						)

				}
			</Grid>
		);
	}

	renderPlanBoxes() {
		const { classes } = this.props;

		return (
			<Grid
				container
				className={
					classNames({[classes.planBoxesWrapper]: true, ['planBoxesWrapper']: true })
				}>
				{this.shouldRenderCategorySelector && this.renderCategorySelector()}
				{(this.shouldRenderPeriodSelector || this.shouldRenderCurrencySelector || this.shouldRenderQuantityField) &&
					<Grid
						container
						item
						
						className={
							classNames({
								[classes.periodAndCurrencySelectorContainer]: true,
								['periodAndCurrencySelectorContainer']: true,
								['layoutWithQuantityField']: this.shouldRenderQuantityField,
								['layoutWithPeriodSelector']: this.shouldRenderPeriodSelector
							}
							)
						}
					>
						{this.shouldRenderQuantityField && (
							<Grid
								item
								className={
									classNames({
										[classes.quantitySelectorColumn]: true,
										['quantitySelectorColumn']: true
									})
								}							
							>
								<QuantityField
									category={this.category} 
									isPerpetualOverviewMode={this.isPerpetualOverviewMode}
									quantity={this.getQuantityInputValue(
										this.isPerpetualOverviewMode || this.isPerpetualPeriodSelected
											?
											QUANTITY_TYPE.LICENSES
											:
											QUANTITY_TYPE.SEATS
									)}
									quantityType={
										this.isPerpetualOverviewMode || this.isPerpetualPeriodSelected
											?
											QUANTITY_TYPE.LICENSES
											:
											QUANTITY_TYPE.SEATS
									}
									renderInfoTooltip={this.renderInfoTooltip} 
									enableBulkDiscountTooltip={!this.isPerpetualOverviewMode && !this.isPerpetualPeriodSelected}
								/>
							</Grid>)
						}
						
						{this.shouldRenderPeriodSelector && (
							<Grid
								item
								className={
									classNames({
										[classes.periodSelectorColumn]: true,
										['periodSelectorColumn']: true
									})
								}							
							>
								{this.renderPeriodSelector()}
							</Grid>)
						}
						
						{this.shouldRenderCurrencySelector && (
							<Grid 
								item
								className={
									classNames({
										[classes.currencySelectorColumn]: true,
										['currencySelectorColumn']: true
									}
									)
								}							
							>
								{this.renderCurrencySelector()}
							</Grid>)
						}
					</Grid>
				}
				<Grid container item>
					{this.renderPlans()}
					{this.renderAddons()}
					<Grid container className={classes.acceptedPaymentMethodsContainer}>
						<Typography variant='body2' className={classes.acceptedPaymentMethods}>
							{localize('subscription-payment-methods-accepted')} 
							{
								this.currency && this.currency.key == CURRENCIES.EUR.key
									?
									<WeAcceptEurIcon className={classes.acceptedPaymentMethodsIcon} />
									:
									<WeAcceptIcon className={classes.acceptedPaymentMethodsIcon} />

							}
						</Typography>
					</Grid>
				</Grid>
			</Grid>
		);
	}

	filterPlans(plansToRender, onlySelectedCategory, onlyPreselected, isPerpetualApp, itemsQuantity, period) {
		const results = [];

		const usePeriod = period || this.period;

		plansToRender.forEach(planKey => {
	
			const planId = SUBSCRIPTION_PLAN[planKey] || planKey;
			const { isCloudSuitePlan, isCreativeToolsPlan, isPlusPackage, isPerpetual } = PACKAGES_CONFIG[planId];

			let showPackage = false;

			if (this.isPlusOverviewMode) {
				if (isPlusPackage || isPerpetual) {
					if (isPerpetualApp && this.isPerpetualPeriodSelected) {
						showPackage = isPerpetual;
					} else {
						
						showPackage = this.shouldPreselectPackage && onlyPreselected
							?
							planId === this.state.preselectPackage && !isPerpetual
							:
							!isPerpetual || (isPerpetual && this.hasPlan);
					}
				} else {
					showPackage = false;
				}
			} else if (this.isPerpetualOverviewMode) {
				showPackage = this.shouldPreselectPackage && onlyPreselected
					?
					planId === this.state.preselectPackage
					:
					isPerpetual;

			} else if (usePeriod === SUBSCRIPTION_PERIOD.PERPETUAL) {
				showPackage = !onlySelectedCategory || isPerpetual;
			} else {
				showPackage = this.shouldPreselectPackage && onlyPreselected
					?
					planId === this.state.preselectPackage
					:
					!onlySelectedCategory ||
					(this.isCloudSuiteCategory && isCloudSuitePlan || this.isCreativeToolsCategory && isCreativeToolsPlan 
						&& (isPerpetual && usePeriod === SUBSCRIPTION_PERIOD.PERPETUAL
							|| !isPerpetual && usePeriod !== SUBSCRIPTION_PERIOD.PERPETUAL)
					);
			}

			// eslint-disable-next-line no-unused-vars
			let quantity = itemsQuantity || (isPerpetual ? this.state.licensesQuantity : this.state.seatsQuantity);

			showPackage && results.push(planId);
		});

		return _.uniq(results);
	}

	getPlansToRender(onlySelectedCategory, showMonthlyToYearlyUpgrade, onlyPreselected, itemsQuantity, period) {
		const { activeSubscription, isPerpetualApp } = this.state;
		let plansToRender = [];
		const { perpetualAddons } = getSubscriptionsAndAddons(this.props.company);

		// If user has subscription render only upgrade options
		// Additionaly render perpetual plans if isPerpetualApp or user has purchased perpetual product before,
		// otherwise render all subscriptions

		if (this.isPerpetualOverviewMode) {
			plansToRender.push(
				SUBSCRIPTION_PLAN.PHOTO_PERPETUAL,
				SUBSCRIPTION_PLAN.WEB_PERPETUAL,
				SUBSCRIPTION_PLAN.DESIGNER_PERPETUAL
			);
		} else {
			let subscriptionPlans;

			if (this.hasPlan) {
				subscriptionPlans = this.props.company.hasUnlimitedTeamSubscription
					?
					[]
					:
					// Don't render Enterprise on plus-overview route
					this.isPlusOverviewMode && activeSubscription.plan === SUBSCRIPTION_PLAN.TEAM_PLUS &&
						activeSubscription.period === SUBSCRIPTION_PERIOD.ANNUAL
						?
						[]
						:
						SUBSCRIPTION_PLAN_UPGRADE_OPTIONS[activeSubscription.plan];
			} else {
				subscriptionPlans = Object.keys(_.omit(PACKAGES_CONFIG, SUBSCRIPTION_PLAN.SCALE));
			}

			plansToRender.push(...subscriptionPlans);

			if (!_.isEmpty(perpetualAddons) && !this.props.company.hasUnlimitedTeamSubscription && !this.isPlusOverviewMode) {
				plansToRender.push(
					SUBSCRIPTION_PLAN.PHOTO_PERPETUAL,
					SUBSCRIPTION_PLAN.WEB_PERPETUAL,
					SUBSCRIPTION_PLAN.DESIGNER_PERPETUAL
				);				
			}
		}

		let results = this.filterPlans(
			plansToRender,
			onlySelectedCategory,
			onlyPreselected,
			isPerpetualApp,
			itemsQuantity,
			period
		);

		if (showMonthlyToYearlyUpgrade &&
			activeSubscription &&
			activeSubscription.plan &&
			activeSubscription.period === SUBSCRIPTION_PERIOD.MONTHLY) {
			results.push(activeSubscription.plan);
		}

		return results;
	}
	
	getNumberOfQualifyingProductsForCoupon(accrossAllCurrencies, onlySubscription, onlyPerpetual, limitToPlan) {
		return this.getQualifyingProductsForCoupon(accrossAllCurrencies, onlySubscription, onlyPerpetual, limitToPlan).length;
	}

	getQualifyingProductsForCoupon(accrossAllCurrencies, onlySubscription, onlyPerpetual, limitToPlan) {
		const result = [];
		const { 
			discountType,
			isDiscountApplied,
			couponConfig,
			couponSetKey,
			couponId,
			appliedProdTypeOfLastValidCombination,
			appliedProdCatOfLastValidCombination

		} = this.props.discount;
		const { activeSubscription } = this.state;

		let plansToCheck = [];

		if ((discountType === DISCOUNT_TYPE.COUPON_ID && (onlySubscription || onlyPerpetual)) ||
			(isDiscountApplied &&
			(
				discountType === DISCOUNT_TYPE.COUPON_ID ||
				discountType === DISCOUNT_TYPE.MAGIX ||
				discountType === DISCOUNT_TYPE.COUPON_SET_ID && couponSetKey === DISCOUNT_KEY.UPGRADE_POPUP
			))
		) {

			if ((this.isPerpetualOverviewMode || onlyPerpetual || this.hasPerpetualCheckbox) && !onlySubscription) {

				if (this.shouldPreselectPackage && this.isPerpetualOverviewMode) {
					plansToCheck.push(this.state.preselectPackage);
				} else {
					if (limitToPlan) {
						plansToCheck.push(limitToPlan);
					} else {
						plansToCheck.push(
							SUBSCRIPTION_PLAN.PHOTO_PERPETUAL,
							SUBSCRIPTION_PLAN.WEB_PERPETUAL,
							SUBSCRIPTION_PLAN.DESIGNER_PERPETUAL
						);
					}
				}
			}

			const allUpgradeOptionsPlans = (!this.isPerpetualOverviewMode && !onlyPerpetual || onlySubscription) &&
				this.getPlanIdsForSubscriptionEstimate(this.props.currentPlanId, true, false);

			!_.isEmpty(allUpgradeOptionsPlans) && plansToCheck.push(...allUpgradeOptionsPlans);

			if (!_.isEmpty(plansToCheck)) {

				plansToCheck.forEach(checkPlan => {
					
					const planId = checkPlan.split('-')[0];

					const checkCurrencies = accrossAllCurrencies ? Object.values(CURRENCIES) : [this.currency];
					checkCurrencies.forEach(loopCurrency => {

						if (PACKAGES_CONFIG[planId].isPerpetual) {

							if (this.shouldShowAppliedDiscountForCurrentPackage(
								planId,
								SUBSCRIPTION_PERIOD.PERPETUAL,
								loopCurrency.key,
								couponConfig,
								discountType,
								couponSetKey,
								couponId,
								false,
								appliedProdTypeOfLastValidCombination,
								appliedProdCatOfLastValidCombination)) {
								
								result.push(planId); 

							}	
						} else if (!this.isPerpetualOverviewMode || onlySubscription) {

							const { plan, period } = convertPlanIdIntoSubscription(checkPlan);

							// ?cid=BOOSTMYROI is already excluding desktop+ packages
							// in shouldShowAppliedDiscountForCurrentPackage
							if (this.shouldShowAppliedDiscountForCurrentPackage(
								plan,
								period,
								loopCurrency.key,
								couponConfig,
								discountType,
								couponSetKey,
								couponId,
								false,
								appliedProdTypeOfLastValidCombination,
								appliedProdCatOfLastValidCombination)) {

								if (this.hasPlan && activeSubscription.plan === plan && activeSubscription.period === period) {
									return;
								}
								result.push(plan);
							}					
						}
					});

				});
			}			

		}
		return _.uniq(result);
	}

	renderPlans() {
		const { classes } = this.props;
		const { activeSubscription, period } = this.state;
		let plansToRender = this.getPlansToRender(true, false, true);

		if (!this.isPerpetualOverviewMode && activeSubscription.plan) {
			// If user already has monthly plan and he clicks on annual checkbox,
			// then offer him to upgrade to annual version of existing plan
			const {
				isCloudSuitePlan: isCloudSuitePlanSelected,
				isCreativeToolsPlan: isCreativeToolsPlanSelected
			} = PACKAGES_CONFIG[activeSubscription.plan];

			if (this.isMonthlyPlan && this.isAnnualPeriodSelected && (this.isCloudSuiteCategory && isCloudSuitePlanSelected ||
				this.isCreativeToolsCategory && isCreativeToolsPlanSelected) &&
				!this.shouldPreselectPackage) {
				plansToRender.unshift(activeSubscription.plan);
			}
		}		

		plansToRender.sort((a, b) => PACKAGES_CONFIG[a].order - PACKAGES_CONFIG[b].order);

		// Add current plan to other upgrade options so that user can compare features with other plans
		if (!this.isPlusOverviewMode && !this.isPerpetualOverviewMode && activeSubscription.plan) {
			if (activeSubscription.period === period) {
				if (this.shouldRenderCategorySelector) {
					if (PACKAGES_CONFIG[activeSubscription.plan].isCloudSuitePlan &&
							this.category === PLAN_CATEGORIES.CLOUD_SUITE) {
						plansToRender.unshift('current');
					} else if (PACKAGES_CONFIG[activeSubscription.plan].isCreativeToolsPlan &&
							this.category === PLAN_CATEGORIES.CREATIVE_TOOLS) {
						plansToRender.unshift('current');
					}
				} else {
					plansToRender.unshift('current');
				}
			}
		}

		const resultPlans = plansToRender.map(
			(planId, index) => (<Grid 
				item
				key={`plan-item-${index+1}`}
				className={
					classNames({
						[classes.productVerticalColumn]: true,
						['productVerticalColumn']: true
					})					
				}			
			>
				{this.renderBox(planId)}
			</Grid>));

		return (<div ref={this['productsListVerticalRef']} className={classes.productsListVerticalWrapper}><Grid
			container
			className={
				classNames({
					[classes.productsListVertical]: true,
					['mobilePackageList']: this.state.mobilePackageList,
					[`columns${plansToRender.length}`]: true
				})					
			}>
			{resultPlans.map(item => item)}
			{this.shouldPreselectPackage && this.renderSeeAllProductsLink()}
		</Grid></div>);
	}

	renderAddons() {
		const { classes } = this.props;
		const keys = Object.keys(ADDONS_LIST).map(key => key.toLowerCase());

		const addonsToRender = [];
		keys.forEach(key => {
			if (this.category === PLAN_CATEGORIES.CLOUD_SUITE && ADDONS_CONFIG[key].isCloudAddon ||
				this.category === PLAN_CATEGORIES.CREATIVE_TOOLS && ADDONS_CONFIG[key].isDesktopAddon) {
				addonsToRender.push(key);
			}
		});

		if (_.isEmpty(addonsToRender)) return;

		return (
			<Grid item container className={classes.addonsWrapper} direction="column">
				<Grid item className={classes.addonsTitleGrid}>
					<Typography
						variant='h2'
						className={classes.addonsTitle}>
						{localize('addons-section-title')}
					</Typography>
				</Grid>
				{addonsToRender.map(id => this.renderAddon(id))}
			</Grid>			
		);
	}

	renderAddon(addonId) {
		const { symbol } = this.currency;
		const { classes } = this.props;
		const { 
			title,
			description,
			details,
			featuresList,
			featuresNote,
			tag,
			tagSubscription,
			tagPerpetual,
			buttonLabel,
			icon: Icon,
			buttonURL,
			intercomMessage
		} = ADDONS_CONFIG[addonId];

		let tagToRender;

		if (tagSubscription && tagPerpetual) {
			if (this.isPerpetualOverviewMode || this.isPerpetualPeriodSelected) {
				tagToRender = tagPerpetual;
			} else {
				tagToRender = tagSubscription;
			}
		} else {
			tagToRender = tag;
		}

		return (
			<Grid
				key={`addon-${addonId}`}
				item
				container
				className={
					classNames({
						[classes.addonContainer]: true,
						[`addonContainer-${addonId}`]: true
					})					
				}>
				<Grid item className={classes.addonTitleAndDescriptionColumn}>
	
					<Grid item container direction="row" className={classes.addonIconAndTitle}>
						<Grid item className={classes.addonIconColumn}>
							<Icon />
						</Grid>
						<Grid item container direction="column" className={classes.addonTitleColumn}>
							<Typography
								variant='h3'
								className={classes.addonTitle}
								dangerouslySetInnerHTML={{ __html: title}} />
						</Grid>
					</Grid>	

					{tagToRender && (
						<Typography
							variant='h3'
							className={classes.addonTag}>
							{tagToRender}
						</Typography>						
					)}

					<Typography
						variant='h3'
						className={classes.addonDescription}>
						{description}
					</Typography>
	
					{details && (
						<Typography
							variant='h3'
							className={classes.addonDetails}>
							{localize(details, [symbol])}
						</Typography>		
					)}
				</Grid>
				<Grid item className={classes.addonDetailsListColumn}>
					<List disablePadding className={classes.addonDetailsList}>
						{featuresList && featuresList.map((item, index) => (
							<ListItem key={`features-list-${index}`} dense className={classes.addonDetailsListItem}>
								<ListItemIcon className={classes.addonDetailsListItemIcon}>
									{
										<CheckIcon2 className={classes.addonDetailsListItemIconIncluded} />
									}
								</ListItemIcon>
								<ListItemText
									className={classes.addonDetailsListItemText}
									primaryTypographyProps={{
										className: classes.addonDetailsListItemTextItem
									}}
								>
									{item.label}
								</ListItemText>
							</ListItem>
						))}
					</List>
					{featuresNote && (
						<Typography
							variant='h3'
							className={classes.addonFeaturesNote}>
							{featuresNote}
						</Typography>						
					)}					
				</Grid>
				<Grid item className={classes.addonActionsColumn}>
					{this.renderAddonButton(buttonLabel, buttonURL, intercomMessage, addonId)}
				</Grid>
			</Grid>
		);
	}


	renderAddonButton(buttonLabel, buttonURL, intercomMessage, addonId) {
		const { classes } = this.props;
		const buttonClassName = classNames({
			[classes.button]: true,
			[classes.addonButton]: true
		});

		return (
			<div className={classes.addonButtonContainer}>
				<Button
					variant='contained'
					key='main'
					className={buttonClassName}
					onClick={() => {
						if (buttonURL) {

							if (addonId === ADDONS_LIST.HOSTING) {
								if (i18n.getCurrentLanguage() === 'de') {
									buttonURL = HOSTING_BUTTON_URL_DE;
								} else {
									buttonURL = HOSTING_BUTTON_URL_EN;
								}
							}

							window.open(buttonURL, '_blank');
						} else if (intercomMessage) {
							openIntercomChat(intercomMessage, true, this.props.showErrorPopup);
						}
					}}
				>
					{buttonLabel} 
				</Button>
			</div>
		);		
	}	

	calculateCheckoutData(planToRender, period, isPerpetual, quantity) {
		let checkoutPriceTotal;
		let checkoutPricePerMonth = 0;
		let showDiscountForPlan;
		let currentRegularPrice;
		let annualPriceTotal;
		let saving;
		let errorLoadingSubscriptionEstimationData = false;
		let planIsTaxed = null;

		const {
			discountType,
			isDiscountApplied,
			couponConfig,
			couponSetKey,
			couponId,
			appliedProdTypeOfLastValidCombination,
			appliedProdCatOfLastValidCombination
		} = this.props.discount;

		if (isPerpetual) {
			showDiscountForPlan = isDiscountApplied &&
			this.shouldShowAppliedDiscountForCurrentPackage(
				planToRender,
				period,
				this.currency.key,
				couponConfig,
				discountType,
				couponSetKey,
				couponId,
				false,
				appliedProdTypeOfLastValidCombination,
				appliedProdCatOfLastValidCombination);

			currentRegularPrice = 
					parseFloat(SUBSCRIPTION_PRICES[planToRender][SUBSCRIPTION_PERIOD.PERPETUAL]);
			
			if (quantity) {
				currentRegularPrice *= quantity;
			}

			const subscriptionDiscountPrice = showDiscountForPlan
				?
				this.getDiscountPrice(currentRegularPrice, planToRender)
				:
				null;
			
			if (subscriptionDiscountPrice) {
				checkoutPricePerMonth = subscriptionDiscountPrice;
				saving = (currentRegularPrice - subscriptionDiscountPrice).toFixed(2);
			} else {
				checkoutPricePerMonth = currentRegularPrice;
			}

			if (subscriptionDiscountPrice && this.getDiscountPercent() === 1 && period === SUBSCRIPTION_PERIOD.PERPETUAL) {
				// When discount is 100% show original price to avoid slightly different number because of rounding 
				saving = currentRegularPrice;
			}		

		} else {
			const planEstimation = 
					_.get(this.props.companies,
						`subscriptionEstimation[${planToRender}-${period}-${CB_API_FETCH_CURRENCY}].estimation`)
					||
					_.get(this.props.companies,
						`subscriptionEstimationActivePlan[${planToRender}-${period}-${CB_API_FETCH_CURRENCY}].estimation`);

			if (planEstimation) {

				planIsTaxed = planEstimation.isTaxed;

				currentRegularPrice = (
					planEstimation.isTaxed
						?
						planEstimation.totalAmountWithoutTaxAndWithoutDiscount * (1 + (planEstimation.totalTaxRate / 100))
						:
						planEstimation.totalAmountWithoutTaxAndWithoutDiscount					
				)/100;

				checkoutPriceTotal = (
					planEstimation.isTaxed ? 
						planEstimation.totalAmountWithTaxWithDiscountWithoutCreditsApplied
						:
						planEstimation.totalAmountWithoutTaxWithDiscountWithoutCreditsApplied
				) / 100;

				if (period === SUBSCRIPTION_PERIOD.ANNUAL) {
					annualPriceTotal = checkoutPriceTotal;
					checkoutPricePerMonth = checkoutPriceTotal / 12;
				} else {
					checkoutPricePerMonth = checkoutPriceTotal;
				}

				showDiscountForPlan = Boolean(planEstimation.totalDiscountAmountWithoutTax);

				if (showDiscountForPlan) {
					saving = (currentRegularPrice - checkoutPriceTotal).toFixed(2);
				}
			} else {
				errorLoadingSubscriptionEstimationData = true;
			}
		}

		annualPriceTotal && (annualPriceTotal = annualPriceTotal.toFixed(2));
		checkoutPricePerMonth && (checkoutPricePerMonth = checkoutPricePerMonth.toFixed(2));

		return {
			checkoutPricePerMonth,
			showDiscountForPlan,
			currentRegularPrice,
			annualPriceTotal,
			saving,
			errorLoadingSubscriptionEstimationData,
			planIsTaxed
		};
	}

	renderBox(plan) {
		let planToRender;
		if (plan === 'current') {
			if (this.props.company.hasUnlimitedTeamSubscription) {
				planToRender = SUBSCRIPTION_PLAN.ENTERPRISE;
			} else {
				planToRender = this.activePlan;
			}
		} else {
			planToRender = plan;
		}

		const { classes } = this.props;
		const { period } = this.state;

		const {
			discountType,
			couponConfig,
			couponSetKey,
			appliedProdTypeOfLastValidCombination
		} = this.props.discount;

		const {
			className,
			title,
			description,
			descriptionDesktop,
			optionsTitle,
			optionsTitleActive,	
			optionsTitleDesktop,
			featuresListMain,
			featuresListAdvanced,
			customPackageTag,
			per_user,
			isPerpetual,
			isCloudSuitePlan,
			isCreativeToolsPlan,			
			icon: Icon,
		} = PACKAGES_CONFIG[planToRender];

		const isCurrentActivePlan = plan === 'current';

		const isCloudPackageLayout = this.category === PLAN_CATEGORIES.CLOUD_SUITE;
		const isDesktopPackageLayout = this.category === PLAN_CATEGORIES.CREATIVE_TOOLS;

		const productClassName = classNames({
			[classes.productWrapperVertical]: true,
			[classes.activeProductContent]: isCurrentActivePlan,
			['activeProductContent']: isCurrentActivePlan,
			['isCloudCategory']: isCloudPackageLayout,
			[className]: true
		});

		const textClassName = classes[className];
		const { symbol } = this.currency;
		
		let displayTitle = this.addVersionToTitle(planToRender, title);
		
		const featuresIncludedTitle = isDesktopPackageLayout && optionsTitleDesktop
			?
			optionsTitleDesktop
			:
			this.hasPlan && optionsTitleActive || optionsTitle;

		const packageDescription = isDesktopPackageLayout && descriptionDesktop
			?
			descriptionDesktop
			:
			description;
		
		const quantity = this.hasPlan && !isPerpetual
			?
			getMembersPaidQuantity(this.props.company)
			:
			this.getQuantityIntegerValue(isPerpetual ? QUANTITY_TYPE.LICENSES : QUANTITY_TYPE.SEATS);

		let {
			checkoutPricePerMonth,
			showDiscountForPlan,
			currentRegularPrice,
			annualPriceTotal,
			saving,
			planIsTaxed,
			errorLoadingSubscriptionEstimationData
		} = this.calculateCheckoutData(planToRender, period, isPerpetual, quantity);

		let savingWithYourDiscountKey = isPerpetual ? 'saving-once-off' : 'saving-subscription';
	
		if (saving) {
			// Cover case when monthly discount is for only few months
			if (_.get(couponConfig, 'duration_type') === 'limited_period' && _.get(couponConfig, 'period_unit') === 'month') {
				savingWithYourDiscountKey += '-per-limited-period';
			} else {
				if (period === SUBSCRIPTION_PERIOD.ANNUAL) {
					savingWithYourDiscountKey += '-per-year';
				} else if (period === SUBSCRIPTION_PERIOD.MONTHLY) {
					savingWithYourDiscountKey += '-per-month';
				}
				
				if (discountType === DISCOUNT_TYPE.MAGIX &&
						appliedProdTypeOfLastValidCombination === MAXIC_DISCOUNT_PROD_TYPE.SUBSCRIPTION ||
					discountType === DISCOUNT_TYPE.COUPON_SET_ID && couponSetKey === DISCOUNT_KEY.UPGRADE_POPUP) {
					savingWithYourDiscountKey += '-first-order-only';
				}
			}		
		}
		
		const renderSavedAmount = () => {

			let savingKey;
			if (!isPerpetual) {
				if (period === SUBSCRIPTION_PERIOD.ANNUAL) {
					savingKey = 'subscription-amount-per-year';
				} else if (period === SUBSCRIPTION_PERIOD.MONTHLY) {
					savingKey = 'subscription-amount-per-month';
				}
			}

			return isPerpetual
				?
				`${localize('subscription-saving-regular-price')} <strong>${symbol}${currentRegularPrice.toFixed(2)}</strong>.
				${localize(savingWithYourDiscountKey, `${symbol}${saving}`)}				
				`
				:
				`${localize('subscription-saving-regular-price')} <strong>${symbol}${currentRegularPrice.toFixed(2)} 
				/${localize(savingKey)}</strong>.
				${localize(savingWithYourDiscountKey, `${symbol}${saving}`)}`
			;
		};		

		const renderEnterprisePrice = () => (
			<Fragment>
				<Typography
					variant='h2'
					className={classes.productPrice}
				>
					{localize('subscription-plan-enterprise-price')}
				</Typography>							
			</Fragment>
		);		

		const renderProductPrice = () => (
			<Fragment>
				<Typography
					variant='h2'
					className={classes.productPrice}
					data-icon={symbol}
				>
					{checkoutPricePerMonth}
					{isPerpetual
						?
						quantity ? 
							(
								<span className={classes.itemsQuantityabel}>
									{localize('subscription-price-for-number-of-licenses', quantity)}
								</span>									
							)
							:
							''
						: (
							<span className={classes.productMonthLabel}>
								{/* P9052-25191 - keep span for Chrome translation */}
								<span>/{localize('subscription-amount-per-month')}</span>
							</span>									
						)
			
					}
					{this.getVatLabel(isPerpetual, false)}
				</Typography>							

				{annualPriceTotal && (
					<Typography
						variant='body2'
						className={classes.productPriceBilledAnualy}
					>
						{localize('subscription-billed-annually-as-one-payment-of')}
						<span className={classes.productPriceBilledAnualyValue}>
							{symbol}{annualPriceTotal}
						</span>

						{this.getVatLabel(isPerpetual, planIsTaxed)}
					</Typography>
				)}

				{!isCurrentActivePlan && saving > 0 && (
					<Typography
						variant='body2'
						className={classes.productSavedAmount}
						dangerouslySetInnerHTML={{ __html: renderSavedAmount() }}
					/>
				)}						
			</Fragment>
		);

		const renderLoadingIcon = () => (<Typography variant='body2' className={classes.productPriceInfoPending}>
			({localize('subscription-calculating-price')})
		</Typography>);

		const renderMembersIncludedInfo = () => {
			const infoToRender = _.get(PACKAGES_CONFIG[planToRender], 'membersIncludedInfo');
			return (
				<List disablePadding className={classes.membersIncludedList}>
					{infoToRender && infoToRender.map((item, index) => (
						<ListItem key={`box-item-${index}`} dense className={classes.membersIncludedListItem}>
							<ListItemIcon className={classNames(textClassName, classes.membersIncludedListItemIcon)}>
								<CheckIcon2 />
							</ListItemIcon>
							<ListItemText
								className={classes.membersIncludedListItemText}
								primaryTypographyProps={{
									className: classes.membersIncludedListItemTextItem
								}}
							>
								{item.label}
								{item.rolesTooltip && <RolesTooltip showGuestTooltip={true} />}
								{item.tooltip && <RolesTooltip text={item.tooltip} />}
							</ListItemText>
						</ListItem>
					))}
				</List>				
			);
		};

		const renderProductPriceAndDescription = () => {

			if (isCloudPackageLayout) {
				return (
					<Grid item container className={classes.gridProducPriceAndDescription}>
						<div ref={this[`${planToRender.toLowerCase()}ProductShortDescriptionCloudRef`]}>
							<Typography
								variant='body2'
								className={classes.productShortDescriptionCloud}>
								{packageDescription}
							</Typography>
						</div>
						<Grid
							className={classes.productPriceInfoVertical}>
							<div ref={this[`${planToRender.toLowerCase()}ProductPriceInfoRef`]}>
								{planToRender === SUBSCRIPTION_PLAN.ENTERPRISE
									?
									renderEnterprisePrice()
									:
									checkoutPricePerMonth &&
								!this.props.companies.getSubscriptionEstimateXhrInProgress
										? renderProductPrice()
										:
										renderLoadingIcon()}
								{planToRender !== SUBSCRIPTION_PLAN.ENTERPRISE &&
								renderMembersIncludedInfo()}
							</div>
						</Grid>
					</Grid>					
				);

			} else if (isDesktopPackageLayout) {
				return (
					<div ref={this[`${planToRender.toLowerCase()}ProductShortDescriptionDesktopRef`]}>
						<Grid item container className={classes.gridProducPriceAndDescription}>
							<Grid
								className={classes.productPriceInfo}>
								{planToRender === SUBSCRIPTION_PLAN.ENTERPRISE
									?
									renderEnterprisePrice()
									:
									checkoutPricePerMonth &&
								!this.props.companies.getSubscriptionEstimateXhrInProgress
										? renderProductPrice()
										:
										renderLoadingIcon()}
							</Grid>
							<Grid
								item
								className={classes.columnProductShortDescriptionDesktop}>
								<Typography variant='body2' className={classes.productShortDescriptionDesktop}>
									{packageDescription}
								</Typography>
							</Grid>									
						</Grid>					
					</div>
				);
			}
			
		};

		const renderProductHeader = () => {
			return (
				<Grid item container direction="row">
					{customPackageTag && !isCurrentActivePlan &&
						isCloudPackageLayout && (
							<Typography variant='body2' className={classes.productTag}>
								{localize('subscription-plan-scale-tag')}
							</Typography>
						)}

					{isCurrentActivePlan && (
						<Typography 
							variant='body2'
							className={classNames(classes.productTag, classes.productTagCurrent)}
						>
							{localize('subscription-plan-tag-current-plan')}
						</Typography>
					)}

					{isDesktopPackageLayout && (
						<Grid item className={classes.columnProductIcon}>
							<Icon />
						</Grid>)}

					<Grid 
						item
						container
						direction="column" 
						className={
							classNames(isCloudPackageLayout
								?
								classes.columnProductTitleSimple
								:
								classes.columnProductTitle)
						}
					>
						<Typography
							variant='h1'
							className={
								classNames(
									classes.productTitle,
									isCloudPackageLayout && classes.productTitleLarge
								)
							}
							dangerouslySetInnerHTML={{ __html: displayTitle }} />
						{!this.props.company.hasUnlimitedTeamSubscription &&
						(planToRender === SUBSCRIPTION_PLAN.TEAM_PLUS ||
								planToRender === SUBSCRIPTION_PLAN.ESSENTIAL) &&
						(
							<Typography variant='body2' className={classes.productQuantityPerUser}>
								{per_user}
							</Typography>									
						)}
					</Grid>
				</Grid>					
			);
		};

		const renderFeaturesListAccordion = (item) => {
			const expanded = _.get(this.state.accordion, `[${item.id}].expanded`, false);

			return (
				<ExpansionPanel
					key={`accordion-${item.id}`}
					expanded={expanded}
					className={classNames({
						[classes.packageDetailsAccordion]: true,
						[classes.packageDetailsAccordionExpanded]: expanded,
						['packageDetailsHighlighted']: Boolean(item.highlighted),
						['packageDetailsHasTag']: Boolean(item.tag)
					})}	
					onChange={(e) => this.handleAccordionToggle(e, item.id)}>
					<ExpansionPanelSummary className={classNames({
						[classes.packageDetailsAccordionSummary]: true,
						['packageDetailsAccordionSummaryExpanded']: expanded
					})}>
						<Grid container direction="row">
							<Grid item className={classes.columnAccordionToggleIcon}>
								<ExpandMore
									style={{ fontSize: 20 }}
									className={classNames({
										[classes.expandAccordionIcon]: true,
										['expandAccordionIcon']: true
									})}			
								/>
							</Grid>
							<Grid item className={classes.columnAccordionToggleTitle}>

								<Typography
									variant="body2"
									className={classNames({
										[classes.accordionTitle]: true,
										['accordionTitle']: true
									})}								
								>
									{item.tag && (
										<span
											variant='body2'
											className={classNames({
												[classes.packageDetailsTag]: true,
												['packageDetailsTag']: true
											})}
										>
											{localize(item.tag)}
										</span>
									)}

									{item.label}
								</Typography>

							</Grid>
						</Grid>				
					</ExpansionPanelSummary>
					<ExpansionPanelDetails className={classes.packageDetailsAccordionDetails}>
						<Typography
							variant='body2'
							className={classes.packageDetailsAccordionContent}
							dangerouslySetInnerHTML={{__html: item.description }}
						/>
					</ExpansionPanelDetails>
				</ExpansionPanel>				
			);
		};

		const renderFeaturesListSection = (item) => {
			return (
				<Grid container direction="row" key={`accordion-section-${item.id}`}>
					<Grid item className={classes.columnPackageDetailsSectionTitle}>
						<Typography variant='h3' className={classes.packageDetailsSectionTitle}>
							{item.tag && (
								<span
									variant='body2'
									className={classNames({
										[classes.packageDetailsTag]: true,
										['packageDetailsTag']: true
									})}							
								>
									{localize(item.tag)}
								</span>
							)}		

							{item.label}
						</Typography>
						{item.description && (
							<Typography variant='body2' className={classes.packageDetailsSectionContent}>
								{localize(item.description)}
							</Typography>
						)}					
						{item.bullets && item.bullets.map((item, index) => {
							return renderFeaturesListAccordion(item);
						})}
					</Grid>
				</Grid>				
			);
		};

		const renderCloudFeatures = () => {
			return (
				<Fragment>
					{featuresListAdvanced && featuresListAdvanced.map((item, index) => {
						if (item.type === PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION) {
							return renderFeaturesListAccordion(item);
						} else if (item.type === PACKAGE_DESCRIPTION_ITEM_TYPE.SECTION) {
							return renderFeaturesListSection(item);
						}
					})}
				
					{
						/* render desktop features inside active plan box active plan */
						isCurrentActivePlan && isCreativeToolsPlan && !isCloudSuitePlan && renderDesktopFeatures(true)
					}
				</Fragment>			
			);
		};

		const renderDesktopFeatures = (renderCloudStyleBullets) => (
			<List disablePadding className={classes.featuresList}>
				{featuresListMain && featuresListMain.map((item, index) => (
					<ListItem
						key={`desktop-features-${index}`}
						dense
						className={
							renderCloudStyleBullets ? classes.featuresListItemCloudStyle: classes.featuresListItem
						}>				
						<ListItemIcon className={classNames(textClassName, classes.featuresListItemIcon)}>
							{
								item.excluded
									?
									<XIcon className={classes.featuresListItemIconExcluded} />
									:
									<CheckIcon2 className={classes.featuresListItemIconIncluded} />
							}
						</ListItemIcon>
						<ListItemText
							className={renderCloudStyleBullets
								?
								classes.featuresListItemTextCloudStyle: classes.featuresListItemText}
							primaryTypographyProps={{
								className: renderCloudStyleBullets ?
									classes.featuresListItemTextItemCloudStyle : classes.featuresListItemTextItem
							}}
						>
							{item.label}
						</ListItemText>
					</ListItem>
				))}
			</List>
		);

		return (
			<Paper className={productClassName} component='section'>
				<Grid
					container
					direction="row"
					className={
						classNames({
							['productContentVertical']: true,
							[classes.productContentVertical]: true
						})
					}>
					<Grid item container className={classes.gridProductHeader}>
						{renderProductHeader()}
					</Grid>
					{!this.props.company.hasUnlimitedTeamSubscription && renderProductPriceAndDescription()}
					<Grid item className={classes.columnProductDescriptionMain}>

						{isCurrentActivePlan
							?
							this.renderViewCurrentPlanButton()
							:
							planToRender === SUBSCRIPTION_PLAN.ENTERPRISE
								?
								this.renderContactSalesButton(planToRender)
								:
								this.renderUpgradeButton(
									displayTitle,
									planToRender,
									showDiscountForPlan,
									period,
									checkoutPricePerMonth,
									annualPriceTotal,
									errorLoadingSubscriptionEstimationData,
									planIsTaxed)}

						{!isCurrentActivePlan && (
							<Typography variant='h2' className={classes.productDescriptionMainTitle}>
								{featuresIncludedTitle}
							</Typography>
						)}

						{isDesktopPackageLayout && this.renderProductCategory(planToRender)}
						{isDesktopPackageLayout ? renderDesktopFeatures(false): renderCloudFeatures()}
					</Grid>
				</Grid>
			</Paper>
		);
	}

	getVatLabel(isPerpetual, planIsTaxed, textOnly) {
		if (this.currency.key === CURRENCIES.USD.key) return;
		const { classes } = this.props;
		const { subscription: pastSubscription } = getSubscriptionsAndAddons(this.props.company, true);

		if (isPerpetual) {
			// Perpetual price comes from config so VAT is not included
			return textOnly
				?
				`(${localize('subscription-plus-vat')})`
				:
				<span className={classes.itemsVatLabel}>({localize('subscription-plus-vat')})</span>;
		} else if (planIsTaxed === true) {
			return textOnly
				?
				`(${localize('subscription-including-vat')})`
				:
				<span className={classes.itemsVatLabel}>({localize('subscription-including-vat')})</span>;
		} else if (!this.hasPlan && _.isEmpty(pastSubscription)) {
			// If user does not have current or past subscription we don't know VAT info
			return textOnly
				?
				`(${localize('subscription-plus-vat')})`
				:
				<span className={classes.itemsVatLabel}>({localize('subscription-plus-vat')})</span>;
		}
	}

	handleAccordionToggle(e, accordionId) {
		const accordionState = this.state.accordion;
		const isAccordionExpanded = !_.get(this.state.accordion, `[${accordionId}]expanded`, false);
		if (!accordionState[accordionId]) {
			accordionState[accordionId] = {};
		}
		accordionState[accordionId].expanded = isAccordionExpanded;
		this.setState(accordionState);
	}

	addVersionToTitle(plan, title, productVersion) {
		if (plan === SUBSCRIPTION_PLAN.WEB_PERPETUAL) {
			return title.replace('_VERSION_', productVersion || WEB_PERPETUAL_LATEST_VERSION);
		} else if (plan === SUBSCRIPTION_PLAN.PHOTO_PERPETUAL) {
			return title.replace('_VERSION_', productVersion || PHOTO_PERPETUAL_LATEST_VERSION);
		} else if (plan === SUBSCRIPTION_PLAN.DESIGNER_PERPETUAL) {
			return title.replace('_VERSION_', productVersion || DESIGNER_PERPETUAL_LATEST_VERSION);
		} else {
			return title;
		}
	}

	renderViewCurrentPlanButton(plan, useDiscount) {
		const { classes } = this.props;
		const buttonClassName = classNames({
			[classes.button]: true,
			[classes.viewCurrentPlanButton]: true
		});

		return (
			<div className={classes.viewCurrentPlanButtonContainer}>
				<Button
					variant='contained'
					data-tid='buttonview-current-plan'
					key='main'
					className={buttonClassName}
					onClick={() => this.handleViewCurrentPlan()}
				>
					{localize('subscription-box-view-current-plan')}
				</Button>
			</div>
		);
	}

	showReduceUsersModal(callback, freeSeatsIncluded, quantityFromQueryParam) {
		const modalProps = {
			cb: callback,
			getQuantityInputValue: this.getQuantityInputValue,
			freeSeatsIncluded,
			quantityFromQueryParam
		};

		this.props.showModal('REDUCE_USERS', modalProps);
	}

	showConfirmChoiceModal(callback,
		displayTitle,
		plan,
		quantity,
		currency,
		period,
		checkoutPricePerMonth,
		annualPriceTotal,
		errorLoadingSubscriptionEstimationData,
		planIsTaxed) {
		const { isPerpetual, freeSeatsIncluded } = PACKAGES_CONFIG[plan];

		let productTitle = stripHTML(displayTitle);

		const modalProps = {
			cb: callback,
			plan,
			listItems: [
				productTitle
			]
		};

		let priceAndPeriodLabelKey;
		if (period === SUBSCRIPTION_PERIOD.ANNUAL) {
			priceAndPeriodLabelKey = 'subscription-current-billing-period-yearly';
		} else if (period === SUBSCRIPTION_PERIOD.MONTHLY) {
			priceAndPeriodLabelKey = 'subscription-current-billing-period-monthly';
		} else {
			priceAndPeriodLabelKey = 'subscription-current-billing-period-perpetual';
		}

		let priceToShow;
		if (period === SUBSCRIPTION_PERIOD.ANNUAL) {
			priceToShow = annualPriceTotal;
		} else if (period === SUBSCRIPTION_PERIOD.MONTHLY || period === SUBSCRIPTION_PERIOD.PERPETUAL) {
			priceToShow = checkoutPricePerMonth;
		}
		
		let priceAndPeriod;
		if (!errorLoadingSubscriptionEstimationData) {
			// Allow checkout if fetching addon data fails but don't show price in Confirm choice popup
			priceAndPeriod = `${localize(priceAndPeriodLabelKey)}:
			${currency.symbol}${priceToShow} ${localize('subscription-currency-' + currency.key)}`;

			const vatLabel = this.getVatLabel(isPerpetual, planIsTaxed);
			if (vatLabel) {
				priceAndPeriod = `${priceAndPeriod}${renderToString(vatLabel)}`;
			}
		}

		if (isPerpetual) {
			modalProps.listItems.push(localize('subscription-confirm-choice-licenses-total', quantity));
			priceAndPeriod && modalProps.listItems.push(priceAndPeriod);
		} else {
			if ([SUBSCRIPTION_PLAN.WEB, SUBSCRIPTION_PLAN.PHOTO, SUBSCRIPTION_PLAN.DESIGNER].includes(plan)) {
				modalProps.listItems.push(localize('subscription-confirm-choice-users-total', quantity));
			} else if (plan === SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT) {
				modalProps.listItems.push(localize('subscription-confirm-choice-one-agent', quantity));
			} else if ([SUBSCRIPTION_PLAN.ESSENTIAL, SUBSCRIPTION_PLAN.TEAM_PLUS, SUBSCRIPTION_PLAN.BROKERAGES].includes(plan)) {

				const usersKey = plan === SUBSCRIPTION_PLAN.BROKERAGES ? 'agents' : 'users';


				const quantityString = quantity <= freeSeatsIncluded
					?
					localize(`subscription-confirm-choice-${usersKey}-total-including-free`,
						[freeSeatsIncluded, freeSeatsIncluded - 1])
					:
					localize(`subscription-confirm-choice-${usersKey}-total`, quantity);

				modalProps.listItems.push(quantityString);
			}

			if (priceAndPeriod) {
				modalProps.listItems.push(priceAndPeriod);
			} else {
				modalProps.listItems.push(localize(priceAndPeriodLabelKey));
				modalProps.listItems.push(`${localize('subscription-currency')}:
					${localize('subscription-currency-' + currency.key)}`);
			}

			if ([SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT, SUBSCRIPTION_PLAN.BROKERAGES].includes(plan)) {
				modalProps.listItems.push(localize('subscription-confirm-choice-12-months-commitment'));
			}
		}

		this.props.showModal('CONFIRM_PURCHASE_CHOICE', modalProps);
	}

	doCheckout(plan, period, isUpgrade, useDiscount, isPerpetual, isUserNumberMismatch) {
		trackClickSubscriptionUpgrade(plan, period, isPerpetual, getTrackingOptions(this.props.company));

		const { isEmptySeatsAllowed, freeSeatsIncluded } = PACKAGES_CONFIG[plan];

		// If users enters quantity = 1 or 2 when buying team/+, continue with order but send all free seats to MW
		let checkoutQuantity = this.getQuantityIntegerValue(isPerpetual ? QUANTITY_TYPE.LICENSES : QUANTITY_TYPE.SEATS);
		if (!isUpgrade && isEmptySeatsAllowed && freeSeatsIncluded && checkoutQuantity < freeSeatsIncluded) {
			checkoutQuantity = freeSeatsIncluded;
		}

		const triggerChargebeeProceed = () => {
			this.proceedChargeBeeSubscription(
				plan,
				period,
				this.currency.key,
				isUpgrade,
				useDiscount ? this.getCouponSetId(period, plan): null,
				useDiscount ? this.props.discount.couponId : null,
				checkoutQuantity
			);		
		};

		if (isUserNumberMismatch) {
			triggerChargebeeProceed();
		} else {
			this.setState({
				willProceedToCheckout: true
			}, () => {
				triggerChargebeeProceed();
			});
		}
	}

	renderProductCategory(plan) {
		const { classes } = this.props;

		let tag;
		if (PACKAGES_CONFIG[plan].isPerpetual) {
			tag = localize('subscription-tag-desktop-only');
		} else if (PACKAGES_CONFIG[plan].isCloudTag && PACKAGES_CONFIG[plan].isDesktopTag) {
			tag = localize('subscription-tag-cloud-and-desktop');
		} else if (PACKAGES_CONFIG[plan].isDesktopTag) {
			tag = localize('subscription-tag-desktop-only');
		} else if (PACKAGES_CONFIG[plan].isCloudTag) {
			tag = localize('subscription-tag-cloud-only');
		}

		return (
			<Typography variant='body2' className={classNames(classes.planCategoryTag)}>
				{tag}
			</Typography>
		);
	}

	renderUpgradeButton(
		displayTitle,
		plan,
		useDiscount,
		period,
		checkoutPricePerMonth,
		annualPriceTotal,
		errorLoadingSubscriptionEstimationData,
		planIsTaxed) {

		if (this.props.company.hasUnlimitedTeamSubscription) return;

		const { classes } = this.props;
		const { className, isPerpetual, freeSeatsIncluded } = PACKAGES_CONFIG[plan];
		const buttonClassName = classNames({
			[classes.button]: true,
			[classes.purchaseButton]: true,
			[classes[className]]: true
		});

		const isUpgrade = this.hasPlan;
		const quantity = this.getQuantityInputValue(isPerpetual ? QUANTITY_TYPE.LICENSES : QUANTITY_TYPE.SEATS);

		let label;
		if (isPerpetual) {
			label = localize('subscription-box-buy');
		} else if (!this.hasPlan) {
			label = localize('subscription-box-subscribe');
		} else if (this.hasPlan) {
			if (plan === this.activePlan && this.isMonthlyPlan && period == SUBSCRIPTION_PERIOD.ANNUAL) {
				label = localize('subscription-box-view-change-to-yearly-subscription');
			} else {
				label = this.category === PLAN_CATEGORIES.CREATIVE_TOOLS
					?
					localize('subscription-box-change-to-this-plan')
					:
					localize('subscription-box-upgrade');
			}
		}

		return (
			<div className={classes.purchaseButtonContainer}>
				<Button
					variant='contained'
					data-tid={`button-subscription-update-${plan}`}
					key='main'
					disabled={!isValidNonZeroQuantity(quantity)}
					className={buttonClassName}
					onClick={() => this.handleBuyRequest(
						plan,
						period,
						isUpgrade,
						isPerpetual,
						displayTitle,
						useDiscount,
						quantity,
						freeSeatsIncluded,
						checkoutPricePerMonth,
						annualPriceTotal,
						errorLoadingSubscriptionEstimationData,
						planIsTaxed				
					)}
				>
					{label}
				</Button>
			</div>
		);
	}

	handleBuyRequest(
		plan,
		period,
		isUpgrade,
		isPerpetual,
		displayTitle,
		useDiscount,
		quantity,
		freeSeatsIncluded,
		checkoutPricePerMonth,
		annualPriceTotal,
		errorLoadingSubscriptionEstimationData,
		planIsTaxed) {

		if (isPerpetual) {
			this.showConfirmChoiceModal(
				() => this.doCheckout(
					plan,
					period,
					false /*isUpgrade*/,
					useDiscount,
					isPerpetual,
					false /*isUserNumberMismatch*/
				),
				displayTitle,
				plan,
				quantity,
				this.currency,
				this.period,
				checkoutPricePerMonth,
				annualPriceTotal,
				errorLoadingSubscriptionEstimationData,
				null /* planIsTaxed */
			);
		} else if (!this.hasPlan) {
			const nonGuestUsers = filterNonGuestUsers(this.props.company.users);
			if (quantity < nonGuestUsers.length && nonGuestUsers.length > freeSeatsIncluded) {
				this.props.showModal('CONFIRMATION_MODAL', {
					title: localize('subscription-confirm-number-of-users-title'),
					message: { __html:
						localize('subscription-confirm-number-of-users-description',
							[nonGuestUsers.length, quantity])
					},
					buttons: [
						<Button
							data-tid="confirm-number-of-users-cancel"
							key='confirm-number-of-users-cancel'
							variant='outlined'
							color='primary'
						>
							{localize('go-back')}
						</Button>,
						<Button
							data-tid="confirm-number-of-users-reduce"
							key='confirm-number-of-users-reduce'
							variant='contained'
							color='primary'
							onClick={() => {
								this.props.hideModal();
								this.showReduceUsersModal(
									() => this.showConfirmChoiceModal(
										() => this.doCheckout(
											plan,
											period,
											isUpgrade,
											useDiscount,
											isPerpetual,
											false /*isUserNumberMismatch*/
										),
										displayTitle,
										plan,
										quantity,
										this.currency,
										this.period,
										checkoutPricePerMonth,
										annualPriceTotal,
										errorLoadingSubscriptionEstimationData,
										planIsTaxed
									),
									freeSeatsIncluded,
									null, // quantityFromQueryParam
								);									
							}}
						>
							{localize('reduce-users')}
						</Button>]
				});
			} else {
				this.showConfirmChoiceModal(
					() => this.doCheckout(
						plan,
						period,
						isUpgrade,
						useDiscount,
						isPerpetual,
						false /*isUserNumberMismatch*/
					),
					displayTitle,
					plan,
					quantity,
					this.currency,
					this.period,
					checkoutPricePerMonth,
					annualPriceTotal,
					errorLoadingSubscriptionEstimationData,
					planIsTaxed
				);
			}

		} else {
			this.doCheckout(plan, period, isUpgrade, useDiscount, isPerpetual, false /*isUserNumberMismatch*/);
		}
	}

	renderContactSalesButton(plan) {
		const { classes } = this.props;
		const buttonClassName = classNames({
			[classes.button]: true,
			[classes.purchaseButton]: true
		});

		return (
			<div className={classes.purchaseButtonContainer}>
				<Button
					variant='contained'
					data-tid={`button-subscription-update-${plan}`}
					key='main'
					className={buttonClassName}
					onClick={() => this.props.showModal('CONTACT_SALES_MODAL', {
						title: localize('contact-sales-form-title')
					})}
				>
					{localize('subscription-contact-sales')} 
				</Button>
			</div>
		);		
	}

	renderSeeAllProductsLink() {
		const { classes } = this.props;
		return (
			<Link
				component="button"
				variant="body2"
				data-tid='see-al-products-button'
				underline='none'
				className={classes.seeAllProductsLink}
				onClick={() => this.toggleSeeAllProducts()}
			>
				{localize('subscription-list-see-all-products')} 
			</Link>
		);
	}

	renderSubscriptionViewSelector() {
		const { classes } = this.props;
		return (
			<Grid container item className={classes.subscriptionViewSelector}>
				<Grid item className={classes.subscriptionViewSelectorColumn}>
					<Link
						underline='none'
						data-tid='subscription-view-current-products-link'
						className={classNames(
								classes.subscriptionViewSelectorLink,
								this.isCurrentProductsView && classes.subscriptionViewSelectorLinkActive
						)}
						onClick={() => this.handleSubscriptionViewChange(SUBSCRIPTION_VIEW.CURRENT_PRODUCTS)}
					>
						{SUBSCRIPTION_VIEW.CURRENT_PRODUCTS}
					</Link>
				</Grid>
				<Grid item className={classes.subscriptionViewSelectorColumn}>
					<Link
						underline='none'
						data-tid='subscription-view-purchase-options-link'
						className={classNames(
								classes.subscriptionViewSelectorLink,
								this.isPurchaseOptionsView && classes.subscriptionViewSelectorLinkActive
						)}
						onClick={() => this.handleSubscriptionViewChange(SUBSCRIPTION_VIEW.PURCHASE_OPTIONS)}
					>
						{SUBSCRIPTION_VIEW.PURCHASE_OPTIONS}
					</Link>
				</Grid>
			</Grid>
		);
	}	
	
	renderCategorySelector() {
		const { classes } = this.props;
		return (
			<Grid container item className={classes.categorySelector}>
				<Grid item className={classes.categorySelectorColumn}>
					<Button
						variant={this.isCloudSuiteCategory ? 'contained' : 'outlined'}
						disableRipple
						fullWidth
						data-tid='plan-category-button-cloud-suite'
						className={classNames(
								classes.categorySelectorButton,
								this.isCloudSuiteCategory && classes.categorySelectorButtonActive
						)}
						onClick={() => this.handlePlanCategoryChange(PLAN_CATEGORIES.CLOUD_SUITE)}
					>
						{localize('subscription-category-cloud')}
					</Button>
				</Grid>
				<Grid item className={classes.categorySelectorColumn}>
					<Button
						variant={this.isCreativeToolsCategory ? 'contained' : 'outlined'}
						disableRipple
						fullWidth
						data-tid='plan-category-button-creative-tools'
						className={classNames(
								classes.categorySelectorButton,
								this.isCreativeToolsCategory && classes.categorySelectorButtonActive
						)}
						onClick={() => this.handlePlanCategoryChange(PLAN_CATEGORIES.CREATIVE_TOOLS)}
					>
						{localize('subscription-category-desktop')}
					</Button>
				</Grid>
			</Grid>
		);
	}

	get shouldRenderPerpetualCheckbox() {
		return this.hasPerpetualCheckbox &&
			(this.category === PLAN_CATEGORIES.CREATIVE_TOOLS || this.isScalePlan && this.isAnnualPlan);
	}

	get hasPerpetualCheckbox() {
		const { perpetualAddons } = getSubscriptionsAndAddons(this.props.company);
		return !_.isEmpty(perpetualAddons) &&
			!this.props.company.hasUnlimitedTeamSubscription &&
			!this.isPlusOverviewMode;
	}

	renderPeriodSelector() {
		const { classes } = this.props;
		const { period } = this.state;

		const selectedValue = period || SUBSCRIPTION_PERIOD.ANNUAL;
		
		return (
			<div className={classes.periodSelector}>
				<RadioGroup
					name="period"
					data-tid='period-selector'
					value={selectedValue}
					row={true}
					onChange={(event) => this.handlePeriodChange(event)}
				>
					{this.allPeriods.includes(SUBSCRIPTION_PERIOD.ANNUAL) && (
						<FormControlLabel
							value={SUBSCRIPTION_PERIOD.ANNUAL}
							className={classNames(
								classes.noMargins,
								selectedValue === SUBSCRIPTION_PERIOD.ANNUAL ?
									classes.periodSelectorLabelChecked : classes.periodSelectorLabel,
								classes.periodSelectorLabelHover)}
							control={
								<Radio
									color="primary"
									className={classes.radioButton}
									disableRipple />
							}
							label={<Fragment>
								{localize('subscription-period-selector-annual')}&nbsp;
								{!(this.isScalePlan && this.isAnnualPlan) && (
									<span className={classes.periodSelectorDiscount}>
										{localize('subscription-period-selector-annual-discount')}
									</span>								
								)}
							
							</Fragment>} />
					)}

					{this.allPeriods.includes(SUBSCRIPTION_PERIOD.MONTHLY) && (
						<FormControlLabel
							value={SUBSCRIPTION_PERIOD.MONTHLY}
							className={classNames(
								classes.noMargins,
								selectedValue === SUBSCRIPTION_PERIOD.MONTHLY ?
									classes.periodSelectorLabelChecked : classes.periodSelectorLabel,
								classes.periodSelectorLabelHover)}
							control={
								<Radio
									color="primary"
									className={classes.radioButton}
									disableRipple
								/>}
							label={localize('subscription-period-selector-monthly')} />
					)}

					{this.allPeriods.includes(SUBSCRIPTION_PERIOD.PERPETUAL) &&
					<FormControlLabel
						value={SUBSCRIPTION_PERIOD.PERPETUAL}
						className={classNames(
							classes.noMargins,
							selectedValue === SUBSCRIPTION_PERIOD.PERPETUAL ?
								classes.periodSelectorLabelChecked : classes.periodSelectorLabel,
							classes.periodSelectorLabelHover)}
						control={
							<Radio
								color="primary"
								className={classes.radioButton}
								disableRipple
							/>}
						label={localize('subscription-period-selector-perpetual')} />
					}
				</RadioGroup>
			</div>
		);
	}

	renderCurrencySelector() {
		const { classes } = this.props;
		return (
			<Paper className={classes.currencySelector} component='section'>
				<Select
					name='currency'
					data-tid='currency-selector'
					className={classes.currencySelectorSelect}
					onChange={this.handleCurrencyChange}
					value={this.currency.key}
					displayEmpty
					fullWidth
					disableUnderline
					IconComponent={SelectArrow}
					MenuProps={{ classes: { paper: classes.currencySelectorSelectItems } }}
				>
					{Object.keys(CURRENCIES).map(key => {
						const option = CURRENCIES[key];
						return (
							<MenuItem key={option.key} value={option.key}>
								{option.value}
							</MenuItem>
						);
					})}
				</Select>
			</Paper>
		);
	}

	renderInfoTooltip(key, isQuantityFieldRelated, plan) {
		const { classes } = this.props;

		let message;
		if (key) {
			if (key === 'desktop-plus-extended') {
				const plansToRender = this.getPlansToRender(true, true, false);
				const isAnyCreativeToolsPlan = plansToRender.some(planId => PACKAGES_CONFIG[planId].isCreativeToolsPlan);
				if (isAnyCreativeToolsPlan) {
					message = localize(`license-info-${key}`);
				}
			} else {
				message = localize(`license-info-${key}`);
			}
			
		} else if (plan === SUBSCRIPTION_PLAN.PHOTO || plan === SUBSCRIPTION_PLAN.WEB || plan === SUBSCRIPTION_PLAN.DESIGNER) {
			message = localize('license-info-desktop-plus');
		} else if (plan === SUBSCRIPTION_PLAN.TEAM_PLUS) {
			message = localize('license-info-scale');
		}

		if (!message) return;

		return (
			<Tooltip
				placement="top"
				title={
					<Fragment>
						<Typography variant='body2' className={classNames(classes.infoTooltipText)}>
							{message}
						</Typography>
						<span className={classes.arrow} />
					</Fragment>
				}
				classes={{
					tooltip: classes.infoTooltip
				}}
			>
				<IconButton
					className={
						classNames({
							[classes.infoIcon]: true,
							[classes.infoIconQuantityField]: isQuantityFieldRelated					
						})
					}
					color='primary'
					component='span'
					disableRipple>
					<Info />
				</IconButton>
			</Tooltip>				
		);
	}

	renderSubscriptionActionButtons(plan, period) {
		const { classes } = this.props;

		return (
			<Fragment>
				<ListItem className={classes.columnActiveProductActionsListItem}>
					<Link
						component="button"
						variant="body2"
						data-tid='view-details-and-manage-button'
						className={classNames(
							classes.activeProductActionLink,
							classes.viewDetailsAndManage
						)}
						onClick={() => this.showSubscriptionDetails()}
					>
						{localize('subscription-action-view-details-and-manage')}
					</Link>
				</ListItem>
				<ListItem className={classes.columnActiveProductActionsListItem}>
					<Link
						component="button"
						variant="body2"
						data-tid='update-credit-card-button'
						className={classNames(
							classes.activeProductActionLink,
							classes.viewDetailsAndManage
						)}
						onClick={() => this.showSubscriptionDetails()}
					>
						{localize('subscription-action-update-credit-card')}
					</Link>
				</ListItem>				
				{PACKAGES_CONFIG[plan].isMultiUser && (
					<ListItem className={classes.columnActiveProductActionsListItem}>
						<Link
							component="button"
							variant="body2"
							data-tid='buy-more-seats-button'
							className={classNames(
								classes.activeProductActionLink,
								classes.buyMoreSeatsLink,
								this.props.companies.pendingPayingUserQuantity && classes.buyMoreSeatsLinkDisabled
							)}
							onClick={() => 
								!this.props.companies.pendingPayingUserQuantity && this.handleBuyMoreSeats(plan, period)}
						>
							{localize('subscription-action-add-more-seats')}
						</Link>
					</ListItem>		
				)}
			</Fragment>
		);
	}

	renderSubscriptionUpgradeButton() {
		const { classes } = this.props;
		return (
			<ListItem className={classes.columnActiveProductActionsListItem}>
				<Link
					component="button"
					variant="body2"
					data-tid='upgrade-plan-button'
					className={classNames(
					classes.activeProductActionLink,
					classes.upgradeLink
					)}
					onClick={() => this.handleUpgradePlan()}
				>
					{localize(this.hasPlan ? 'subscription-action-upgrade' : 'subscription-action-upgrade-now')}
				</Link>
			</ListItem>
		);
	}	

	renderContactUsButton() {
		const { classes } = this.props;
		return (
			<ListItem className={classes.columnActiveProductActionsListItem}>
				<Link
					component="button"
					variant="body2"
					data-tid='contact-us-button'
					className={classNames(
					classes.activeProductActionLink,
					classes.contactUsLink
					)}
					onClick={() => this.contactUsHandler()}
				>
					{localize('subscription-contact-us')}
				</Link>
			</ListItem>
		);
	}

	getTotalNumberOfSeats() {
		const result = this.props.companies.pendingPayingUserQuantity ?
			this.props.companies.pendingPayingUserQuantity
			:
			this.hasPlan ? getMembersPaidQuantity(this.props.company) + PACKAGES_CONFIG[this.activePlan].freeSeatsIncluded: 0;

		return result;
	}

	renderCurrentPlans() {
		
		const { classes } = this.props;
		const { activeSubscription, hasTrial } = this.state;
		const { perpetualAddons, subscription } = getSubscriptionsAndAddons(this.props.company);

		let cancelledSubscription;
		let cancelledPlanId;
		if (!this.hasPlan && !this.props.company.hasUnlimitedTeamSubscription) {
			({ subscription: cancelledSubscription } = getSubscriptionsAndAddons(this.props.company, true)); 

			if (!_.isEmpty(cancelledSubscription)) {
				({ plan: cancelledPlanId } = convertPlanIdIntoSubscription(cancelledSubscription.planId));
				
				if (!Object.values(SUBSCRIPTION_PLAN).includes(cancelledPlanId)) {
					// Cancelled subscriptions are not migrated, we upgrade them to Scale
					cancelledPlanId = SUBSCRIPTION_PLAN.SCALE;
				}
			}
		}

		let totalNumberOfSeats = this.getTotalNumberOfSeats();

		const ownedPerpetualAddons = [];
		if (!_.isEmpty(perpetualAddons) && !this.props.company.hasUnlimitedTeamSubscription) {
			perpetualAddons.sort((a, b) => {
				const productKeyA = a.id.split('_')[0];
				const productKeyB = b.id.split('_')[0];
				const productVersionA = parseInt(a.id.split('_')[1]);
				const productVersionB = parseInt(b.id.split('_')[1]);
				return productVersionB - productVersionA || productKeyB.localeCompare(productKeyA);
			});

			perpetualAddons.forEach((addon, index) => {
				const productKey = addon.id.split('_')[0];
				const productVersion = parseInt(addon.id.split('_')[1]);
				const plan = productKey.toLowerCase();
	
				const {
					icon: Icon,
					title,
				} = PACKAGES_CONFIG[plan];				

				const displayTitle = this.addVersionToTitle(plan, title, productVersion);
					
				const renderLicenseUsageStats = () => {
					if (addon.paidQuantity > 1) {
						return localize('subscription-used-licenses', [addon.usedQuantity, addon.paidQuantity]);
					} else if (addon.paidQuantity === 1) {
						return localize(addon.usedQuantity === 1
							?
							'subscription-used-licenses-single-user'
							:
							'subscription-used-licenses-single-user-not-used'
						);
					}
				};

				ownedPerpetualAddons.push(
					<Grid item key={`active-product-addon-${index+1}`} className={classes.product}>
						<Paper
							className={classNames(classes.productContent, classes.ownedProductContent)}
							component='section'>
							<Grid container direction="row" className={classes.productColumns}>
								<Grid item container className={classes.columnActiveProductName}>
									<Grid item container direction="row">
										<Grid item className={classes.columnProductIcon}>
											<Icon />
										</Grid>
										<Grid item container direction="column" className={classes.columnProductTitle}>
											<Typography
												variant='h1'
												className={classes.productTitle}
												dangerouslySetInnerHTML={{ __html: displayTitle }} />
										</Grid>
									</Grid>	
								</Grid>
								<Grid item className={classes.columnActiveProductDetails}>
									<Typography
										className={classNames(classes.columnActiveProductDetailsTitle, classes.columnTextLarger)}>
										{localize('subscription-duration-lifetime')}
									</Typography>
									<Typography
										className={
											classNames(
												classes.columnActiveProductDetailsQuantity, 
												classes.columnTextSmaller
											)
										}>
										{localize('subscription-total-licenses')}: {addon.paidQuantity}
										{this.renderInfoTooltip('perpetual', false)}
									</Typography>
									<Typography
										className={
											classNames(
												classes.columnActiveProductDetailsUsedInfo,
												classes.columnTextSmaller
											)}>
										{renderLicenseUsageStats()}
									</Typography>
								</Grid>
								<Grid item className={classes.columnActiveProductActions}>
									{
										!this.props.company.hasUnlimitedTeamSubscription && (
											<Link
												component="button"
												variant="body2"
												data-tid='buy-more-licenses'
												className={classNames(
												classes.buyMoreLicenses,
												classes.activeProductActionLink
												)}
												underline='none'
												onClick={() => this.handlePurchaseMoreLicenses(plan)}
											>
												{localize('subscription-your-producs-buy-more-licenses')}
											</Link>
										)
									}
								</Grid>
							</Grid>
						</Paper>
					</Grid>
				);
			});
		}		
		let Icon, title, planTid;

		if (!_.isEmpty(this.pendingSubscription)) {
			const { plan: savedCheckoutPlan } = convertPlanIdIntoSubscription(this.pendingSubscription);
			({icon: Icon, title} = PACKAGES_CONFIG[savedCheckoutPlan]);
			planTid = 'current-plan';
		} else if (this.hasPlan) {

			if (this.props.company.hasUnlimitedTeamSubscription) {
				({icon: Icon, title} = PACKAGES_CONFIG[SUBSCRIPTION_PLAN.ENTERPRISE]);
			} else {
				({icon: Icon, title} = PACKAGES_CONFIG[activeSubscription.plan]);
			}
			planTid = 'current-plan';
			
		} else {
			Icon = IconNoPackage;
			title = localize(hasTrial ? 'subscription-trial' : 'subscription-free');
			planTid = hasTrial ? 'subscription-trial' : 'subscription-free';
		}

		if ([SUBSCRIPTION_PLAN.BROKERAGES, SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT].includes(activeSubscription.plan)) {
			Icon = IconNoPackage;
		}

		let billingNextDate = this.getNextBillingDate();
		let cancellationDate = this.getCancellationDate();
		let renewalEstimation = 0;
		let renewalEstimationIsTaxed = false;

		if (this.hasPlan) {
			const upcomingInvoiceEstimation = this.props.companies.upcomingInvoiceEstimation;
			
			if (upcomingInvoiceEstimation) {
				renewalEstimation = 
					(upcomingInvoiceEstimation.totalAmountWithTaxWithDiscountWithoutCreditsApplied/100).toFixed(2);
				renewalEstimationIsTaxed = upcomingInvoiceEstimation.totalTaxRate != null;
			}
		}

		const renderNextBillingAmount = () => {
			let result = '';
			if (this.props.companies.pendingPayingUserQuantity || this.props.companies.upcomingInvoiceEstimationXhrInProgress) {
				result = localize('subscription-calculating-renewal');
			} else {
				result = `${this.currency.symbol}${renewalEstimation}`;
				if (renewalEstimationIsTaxed) {
					result += ` (${localize('subscription-including-vat')})`;
				}
			}
			return result;
		};
		
		const renderActiveProductDetails = () => {
			return (
				<Fragment>
					{subscription.nextBillingAt &&
					!subscription.cancellationPending &&
					!this.props.company.hasUnlimitedTeamSubscription && (
							<Typography
								className={
									classNames(classes.columnActiveProductDetailsCurrentBillingPeriod, classes.columnTextLarger)
								}>
								{localize(activeSubscription.period === SUBSCRIPTION_PERIOD.ANNUAL
									?
									'subscription-current-billing-period-yearly'
									:
									'subscription-current-billing-period-monthly')
								}
							: {renderNextBillingAmount()}
							</Typography>
						)}
					<Typography className={classNames(classes.columnActiveProductDetailsSeatsStats, classes.columnTextSmaller)}>
						{
							PACKAGES_CONFIG[activeSubscription.plan].freeSeatsIncluded === 1 &&
								!PACKAGES_CONFIG[activeSubscription.plan].isEmptySeatsAllowed
								?
								localize('subscription-single-user')
								:
								this.props.company.hasUnlimitedTeamSubscription
									?
									`${localize('subscription-total-users')}: ${totalNumberOfSeats}`
									:
									localize('subscription-user-licenses-stats',
										[totalNumberOfSeats, filterNonGuestUsers(this.props.company.users).length])}
						{this.renderInfoTooltip(null, false, activeSubscription.plan)}
					</Typography>

					{cancellationDate && (
						<Fragment>
							<Typography
								className={
									classNames(classes.columnActiveProductDetailsCancellationDate, classes.columnTextSmaller)
								}>
								{localize(
									this.isRealEstateIndustry()
										?
										're-subscription-cancellation-date'
										:
										'subscription-cancellation-date',
										cancellationDate)
								}
							</Typography>
							<Typography
								className={
									classNames(
										classes.columnActiveProductDetailsRevokeCancellationInfo,
										classes.columnTextSmaller
									)
								}>
								{localize('subscription-revoke-cancellation-info')}
							</Typography>
						</Fragment>
					)}

					{billingNextDate && (
						<Typography
							className={
								classNames(classes.columnActiveProductDetailsSubscriptionRenewalDate, classes.columnTextSmaller)
							}>
							{localize('subscription-renewal-date')}: {billingNextDate}
						</Typography>
					)}
				</Fragment>			
			);
		};

		const getAccesToProductsDetails = (isTrialActive) => {
			const isPerpetualMode = this.props.app.isPerpetualApp || this.isPerpetualOverviewMode;
			const key = isPerpetualMode
				?
				isTrialActive
					? 'subscription-no-access-to-desktop-apps-perpetual' : 'subscription-continue-to-use-desktop-apps-perpetual'
				:
				isTrialActive
					? 'subscription-no-access-to-desktop-apps-plus' : 'subscription-continue-to-use-desktop-apps-plus';

			return (
				<List className={classes.expiredProductsLists}>
					<ListItem>
						{!isPerpetualMode && (
							<Typography className={classes.columnTextSmaller}>
								{localize(
							isTrialActive ? 'subscription-xara-cloud' : 'subscription-xara-cloud-free-plan')
								}
							</Typography>
						)}
					</ListItem>
					<ListItem>
						<Typography className={classes.columnTextSmaller}>{localize(key)}</Typography>
					</ListItem>
				</List>
			);
		};

		const renderActiveTrialDetails = () => {
			const trialExpireDate = new Date(this.props.company.trial.endDate)
				.toLocaleDateString(i18n.getCurrentLanguage(true), localeDateStringOptions);
			return (
				<Fragment>
					<Typography
						className={classNames(classes.columnActiveProductDetailsTitle, classes.columnTextLarger)}>
						{localize('subscription-trial-expires-on')}: {trialExpireDate}
					</Typography>
					<Typography
						className={classNames(classes.infoAccessToProducts, classes.columnTextSmaller)}>
						{localize('subscription-trial-you-have-full-access-to')}:
					</Typography>
					{getAccesToProductsDetails(true)}
				</Fragment>
			);
		};

		const renderPendingSubscription = () => {
			return (
				<Typography
					className={classNames(classes.infoPendingSubscription, classes.columnTextSmaller)}>
					{localize('subscription-pending-subscription')}
				</Typography>
			);
		};		

		const renderExpiredTrialDetails = () => {
			return (
				<Fragment>
					<Typography
						className={classNames(classes.infoAccessToProducts, classes.columnTextSmaller)}>
						{localize('subscription-free-you-can-continue-to-use')}:
					</Typography>					
					{getAccesToProductsDetails(false)}
				</Fragment>
			);
		};
		
		return (
			<Grid container item>
				<Grid container className={classes.productsList}>
					<Grid item key={'active-product-subscription'} className={classes.product}>
						<Paper 
							className={classNames({
								[classes.productContent]: true,
								[classes.ownedProductContent]: true,
								['hasReactivateLink']: !_.isEmpty(cancelledSubscription),
								['isMonthly']: this.hasPlan && activeSubscription.period === SUBSCRIPTION_PERIOD.MONTHLY,
								['hasCancellationDate']: Boolean(cancellationDate),
								['hasAddons']: !_.isEmpty(ownedPerpetualAddons)
							})}						
							component='section'>
							<Grid 
								container 
								direction="row"
								className={classes.productColumns}
								{...(planTid ? {'data-tid': planTid} : {})}
							>
								<Grid item container className={classes.columnActiveProductName}>
									<Grid item container direction="row">
										<Grid item className={classes.columnProductIcon}>
											<Icon />
										</Grid>
										<Grid item container direction="column" className={classes.columnProductTitle}>
											<Typography
												variant='h1'
												className={classNames(
													classes.productTitle,
													this.props.company.hasUnlimitedTeamSubscription
														? 
														classes.productTitleUnlimited : null
												)}
												dangerouslySetInnerHTML={{ __html: title }} />
										</Grid>
									</Grid>											
								</Grid>
								<Grid item className={classes.columnActiveProductDetails}>
									{
										this.pendingSubscription
											?
											renderPendingSubscription()
											:
											this.hasPlan
												?
												renderActiveProductDetails()
												:
												hasTrial
													?
													renderActiveTrialDetails()
													:
													renderExpiredTrialDetails()
									}
								</Grid>
								<Grid item className={classes.columnActiveProductActions}>
									{!this.pendingSubscription &&
										(this.hasNonUnlimitedSubscription || this.canSubscriptionBeUpgraded) && (
											<List className={classes.columnActiveProductActionsList}>
												{this.hasNonUnlimitedSubscription &&
											this.renderSubscriptionActionButtons(
												activeSubscription.plan,
												activeSubscription.period
											)}
												{this.canSubscriptionBeUpgraded && this.renderSubscriptionUpgradeButton()}
												{!this.hasPlan && this.renderContactUsButton()}
											</List>
										)}
								</Grid>
							</Grid>

							{!_.isEmpty(cancelledSubscription) && (
								<Grid container direction="row" className={classes.productCTASwitchOrReactivate}>
									<Link
										component="button"
										variant="body2"
										data-tid='reactivate-my-plan-link'
										className={classes.switchOrReactivateLink}
										underline='always'
										onClick={() => this.reactivateMySubscriptionHandler(cancelledSubscription)}
									>
										{localize('subscription-reactivate-my-plan',
											[stripHTML(PACKAGES_CONFIG[cancelledPlanId].title)])}
									</Link>						
								</Grid>
							)}

							{this.hasPlan && activeSubscription.period === SUBSCRIPTION_PERIOD.MONTHLY && (
								<Grid container direction="row" className={classes.productCTASwitchOrReactivate}>
									<Link
										component="button"
										variant="body2"
										data-tid='switch-to-yearly-link'
										className={classes.switchOrReactivateLink}
										underline='always'
										onClick={() => this.switchToYearlyHandler()}
									>
										{localize('subscription-switch-to-yearly-and-save')}
									</Link>						
								</Grid>
							)}
						</Paper>
					</Grid>
					{ownedPerpetualAddons}					
				</Grid>
				<Grid container className={classes.haveQuestionContainer}>
					<Typography className={classNames(classes.haveQuestionsMessage, classes.columnTextSmaller)}>
						{localize('subscription-got-questions-general')}&nbsp;
						<Link
							component="button"
							variant="body2"
							data-tid='have-questions-link'
							className={classes.haveQuestionsLink}
							underline='always'
							onClick={() => this.contactUsHandler()}
						>
							{localize('subscription-contact-us')}
						</Link>
					</Typography>						
				</Grid>
			</Grid>			
		);
		
	}

	//#endregion

	//#region State change handlers

	handlePeriodChange(event) {
		const period = event.target.value;
		this.props.setSubscriptionPeriod(period, false);
		trackDurationChange(period, getTrackingOptions(this.props.company));
	}

	handlePlanCategoryChange(category) {
		// Switch period selector to Annual if a current plan is annual
		this.props.setSubscriptionCategory(category, false);
		trackCategoryChange(category, getTrackingOptions(this.props.company));
	}

	handleSubscriptionViewChange(view) {
		this.props.setSubscriptionView(view, false);
	}

	handleCurrencyChange(event) {
		this.props.setSubscriptionCurrency(_.find(CURRENCIES, { key: event.target.value }).key, false);
	}

	//#endregion

	//#region ChargeBee integration methods

	/**
	 * Proceed ChargeBee Subscription - triggers on package upgrade
	 *
	 * @param {string} plan
	 * @param {string} period
	 * @param {string} currency
	 * @param {bool} upgrade
	 * @param {string} couponSetId
	 * @param {string} couponId
	 * @memberof Subscription
	 */
	proceedChargeBeeSubscription(plan, period, currency, upgrade, couponSetId, couponId, quantity) {

		// Covers two cases:
		// 1. Clear credentials from previous abandoned initial purchase of annual plan where magix discout was applied
		// Otherwise it could be false positive in SubscriptionSuccessful.js > componentDidMount when doing next 
		// purchase of annual plan without magix discout
		// Clears magix credentials when submitting promo/gift form

		clearMagixDiscountCredentials();
		clearFirstOrder();
		// Put this code here because of race condition with paymentRedirectUrl redirect in app.js
		if (this.props.discount.isDiscountApplied && this.props.discount.discountType === DISCOUNT_TYPE.MAGIX &&
			(this.props.discount.appliedProdTypeOfLastValidCombination === MAXIC_DISCOUNT_PROD_TYPE.SUBSCRIPTION &&
				period === SUBSCRIPTION_PERIOD.ANNUAL
				||
				this.props.discount.appliedProdTypeOfLastValidCombination === MAXIC_DISCOUNT_PROD_TYPE.PERPETUAL &&
				period === SUBSCRIPTION_PERIOD.PERPETUAL)) {
			saveMagixDiscountCredentials(this.props.discount.usedMagixEmail, this.props.discount.usedProductSerial);
		}

		const addOnName = MAP_ADDON_TO_LATEST_VERSION[plan];

		const chargebeeItemName = addOnName
			?
			`${addOnName}-${SUBSCRIPTION_PERIOD.PERPETUAL}-${currency}`
			:
			`${plan === SUBSCRIPTION_PLAN.SCALE ? SUBSCRIPTION_PLAN.TEAM_PLUS : plan}-${period}-${currency}`;

		saveCheckoutPlan(`${plan === SUBSCRIPTION_PLAN.SCALE ? SUBSCRIPTION_PLAN.TEAM_PLUS : plan}-${period}-${currency}`);
		saveCheckoutSeatsQuantity(quantity);
		
		const nrOfProductUserOwns = getTotalProductsForCompany(this.props.company);
		nrOfProductUserOwns === 0 && setIsFirstOrder(true);

		const isoCodeLang = i18n.getCurrentLanguage(true);
		let cartLang = null;
		let storageCheckoutLang = null;
		if (isoCodeLang === 'de-DE') {
			cartLang = isoCodeLang;
			storageCheckoutLang = 'de';
		}
		saveCheckoutLang(storageCheckoutLang);

		this.props.createChargeBeeSubscription(
			this.hasPlan,
			chargebeeItemName,
			upgrade,
			undefined,
			couponSetId,
			couponId,
			Boolean(addOnName),
			quantity,
			cartLang
		)
			.then((data) => {

				if (data instanceof AppError) {
					clearMagixDiscountCredentials();

					log.send(data);

					if (data.errorId === ERROR.API_REQUEST_LIMIT_EXCEEDED) {
						this.props.showRateLimitError();
					
					} else if (this.props.isCBPlanExternalRedirect &&
						this.state.shouldStartUpdate) {
						// Error returned from estimation endpoint when 
						// http://localhost:3000/#COMPANY/?chargebee-plan-id=teamplus-annual-usd&cid=DOESNOTEXIST url is used
						// but it could happens also in some other cases when CB returns 13001

						if (_.get(data, 'errorId') ===
							ERROR.THE_NUMBER_OF_THE_USERS_CANNOT_BE_LESS_THAN_THE_NUMBER_OF_USERS_OF_COMPANY && !this.hasPlan) {
							const { title, freeSeatsIncluded } = PACKAGES_CONFIG[plan];

							this.props.couponId && this.props.applyDiscountUsingCouponId(
								this.props.couponId,
								COUPON_TYPE.SEATS,
								true);

							/*
							use freeSeatsIncluded for quantity for direct link
							to avoid THE_NUMBER_OF_THE_USERS_CANNOT_BE_LESS_THAN_THE_NUMBER_OF_USERS_OF_COMPANY error
							or quantity from url params 
							*/
							const useQuantity = Math.max(freeSeatsIncluded, this.props.productQuantity || 1);
							const nonGuestUsers = filterNonGuestUsers(this.props.company.users);

							this.props.showModal('CONFIRMATION_MODAL', {
								title: localize('subscription-confirm-number-of-users-title'),
								message: { __html:
									localize('subscription-confirm-number-of-users-description',
										[nonGuestUsers.length, useQuantity])
								},
								buttons: [
									<Button
										data-tid="confirm-number-of-users-cancel"
										key='confirm-number-of-users-cancel'
										variant='outlined'
										color='primary'
									>
										{localize('go-back')}
									</Button>,
									<Button
										data-tid="confirm-number-of-users-reduce"
										key='confirm-number-of-users-reduce'
										variant='contained'
										color='primary'
										onClick={() => this.handleShowModalInReduceUsersApiErrorWorkflow(
											{plan, period, quantity, upgrade, title, useQuantity, freeSeatsIncluded})
										}
									>
										{localize('reduce-users')}
									</Button>],
								showCouponErrorMessageIfExists: true
							});

						} else {
							this.props.showErrorPopup(data.errorId || ERROR.UNKNOWN);
						}
						
					}
					this.props.hidePreloader();
					return;
				}

				if (data.result && data.result.hostedPage) {
					this.openChargeBeeCheckout(data.result.hostedPage);
				}
			});
	}

	handleShowModalInReduceUsersApiErrorWorkflow(props) {
		this.props.setReduceUsersApiErrorState(props);
	}

	showModalInReduceUsersApiWorkflow() {
		const { plan, period, quantity, upgrade, title, useQuantity, freeSeatsIncluded } = this.props.app.reduceUsersApiState;
		this.props.hideModal();

		this.showReduceUsersModal(
			() => {
				// fetch price after user submits Reduce user modal as by this time fetch()
				// from estimation endpoint should complete
				let {
					checkoutPricePerMonth,
					annualPriceTotal,
					showDiscountForPlan,
					errorLoadingSubscriptionEstimationData,
					planIsTaxed
				} = this.calculateCheckoutData(
					plan === SUBSCRIPTION_PLAN.SCALE ? SUBSCRIPTION_PLAN.TEAM_PLUS : plan,
					period,
					false /*isPerpetual*/,
					quantity);
					
				this.showConfirmChoiceModal(
					() => this.doCheckout(
						plan,
						period,
						upgrade,
						showDiscountForPlan,
						false,// isPerpetual
						// eslint-disable-next-line max-len
						true /*isUserNumberMismatch*/
					),
					title,
					plan,
					useQuantity,
					this.currency,
					period,
					checkoutPricePerMonth,
					annualPriceTotal,
					errorLoadingSubscriptionEstimationData,
					planIsTaxed
				);
			},
			freeSeatsIncluded,
			useQuantity,
			true
		);
	}

	getQuantityIntegerValue(type) {
		return isValidNonZeroQuantity(type === QUANTITY_TYPE.LICENSES ? this.state.licensesQuantity : this.state.seatsQuantity)
			?
			parseInt(type === QUANTITY_TYPE.LICENSES ? this.state.licensesQuantity : this.state.seatsQuantity)
			:
			0;
	}

	getCouponSetId(period, plan) {
		let couponSetId;
		const { 
			discountType,
			couponSetKey,
			isDiscountApplied,
			appliedProdTypeOfLastValidCombination,
			appliedProdCatOfLastValidCombination
		} = this.props.discount;

		// We limit magix discount to annual plans on client side and UPGRADE_POPUP to XC/XC+ packages only excluding desktop+
		if (isDiscountApplied &&
			(discountType === DISCOUNT_TYPE.MAGIX && 
				(appliedProdTypeOfLastValidCombination === MAXIC_DISCOUNT_PROD_TYPE.SUBSCRIPTION &&
					period === SUBSCRIPTION_PERIOD.ANNUAL ||
				appliedProdTypeOfLastValidCombination === MAXIC_DISCOUNT_PROD_TYPE.PERPETUAL &&
					period === SUBSCRIPTION_PERIOD.PERPETUAL)
					||
				discountType === DISCOUNT_TYPE.COUPON_SET_ID)) {
			if (plan && couponSetKey === DISCOUNT_KEY.UPGRADE_POPUP) {
				// Plan is provided only when clicked on Subscribe button
				if (PACKAGES_CONFIG[plan].isCloudSuitePlan) {
					couponSetId = DISCOUNTS_CONFIG[couponSetKey].coupon_set_id;	
				}
			} else if (discountType === DISCOUNT_TYPE.MAGIX && plan && PACKAGES_CONFIG[plan].isPerpetual) {
				// maxic perpetual discount
				const isFallbackProduct = _.get(this.props.crs, 'isFallbackProductReturnedLastValidCombination');

				if (PERPETAUL_PRODUCT_CATEGORY_TO_PACKAGE_MAP[appliedProdCatOfLastValidCombination] === plan ||
					isFallbackProduct) {
					// If user is not owner of specific product (wd, dp or pgd) CRS endpoint returns fallback product,
					// in this case give discount for all perpetual products but
					// using discount specific for each of them (20%, 30%, 40%)

					const couponTier = isFallbackProduct ?
						_.invert(PERPETAUL_PRODUCT_CATEGORY_TO_PACKAGE_MAP)[plan]
						:
						appliedProdCatOfLastValidCombination;

					couponSetId =
						DISCOUNTS_CONFIG[`tier_${couponTier}`].coupon_set_id;
				}
			} else {
				couponSetId = DISCOUNTS_CONFIG[couponSetKey].coupon_set_id;
			}
		}

		return couponSetId;
	}

	getMemberAddonDetailsFromPaymentAccount(plan, period, currency) {

		const addonDetailsFromPaymentAccount = _.get(this.props.companies,
			`currentMemberAddonDetails[${getNonObsoleteMemberAddonForPlan(plan)}-${period}-${currency}]`);

		if (!addonDetailsFromPaymentAccount) return;

		const amountWithoutTaxAndWithoutDiscount = addonDetailsFromPaymentAccount.amountWithoutTaxAndWithoutDiscount;
		const amountWithoutTaxAndWithDiscount = addonDetailsFromPaymentAccount.amountWithoutTaxAndWithDiscount;
		const discountAmountWithoutTax = addonDetailsFromPaymentAccount.discountAmountWithoutTax;
	
		let discountPercent;
		if (discountAmountWithoutTax && amountWithoutTaxAndWithoutDiscount && amountWithoutTaxAndWithDiscount) {
			discountPercent = Math.ceil((1-amountWithoutTaxAndWithDiscount/amountWithoutTaxAndWithoutDiscount) * 100);
		}

		return {
			...addonDetailsFromPaymentAccount,
			discountPercent,
			hasDiscount: Boolean(discountAmountWithoutTax)
		};
	}

	fetchSubscriptionEstimate(skipDiscount, onlyActivePlan) {
		const subscriptionEstimationUrl = this.getSubscriptionEstimationUrl(skipDiscount, onlyActivePlan);
		const planForSubscriptionEstimation = this.getPlanForSubscriptionEstimation();

		const { couponSetId, couponId, discountType, couponSetKey } = this.getCouponDataForSubscriptionEstimate();
		const fn = onlyActivePlan ? this.props.getSubscriptionEstimation : this.getSubscriptionEstimationDebounced;

		subscriptionEstimationUrl && 
		fn(
			subscriptionEstimationUrl,
			planForSubscriptionEstimation,
			discountType,
			couponSetKey,
			onlyActivePlan ? null : !couponSetId && couponId,
			onlyActivePlan ? null : couponSetId,
			this.isPerpetualOverviewMode || this.isPerpetualPeriodSelected
				?
				COUPON_TYPE.LICENSES
				:
				COUPON_TYPE.SEATS,			
			onlyActivePlan);
	}

	getPlanForSubscriptionEstimation() {
		if (this.props.currentPlanId) {
			const { plan, period } = convertPlanIdIntoSubscription(this.props.currentPlanId);
			return `${plan}-${period}-${CB_API_FETCH_CURRENCY}`;
		} else {
			return 'all';
		}
	}

	getSubscriptionEstimationUrl(skipDiscount, onlyActivePlan) {
		const {
			discountType,
			isDiscountApplied,
			couponSetKey,
			couponAppliedWithoutValidation,
			isResponsePendingFromEstimationEndpoint
		} = this.props.discount;

		const { couponSetId, couponId } = this.getCouponDataForSubscriptionEstimate();
		
		let quantityOfMembers;
		const paidQuantity = getMembersPaidQuantity(this.props.company);
		if (onlyActivePlan) {
			quantityOfMembers = 0;
		} else if (this.hasPlan && paidQuantity > 0) {
			quantityOfMembers = getMembersPaidQuantity(this.props.company) +
                PACKAGES_CONFIG[this.activePlan].freeSeatsIncluded;
		} else if (this.hasPlan && paidQuantity === 0) {
			quantityOfMembers = filterNonGuestUsers(this.props.company.users).length >
                PACKAGES_CONFIG[this.activePlan].freeSeatsIncluded ? 
				filterNonGuestUsers(this.props.company.users).length : 0;
		} else {
			quantityOfMembers = this.state.seatsQuantity;
		}

		const skipActivePlan = !onlyActivePlan && this.hasPlan &&
			(isDiscountApplied || couponAppliedWithoutValidation) &&
			(
				(couponAppliedWithoutValidation && isResponsePendingFromEstimationEndpoint) ||
				discountType === DISCOUNT_TYPE.COUPON_ID ||
				discountType === DISCOUNT_TYPE.MAGIX ||
				discountType === DISCOUNT_TYPE.COUPON_SET_ID && couponSetKey === DISCOUNT_KEY.UPGRADE_POPUP
			);

		const fetchSubscriptionEstimatesForPlans = this.getPlanIdsForSubscriptionEstimate(
			this.props.currentPlanId,
			skipActivePlan,
			onlyActivePlan
		);

		if (_.isEmpty(fetchSubscriptionEstimatesForPlans)) return;

		let couponSetIdQuery = '';
		let couponIdQuery = '';
		if (!onlyActivePlan && !skipDiscount) {
			couponSetId && (couponSetIdQuery = `&couponSetId=${encodeURIComponent(couponSetId)}`);
			!couponSetId && couponId && (couponIdQuery = `&couponId=${encodeURIComponent(couponId)}`);
		}

		const plansQueryString = fetchSubscriptionEstimatesForPlans.reduce(
			(accumulator, currentValue) => `${accumulator}&planIds[]=${currentValue}`, 
		'');
		
		const { subscription: pastSubscription } = getSubscriptionsAndAddons(this.props.company, true);
		const companyIdforEndpoint = !_.isEmpty(pastSubscription)
			?
			`${this.props.selectedCompanyId}/`
			:
			'';

		// eslint-disable-next-line max-len 
		return `/companies/subscription/${companyIdforEndpoint}createSubscriptionEstimation?quantityOfMembers=${quantityOfMembers}${plansQueryString}${couponIdQuery}${couponSetIdQuery}`;
	}

	getCouponDataForSubscriptionEstimate() {
		const {
			discountType,
			couponSetKey,
			isDiscountApplied,
			couponAppliedWithoutValidation,
			userSuppliedPromoCode
		} = this.props.discount;
		
		const couponSetId = this.getCouponSetId(this.state.period);

		let couponId = null;
		if (isDiscountApplied && discountType === DISCOUNT_TYPE.COUPON_ID) {
			couponId = this.props.discount.couponId;
		} else if (couponAppliedWithoutValidation) {
			couponId = userSuppliedPromoCode;
		} 

		return { couponSetId, couponId, discountType, couponSetKey };
	}

	getPlanIdsForSubscriptionEstimate(selectedPlanId, skipActivePlan, onlyActivePlan) {
		const result = [];
		if (selectedPlanId) {
			const { plan, period } = convertPlanIdIntoSubscription(selectedPlanId);

			if (onlyActivePlan) {
				result.push(`${plan}-${period}-${CB_API_FETCH_CURRENCY}`);
			} else {
				// Get price for current plan
				// skip current plan if cap is not opened with CID query parameter as in this case it will be missing
				// price of current active subscription
				if (!skipActivePlan) {
					result.push(`${plan}-${period}-${CB_API_FETCH_CURRENCY}`);
				}

				// Upgrade monthly to annual; there is no upgrade to annual for RE plans
				if (!PACKAGES_CONFIG[plan].isRealEstatePlan && period === SUBSCRIPTION_PERIOD.MONTHLY) {
					result.push(`${plan}-${SUBSCRIPTION_PERIOD.ANNUAL}-${CB_API_FETCH_CURRENCY}`);
				}

				// Upgrade to other plans in selected period
				SUBSCRIPTION_PLAN_UPGRADE_OPTIONS[plan].forEach(upgradeOptionPlan => {
					if (!PACKAGES_CONFIG[upgradeOptionPlan].isPerpetual && !PACKAGES_CONFIG[upgradeOptionPlan].doesNotExistInCB) {
						result.push(`${upgradeOptionPlan}-${period}-${CB_API_FETCH_CURRENCY}`);
						if (!PACKAGES_CONFIG[upgradeOptionPlan].isRealEstatePlan && period === SUBSCRIPTION_PERIOD.MONTHLY) {
							result.push(`${upgradeOptionPlan}-${SUBSCRIPTION_PERIOD.ANNUAL}-${CB_API_FETCH_CURRENCY}`);
						}
					}
				});
			}

		} else if (this.props.company) {
			let planKeys;
			let periodKeys;

			if (showNewRealEstateUI(this.props.company, this.props.app.isDesktopTrial, this.props.app.isReAccessNoIndustry)) {
				planKeys = [SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT, SUBSCRIPTION_PLAN.BROKERAGES];
				periodKeys = [SUBSCRIPTION_PERIOD.MONTHLY];
			} else {
				planKeys = Object.keys(_.omit(PACKAGES_CONFIG, SUBSCRIPTION_PLAN.SCALE, SUBSCRIPTION_PLAN.ENTERPRISE));
				periodKeys = [SUBSCRIPTION_PERIOD.MONTHLY, SUBSCRIPTION_PERIOD.ANNUAL];
			}

			planKeys.forEach(planKey => {
				if (!PACKAGES_CONFIG[planKey].isPerpetual) {
					periodKeys.forEach(periodKey => {
						if (!(PACKAGES_CONFIG[planKey].isRealEstatePlan && periodKey === SUBSCRIPTION_PERIOD.ANNUAL)) {
							result.push(`${planKey}-${periodKey.toLowerCase()}-${CB_API_FETCH_CURRENCY}`);	
						}
					});				
				}
			});
		}

		return _.uniq(result);
	}

	shouldShowAppliedDiscountForCurrentPackage(
		plan,
		period,
		currency,
		couponConfig,
		discountType,
		couponSetKey,
		couponId,
		isMemberAddon,
		appliedProdTypeOfLastValidCombination,
		appliedProdCatOfLastValidCombination) {

		// We limit magix discount to annual plans on client side and UPGRADE_POPUP to XC/XC+ packages only excluding desktop+
		if (discountType === DISCOUNT_TYPE.MAGIX && 
			(appliedProdTypeOfLastValidCombination === MAXIC_DISCOUNT_PROD_TYPE.SUBSCRIPTION &&
				period === SUBSCRIPTION_PERIOD.ANNUAL
				||
				appliedProdTypeOfLastValidCombination === MAXIC_DISCOUNT_PROD_TYPE.PERPETUAL &&
				period === SUBSCRIPTION_PERIOD.PERPETUAL)			
			||
			discountType === DISCOUNT_TYPE.COUPON_SET_ID) {
			
			if (couponSetKey === DISCOUNT_KEY.UPGRADE_POPUP) {
				return PACKAGES_CONFIG[plan].isCloudSuitePlan;
			} else {
				if (appliedProdTypeOfLastValidCombination === MAXIC_DISCOUNT_PROD_TYPE.PERPETUAL &&
				period === SUBSCRIPTION_PERIOD.PERPETUAL) {

					if (plan === SUBSCRIPTION_PLAN.PHOTO_PERPETUAL &&
							appliedProdCatOfLastValidCombination === PRODUCT_CATEGORY.PHOTO ||
						plan === SUBSCRIPTION_PLAN.WEB_PERPETUAL &&
							appliedProdCatOfLastValidCombination === PRODUCT_CATEGORY.WEB ||
						plan === SUBSCRIPTION_PLAN.DESIGNER_PERPETUAL &&
							appliedProdCatOfLastValidCombination === PRODUCT_CATEGORY.DESIGNER ||
							_.get(this.props.crs, 'isFallbackProductReturnedLastValidCombination')
					) {
						return true;
					} else {
						return false;
					}

				} else {
					// magix discount for subscription plans
					const cbProductIds = _.get(couponConfig, 'plan_ids');
					if (cbProductIds && [DISCOUNT_KEY.TIER1, DISCOUNT_KEY.TIER2, DISCOUNT_KEY.TIER3].includes(couponSetKey)) {

						return cbProductIds.some(allowedCbProductId => {
							const { plan: allowed_plan, period: allowed_period, currency: allowed_currency } =
								convertPlanIdIntoSubscription(allowedCbProductId);

							return plan === allowed_plan && period === allowed_period && currency === allowed_currency;
						});

					} else {
						return false;
					}
				}
			}

		} else if (discountType === DISCOUNT_TYPE.COUPON_ID) {
			if (couponId === DISCOUNTS_CONFIG[DISCOUNT_KEY.UPGRADE_POPUP].coupon_set_id) {
				return PACKAGES_CONFIG[plan].isCloudSuitePlan;
			} else {

				const sourceObject = PACKAGES_CONFIG[plan].isPerpetual || isMemberAddon ? 'addon' : 'plan';

				if (PACKAGES_CONFIG[plan].isPerpetual && _.get(couponConfig, 'duration_type') === 'forever') {
					return false;
				} else {
					if (_.get(couponConfig, 'apply_on') === 'invoice_amount') {
						return true;
					} else if (_.get(couponConfig, 'apply_on') === 'each_specified_item') {
						if (_.get(couponConfig, `${sourceObject}_constraint`) === 'all') {
							return true;
						} else if (_.get(couponConfig, `${sourceObject}_constraint`) === 'specific') {
				

							const cbProductIds = _.get(couponConfig, `${sourceObject}_ids`);
							return cbProductIds.some(allowedCbProductId => {
								const { plan: allowed_plan, period: allowed_period, currency: allowed_currency } = 
									convertPlanIdIntoSubscription(allowedCbProductId);

								const latestPlan = PACKAGES_CONFIG[plan].isPerpetual 
									?
									MAP_ADDON_TO_LATEST_VERSION[plan]
									:
									isMemberAddon ? getNonObsoleteMemberAddonForPlan(plan) : plan;

								return latestPlan === allowed_plan && period === allowed_period && currency === allowed_currency;
							});
				
						} else {
							//constraint = not_applicable
							return false; 
						}
					} else {
						//not configured
						return false; 			
					}
				}

			}
		}
	}

	/**
	 * Start Subscription upgrade process
	 *
	 * @param {string} planId for example, 'team-annual-usd'
	 * @returns
	 * @memberof Subscription
	 */
	shouldStartSubscriptionUpgrade(planId) {
		const { activeSubscription } = this.state;
		const { plan, period, currency } = convertPlanIdIntoSubscription(planId);

		if ([STANDARD_OVERVIEW_PLAN_ID, REAL_ESTATE_OVERVIEW_PLAN_ID].includes(planId)) {
			return;
		}

		// Check if we can open Chargebee for an upgrade, if not we need to show the standard subscription page
		if (activeSubscription.plan !== undefined) {

			if (activeSubscription.plan === plan &&
				activeSubscription.period === SUBSCRIPTION_PERIOD.MONTHLY &&
				period === SUBSCRIPTION_PERIOD.ANNUAL &&
				activeSubscription.currency === currency) {
				// allow upgrade from monthly to  yearly
				return true;
			} else if (
				// requesting to subscribe for the same plan they already have, or downgrade
				!SUBSCRIPTION_PLAN_UPGRADE_OPTIONS[activeSubscription.plan].
					includes(plan === SUBSCRIPTION_PLAN.SCALE ? SUBSCRIPTION_PLAN.TEAM_PLUS : plan) ||
					// requesting change from annual to monthly
					(activeSubscription.period === SUBSCRIPTION_PERIOD.ANNUAL && period === SUBSCRIPTION_PERIOD.MONTHLY) ||
				// requesting to use a different currency
				activeSubscription.currency !== currency
			) {
				return;
			}
		}

		return true;
	}

	/**
	 * Get the current subscription plan and trigger ChargeBee portal popup
	 *
	 * @memberof Subscription
	 */
	showSubscriptionDetails() {
		const { subscription: activeSubscription } = getSubscriptionsAndAddons (this.props.company, false);

		let plan, period, currency;

		if (activeSubscription) {
			({ plan, period, currency } = convertPlanIdIntoSubscription(activeSubscription.planId));
		} else {
			const { subscription: cancelledSubscription } = getSubscriptionsAndAddons (this.props.company, true);
			if (!_.isEmpty(cancelledSubscription)) {
				({ plan, period, currency } = convertPlanIdIntoSubscription(cancelledSubscription.planId));
			}
		}

		if (plan && period && currency) {
			this.props.createChargeBeeSession(`${plan}-${period}-${currency}`)
				.then((data) => {
					if (data instanceof AppError) {

						log.send(data);

						if (data.errorId === ERROR.API_REQUEST_LIMIT_EXCEEDED) {
							this.props.showRateLimitError();
						}

						return;
					}

					data.result && this.openChargeBeePortal(data.result.portal_session);
				});
		}
	}

	/**
	 * Go to Cloud suite or Creative tools category
	 *
	 * @memberof Subscription
	 */
	handleUpgradePlan(showPeriod) {
		const { activeSubscription } = this.state;
		const { plan, period } = activeSubscription;
		
		if (!showPeriod &&
			activeSubscription.plan === SUBSCRIPTION_PLAN.TEAM_PLUS &&
			activeSubscription.period === SUBSCRIPTION_PERIOD.MONTHLY) {
			showPeriod = SUBSCRIPTION_PERIOD.ANNUAL;
		}

		let showCategory;
		if (plan) {
			showCategory = this.getCategoryOfUpgradeOptionForActivePlan(plan, period);
		} else if (this.props.app.isDesktopApp) {
			// For desktop app, if category selected is shown switch to CREATIVE_TOOLS,
			// otherwise switch to single category whatever is defined by this.category
			showCategory = this.shouldRenderCategorySelector ? PLAN_CATEGORIES.CREATIVE_TOOLS : this.category;
		} else {
			showCategory = this.props.discount.isDiscountApplied && this.props.discount.discountType === DISCOUNT_TYPE.MAGIX
				?
				PLAN_CATEGORIES.CREATIVE_TOOLS
				:
				PLAN_CATEGORIES.CLOUD_SUITE;
		}

		if (this.isPerpetualOverviewMode || this.isPlusOverviewMode) {
			this.setState({
				pendingUpgradePlanClicked: true
			}, () => {
				this.props.history.push({
					pathname: getRoute(SUBSCRIPTION, this.props.company.id),
					state: { preselectCategory: showCategory }
				});
			});			
		} else {
			this.setState({
				pendingUpgradePlanClicked: true
			}, () => {
				this.props.setAppStateParams(
					{
						subscriptionView: SUBSCRIPTION_VIEW.PURCHASE_OPTIONS, 
						subscriptionCategory: showCategory,
						...(showPeriod && {subscriptionPeriod: showPeriod})
					}
				);
			});	
		}
	}

	
	/**
	 * Reactivate my plan handler
	 *
	 * @memberof Subscription
	 */	
	reactivateMySubscriptionHandler(cancelledSubscription) {
		let { plan, period, currency } = convertPlanIdIntoSubscription(cancelledSubscription.planId);

		if (!Object.values(SUBSCRIPTION_PLAN).includes(plan)) {
			// Cancelled subscriptions are not migrated, we upgrade them to Scale
			plan = SUBSCRIPTION_PLAN.TEAM_PLUS;
		}

		const showCategory = PACKAGES_CONFIG[plan].isCloudSuitePlan
			?
			PLAN_CATEGORIES.CLOUD_SUITE
			:
			PLAN_CATEGORIES.CREATIVE_TOOLS;

		const defaultQuantity = this.getDefaultQuantity(this.props, QUANTITY_TYPE.SEATS);
		
		this.setState({
			pendingReactivatePlanId: `${plan}-${period}-${currency}`,
			pendingReactivateQuantity: defaultQuantity,
			pendingReactivatePeriod: period,
		}, () => {
			
			this.props.setSeatsQuantity(defaultQuantity);
			this.props.setAppStateParams(
				{
					subscriptionView: SUBSCRIPTION_VIEW.PURCHASE_OPTIONS,
					subscriptionPeriod: period,
					subscriptionCategory: showCategory
				}
			);		
		});
	}

	handleSwitchToPlansFromBuyMoreLicensesPopup() {
		this.props.hideModal();

		this.props.setAppStateParams(
			{
				subscriptionView: SUBSCRIPTION_VIEW.PURCHASE_OPTIONS,
				subscriptionPeriod: SUBSCRIPTION_PERIOD.ANNUAL,
				subscriptionCategory: PLAN_CATEGORIES.CLOUD_SUITE				
			}
		);		

		if (this.props.discount.isDiscountApplied &&
			this.props.discount.couponType === COUPON_TYPE.LICENSES) {
			this.props.changeCouponType(COUPON_TYPE.SEATS);
		}
	}

	getCategoryOfUpgradeOptionForActivePlan(plan, period) {
		let showCategory;
		if ([SUBSCRIPTION_PLAN.WEB, SUBSCRIPTION_PLAN.PHOTO].includes(plan)) {
			showCategory = PLAN_CATEGORIES.CREATIVE_TOOLS;
		} else if (plan === SUBSCRIPTION_PLAN.DESIGNER) {
			// designer can only be upgraded to Scale (cloud) option
			showCategory = period === SUBSCRIPTION_PERIOD.MONTHLY
				?
				PLAN_CATEGORIES.CREATIVE_TOOLS
				:
				PLAN_CATEGORIES.CLOUD_SUITE;
		} else {
			showCategory = PLAN_CATEGORIES.CLOUD_SUITE;
		}
		return showCategory;
	}

	/**
	 * Open ChargeBee portal popup with details of company's subscription
	 *
	 * @param {*} portalSession
	 * @returns
	 * @memberof Subscription
	 */
	openChargeBeePortal(portalSession) {
		if (!portalSession) return;
		if (_.isEmpty(ChargeBee)) {
			this.handleCBnotLoaded();
			return;
		}
		ChargeBee.setPortalSession(portalSession);
		const cbPortal = ChargeBee.createChargebeePortal();
		cbPortal.open();
	}


	/**
	 * Open ChargeBee Checkout popup to upgrade from Pro to Team subscription
	 *
	 * @param {JSON} hostedPage JSON object from Middleware
	 * @memberof Subscription
	 */
	openChargeBeeCheckout(hostedPage) {
		if (!hostedPage) return;
		if (_.isEmpty(ChargeBee)) {
			this.handleCBnotLoaded();
			return;
		}

		ChargeBee.openCheckout({
			hostedPage: () => { return Promise.resolve(hostedPage); },
			loaded: () => {
				this.setState({
					willProceedToCheckout: false
				});
			},
			success: () => {
				this.props.showChargebeeLoader();
				ChargeBee.closeAll();
			},
			error: function (error) {
				const nError = new AppError({
					message: 'openChargeBeeCheckout.hostedPage failed',
					errorId: ERROR.UNKNOWN,
					originalError: error,
					visualisers: { feature: 'CHARGEBEE' }
				});
				log.send(nError);
			}
		});
	}

	handleCBnotLoaded() {
		this.props.setErrorId(ERROR.CB_NOT_LOADED);

		const nError = new AppError({
			message: 'ChargeBee library could not be loaded',
			errorId: ERROR.CB_NOT_LOADED,
			visualisers: { feature: 'CHARGEBEE' }
		});
		log.send(nError);

	}

	toggleSeeAllProducts() {
		const isCloudPackagePreselected = [SUBSCRIPTION_PLAN.SCALE, SUBSCRIPTION_PLAN.ESSENTIAL]
			.includes(this.preselectedPackage);

		if (isCloudPackagePreselected) {

			this.setState({
				pendingSeeAllProductsPlanClicked: true,
				preselectPackage: false
			}, () => {

				this.props.setAppStateParams(
					{
						subscriptionView: SUBSCRIPTION_VIEW.PURCHASE_OPTIONS,
						subscriptionPeriod: SUBSCRIPTION_PERIOD.ANNUAL,
						subscriptionCategory: PLAN_CATEGORIES.CLOUD_SUITE
					}
				);

				this.props.setAllPackagesShownFlag(true);
			});
		} else {
			this.setState({ preselectPackage: false });
			this.props.setAllPackagesShownFlag(true);
		}
	}

	handleViewCurrentPlan() {
		this.handleSubscriptionViewChange(SUBSCRIPTION_VIEW.CURRENT_PRODUCTS);
	}

	contactUsHandler(message) {
		openIntercomChat(message, true, this.props.showErrorPopup);
	}

	switchToYearlyHandler() {
		this.handleUpgradePlan(SUBSCRIPTION_PERIOD.ANNUAL);
	}

	handleUpdateLastPageVisited() {

		if (this.props.isStandardProductOverview &&
			(this.props.app.wasPlusOverviewPageVisited || this.props.app.wasPerpetualOverviewPageVisited)) {
			this.props.clearSubscriptionState();
		}

		if (this.props.isStandardProductOverview &&
			this.props.app.wasPerpetualOverviewPageVisited &&
			this.props.discount.isDiscountApplied &&
			this.props.discount.couponType === COUPON_TYPE.LICENSES) {
			//SUBSCRIPTION_VIEW
			this.props.changeCouponType(COUPON_TYPE.SEATS);
		}

		if (this.isCurrentProductsView &&
			this.props.discount.isDiscountApplied &&
			this.props.discount.couponType === COUPON_TYPE.SEATS) {
			// When going from One-Time-Checkbox to Buy more licenses coupon is not applied on checkout
			this.props.changeCouponType(COUPON_TYPE.LICENSES);
		}

		// when going from One-Time (perpetual) checkbox with applied perpetual coupon to Monthly/Annually checkbox
		const isPerpetualCheckbox = this.isPurchaseOptionsView && this.isPerpetualPeriodSelected && !this.isPerpetualOverviewMode;
		if (this.isPurchaseOptionsView &&
			this.props.isStandardProductOverview &&
			this.props.discount.isDiscountApplied &&
			this.props.discount.couponType === COUPON_TYPE.LICENSES &&
			!isPerpetualCheckbox) {
			this.props.changeCouponType(COUPON_TYPE.SEATS);
		}
	}

	clearInvalidFieldsForBuyMorePopup(resetSeatsQuantityToDefault, clearDiscountField) {
		if (this.props.discount.couponCodeFetchSuccess === false || clearDiscountField) {
			// Clear coupon applied in background if it's invalid
			this.props.clearAppliedDiscount();
		}

		const currentLicensesQuantityValue = this.getQuantityInputValue(QUANTITY_TYPE.LICENSES);
		if (!isValidNonZeroQuantity(currentLicensesQuantityValue)) {
			// If quantity values in invalid in Subscription page, reset it in Extra licenses modal
			this.props.setLicensesQuantity(this.getDefaultQuantity(this.props, QUANTITY_TYPE.LICENSES));
		}

		
		const currentSeatsQuantityValue = this.getQuantityInputValue(QUANTITY_TYPE.SEATS);
		const defaultSeatsQuantity = this.getDefaultQuantity(this.props, QUANTITY_TYPE.SEATS);
		if (!isValidNonZeroQuantity(currentSeatsQuantityValue) ||
			(resetSeatsQuantityToDefault && currentSeatsQuantityValue !== defaultSeatsQuantity)) {
			// If quantity values in invalid in Subscription page, reset it in Extra licenses modal
			this.props.setSeatsQuantity(this.getDefaultQuantity(this.props, QUANTITY_TYPE.SEATS));
		}
	}

	handlePurchaseMoreLicenses(plan) {
		const {
			isDiscountApplied,
			discountType,
			couponId,
			couponSetKey,
			couponConfig,
			appliedProdTypeOfLastValidCombination,
			appliedProdCatOfLastValidCombination
		} = this.props.discount;

		const showDiscount = isDiscountApplied &&
				this.shouldShowAppliedDiscountForCurrentPackage(
						plan,
						SUBSCRIPTION_PERIOD.PERPETUAL,
						this.currency.key,
						couponConfig,
						discountType,
						couponSetKey,
						couponId,
						false,
						appliedProdTypeOfLastValidCombination,
						appliedProdCatOfLastValidCombination);

		this.clearInvalidFieldsForBuyMorePopup(null, !showDiscount);

		const modalProps = {
			cb: (hasCouponError) => {

				const {
					isDiscountApplied,
					discountType,
					couponType
				} = this.props.discount;

				const useDiscount = !hasCouponError && isDiscountApplied &&
					couponType === COUPON_TYPE.LICENSES &&
					discountType === DISCOUNT_TYPE.COUPON_ID;

				this.doCheckout(
					plan,
					SUBSCRIPTION_PERIOD.PERPETUAL,
					false /*isUpgrade*/,
					useDiscount,
					true /*isPerpetual*/,
					false /*isUserNumberMismatch*/);
			},
			type: BUY_MORE_POPUP_TYPE.LICENSES,
			plan,
			currency: this.currency,
			getQuantityInputValue: this.getQuantityInputValue,
			renderInfoTooltip: this.renderInfoTooltip,
			shouldShowAppliedDiscountForCurrentPackage: this.shouldShowAppliedDiscountForCurrentPackage,
			getNumberOfQualifyingProductsForCoupon: this.getNumberOfQualifyingProductsForCoupon,
			getQualifyingProductsForCoupon: this.getQualifyingProductsForCoupon,
			addVersionToTitle: this.addVersionToTitle,
			getDiscountPrice: this.getDiscountPrice,
			clearInvalidFieldsForBuyMorePopup: this.clearInvalidFieldsForBuyMorePopup,
			contactUsHandler: this.contactUsHandler,
			handleSwitchToPlansFromBuyMoreLicensesPopup: this.handleSwitchToPlansFromBuyMoreLicensesPopup,
			routeToOneTimeCheckBoxAndShowDiscountPopup: this.routeToOneTimeCheckBoxAndShowDiscountPopup
		};
				
		this.props.showModal('BUY_MORE_LICENSES_OR_SEATS', modalProps);
	}

	buyMoreSeatsCallback() {
		const targetUsersPayingQuantity = getMembersPaidQuantity(this.props.company) +
		PACKAGES_CONFIG[this.activePlan].freeSeatsIncluded +
			parseInt(this.getQuantityInputValue());

		this.props.purchaseSeats(this.getQuantityInputValue(), targetUsersPayingQuantity);
	}

	handleBuyMoreSeats(plan, period) {
		this.clearInvalidFieldsForBuyMorePopup(true);

		const modalProps = {
			cb: this.buyMoreSeatsCallback,
			type: BUY_MORE_POPUP_TYPE.SEATS,
			plan,
			period,
			currency: this.currency,
			getQuantityInputValue: this.getQuantityInputValue,
			renderInfoTooltip: this.renderInfoTooltip,
			nrOfNonGuestUsers: filterNonGuestUsers(this.props.company.users).length,
			clearInvalidFieldsForBuyMorePopup: this.clearInvalidFieldsForBuyMorePopup
		};
				
		this.props.showModal('BUY_MORE_LICENSES_OR_SEATS', modalProps);		
	}

	updatePendingSubscription() {

		const pendingSubscriptionSettingsValue = _.get(this.props.company, 'settings.pendingSubscription');

		if (this.props.currentPlanId &&
			pendingSubscriptionSettingsValue &&
			this.props.currentPlanId === pendingSubscriptionSettingsValue) {
			this.setState({
				pendingSubscription: false,
				pendingSeatsQuantity: false
			});

			this.deleteSavedPendingSubscription();
		}

		if (pendingSubscriptionSettingsValue) {
			setTimeout(() => {
				this.deleteSavedPendingSubscription();
			}, CLEAR_PENDING_SUBSCRIPTION_TIMEOUT);
		}
	}

	deleteSavedPendingSubscription() {
		this.props.writeCompanySettings({ pendingSubscription: null, pendingSeatsQuantity: null });
	}

	changeRoute(props) {
		this.setState({
			pendingRouteChange: true
		}, () => {
			this.props.history.push(props);
		});	
	}

	//#endregion

	//#region Getters
	getCancellationDate() {
		const { subscription } = getSubscriptionsAndAddons(this.props.company);
		let cancellationDate;
		if (this.hasPlan) {
			if (subscription.cancellationPending && subscription.cancelledAt) {
				cancellationDate = (new Date(subscription.cancelledAt))
					.toLocaleDateString(i18n.getCurrentLanguage(true), localeDateStringOptions);
			}
		}
		return cancellationDate;
	}

	getNextBillingDate() {
		const { subscription } = getSubscriptionsAndAddons(this.props.company);
		let billingNextDate;
		if (this.hasPlan) {
			if (subscription.nextBillingAt && !subscription.cancellationPending) {
				billingNextDate = (new Date(subscription.nextBillingAt))
					.toLocaleDateString(i18n.getCurrentLanguage(true), localeDateStringOptions);
			}
		}
		return billingNextDate;
	}

	// Check if there is active subscription plan
	getQuantityInputValue(type) {
		return type === QUANTITY_TYPE.LICENSES ? this.state.licensesQuantity : this.state.seatsQuantity;
	}

	get hasPlan() {
		const planId = _.get(this.state, 'activeSubscription.plan');
		return planId !== undefined;
	}

	get pendingSubscription() {
		return _.get(this.state, 'pendingSubscription');
	}

	get pendingSeatsQuantity() {
		return _.get(this.state, 'pendingSeatsQuantity');
	}

	// Get active plan
	get activePlan() {
		const { activeSubscription: { plan } } = this.state;
		return plan;
	}

	// Check if the current plan is Essential
	get isEssentialPlan() {
		const { activeSubscription: { plan } } = this.state;
		return plan === SUBSCRIPTION_PLAN.ESSENTIAL;
	}

	// Check if the current plan is Scale
	get isScalePlan() {
		const { activeSubscription: { plan } } = this.state;
		return plan === SUBSCRIPTION_PLAN.TEAM_PLUS;
	}

	// Check if the current plan has monthly payment period
	get isMonthlyPlan() {
		const { activeSubscription: { period } } = this.state;
		return period === SUBSCRIPTION_PERIOD.MONTHLY;
	}

	// Check if the current plan has annual payment period
	get isAnnualPlan() {
		const { activeSubscription: { period } } = this.state;
		return period === SUBSCRIPTION_PERIOD.ANNUAL;
	}

	// Check if the current period selector is annual
	get isAnnualPeriodSelected() {
		return this.period === SUBSCRIPTION_PERIOD.ANNUAL;
	}

	// Check if the current period selector is perpetual
	get isPerpetualPeriodSelected() {
		return this.period === SUBSCRIPTION_PERIOD.PERPETUAL;
	}

	// Check if the plans category selector is Cloud Suite
	get isCloudSuiteCategory() {
		return this.category === PLAN_CATEGORIES.CLOUD_SUITE;
	}

	// Check if the tab selector is Your Producs
	get isCurrentProductsView() {
		return this.subscriptionView === SUBSCRIPTION_VIEW.CURRENT_PRODUCTS;
	}

	// Check if the tab selector is Purchase Options
	get isPurchaseOptionsView() {
		return this.subscriptionView === SUBSCRIPTION_VIEW.PURCHASE_OPTIONS;
	}

	// Check if the plans category selector is Creative Tools
	get isCreativeToolsCategory() {
		return this.category === PLAN_CATEGORIES.CREATIVE_TOOLS;
	}

	// Get the current value from payment period selector
	get period() {
		const { period } = this.state;
		return period;
	}

	// Get the current value from currency selector
	get currency() {
		return _.find(CURRENCIES, { key: this.state.currency });
	}

	// Get the current value from plans category selector
	get category() {
		const { category } = this.state;
		return category;
	}

	// Get the current value from subscriptionView selector
	get subscriptionView() {
		const { subscriptionView } = this.state;
		return subscriptionView;
	}	

	// Get if the Subscription page is opened in the Plus Overview Mode
	get isPlusOverviewMode() {
		const { plusOverview } = this.props;
		return plusOverview;
	}

	// Get if the Subscription page is opened in the Perpetual Overview Mode
	get isPerpetualOverviewMode() {
		const { perpetualOverview } = this.props;
		return perpetualOverview;
	}

	get preselectedPackage() {
		const { productName, magixCat } = this.props;

		let result;
		if (productName) {
			if (!(result = SUBSCRIPTION_PLAN[this.props.productName.toUpperCase()])) {
				result = PRODUCT_PREFIX_TO_PACKAGE_MAP[this.props.productName];
			}
		} else if (magixCat) {
			result = PRODUCT_CATEGORY_TO_PACKAGE_MAP[this.props.magixCat];
		}
		return result;
	}	

	//#endregion

	//#region Rendering conditions

	get shouldRenderPlanBoxes() {
		const { perpetualAddons } = getSubscriptionsAndAddons(this.props.company);

		// Don't render Enterprise on plus-overview route
		// /* temporarily disable */ if (this.isScalePlan && this.isAnnualPlan && this.isPlusOverviewMode) return false;

		const { activeSubscription: { plan } } = this.state;
		if (plan === SUBSCRIPTION_PLAN.DESIGNER && this.isAnnualPlan && this.isPlusOverviewMode) return false;

		// only scale unlimited has no further upgrade options
		return !(this.isScalePlan && this.props.company.hasUnlimitedTeamSubscription && !this.isPerpetualOverviewMode) ||
			!_.isEmpty(perpetualAddons);
	}

	get shouldRenderCategorySelector() {
		// Always hide if the Subscription page is opened in the Plus Overview Mode
		if (this.isPlusOverviewMode || this.isPerpetualOverviewMode) {
			return false;
		}

		if (this.state.preselectPackage && !this.props.app.showAllPackages) {
			return false;
		}

		// No active subscription or available upgrade options are in both cloud and desktop categories
		//getPlansToRender(onlySelectedCategory, showMonthlyToYearlyUpgrade, onlyPreselected
		const plansToRender = this.getPlansToRender(false, true, false);

		let hasCloudSuiteUpgradeTab = false;
		let hasCreativeToolsUpgradeTab = false;

		plansToRender.every(planId => {
			
			if (PACKAGES_CONFIG[planId].isCloudSuitePlan) {
				hasCloudSuiteUpgradeTab = true;
			}
			if (PACKAGES_CONFIG[planId].isCreativeToolsPlan) {
				hasCreativeToolsUpgradeTab = true;
			}

			return !hasCloudSuiteUpgradeTab || !hasCreativeToolsUpgradeTab;
		});

		return !this.hasPlan ||
		(hasCloudSuiteUpgradeTab && hasCreativeToolsUpgradeTab &&
			!this.areCloudOnlyPlans(plansToRender) && !this.areDesktopOnlyPlans(plansToRender));
	}

	get shouldPreselectPackage() {
		return this.state.preselectPackage && !this.props.app.showAllPackages;
	}

	areCloudOnlyPlans(plans) {
		const desktopPackages = [
			SUBSCRIPTION_PLAN.WEB,
			SUBSCRIPTION_PLAN.DESIGNER,
			SUBSCRIPTION_PLAN.PHOTO,
			SUBSCRIPTION_PLAN.PHOTO_PERPETUAL,
			SUBSCRIPTION_PLAN.WEB_PERPETUAL,
			SUBSCRIPTION_PLAN.DESIGNER_PERPETUAL

		];
		let isCloudOnly = true;

		plans.forEach(planId => {
			if (desktopPackages.includes(planId)) {
				isCloudOnly = false;
			}
		});
		return isCloudOnly;
	}

	areDesktopOnlyPlans(plans) {
		const cloudPackages = [
			SUBSCRIPTION_PLAN.ESSENTIAL,
			SUBSCRIPTION_PLAN.TEAM_PLUS
		];
		let isDesktopOnly = true;
		plans.forEach(planId => {
			if (cloudPackages.includes(planId)) {
				isDesktopOnly = false;
			}
		});
		return isDesktopOnly;
	}

	getCategoryOfCoupon(props, plans, currency) {
		const {
			isDiscountApplied,
			couponAppliedWithoutValidation,
			couponConfig,
			isResponsePendingFromEstimationEndpoint
		} = props.discount;

		let isCouponAppliedToCloud = false;
		let isCouponAppliedToDesktop = false;
		
		if (!isDiscountApplied ||
			(couponAppliedWithoutValidation && isResponsePendingFromEstimationEndpoint && couponConfig === null)) {
				
			if (isDiscountApplied && couponAppliedWithoutValidation && couponConfig === null) {
			}
			return { isCouponAppliedToCloud, isCouponAppliedToDesktop };
		}
		
		plans.forEach(planId => {

			const periodsArray = [SUBSCRIPTION_PERIOD.ANNUAL, SUBSCRIPTION_PERIOD.MONTHLY];

			if (this.isPerpetualOverviewMode || this.hasPerpetualCheckbox) {
				periodsArray.push(SUBSCRIPTION_PERIOD.PERPETUAL);
			}

			periodsArray.forEach(period => {

				if (period === SUBSCRIPTION_PERIOD.PERPETUAL && PACKAGES_CONFIG[planId].isPerpetual ||
					period !== SUBSCRIPTION_PERIOD.PERPETUAL && !PACKAGES_CONFIG[planId].isPerpetual) {
					const shouldApplyDiscount = this.shouldShowAppliedDiscountForCurrentPackage(
							planId,
							period,
							currency,
							props.discount.couponConfig,
							props.discount.discountType,
							props.discount.couponSetKey,
							props.discount.couponId,
							false,
							couponAppliedWithoutValidation,
							true,
							props.discount.appliedProdTypeOfLastValidCombination,
							props.discount.appliedProdCatOfLastValidCombination
					);
		
					if (shouldApplyDiscount) {
						PACKAGES_CONFIG[planId].isCloudSuitePlan && (isCouponAppliedToCloud = true);
						PACKAGES_CONFIG[planId].isCreativeToolsPlan && (isCouponAppliedToDesktop = true);
						PACKAGES_CONFIG[planId].isPerpetual && (isCouponAppliedToDesktop = true);
					}
				}
			});
		});

		return { isCouponAppliedToCloud, isCouponAppliedToDesktop };
	}

	getPeriodOfCoupon(props, plans, currency, category) {
		const { isDiscountApplied } = props.discount;

		let isCouponAppliedToMonthly = false;
		let isCouponAppliedToAnnualy = false;
		let isCouponAppliedToPerpetual = false;
		
		if (!isDiscountApplied) {
			return { isCouponAppliedToMonthly, isCouponAppliedToAnnualy, isCouponAppliedToPerpetual };
		}

		let searchInPlans = plans;
		if (category) {
			searchInPlans = searchInPlans.filter(planId => {
				return category === PLAN_CATEGORIES.CLOUD_SUITE && PACKAGES_CONFIG[planId].isCloudSuitePlan ||
				category === PLAN_CATEGORIES.CREATIVE_TOOLS && PACKAGES_CONFIG[planId].isCreativeToolsPlan ||
				category === PLAN_CATEGORIES.CREATIVE_TOOLS && PACKAGES_CONFIG[planId].isPerpetual;
			});
		}
		searchInPlans.forEach(planId => {

			const periodsArray = [SUBSCRIPTION_PERIOD.ANNUAL, SUBSCRIPTION_PERIOD.MONTHLY];

			if (this.isPerpetualOverviewMode || this.hasPerpetualCheckbox) {
				periodsArray.push(SUBSCRIPTION_PERIOD.PERPETUAL);
			}

			periodsArray.forEach(period => {

				if (period === SUBSCRIPTION_PERIOD.PERPETUAL && PACKAGES_CONFIG[planId].isPerpetual ||
					period !== SUBSCRIPTION_PERIOD.PERPETUAL && !PACKAGES_CONFIG[planId].isPerpetual) {

					const shouldApplyDiscount = this.shouldShowAppliedDiscountForCurrentPackage(
							planId,
							period,
							currency,
							props.discount.couponConfig,
							props.discount.discountType,
							props.discount.couponSetKey,
							props.discount.couponId,
							false,
							props.discount.appliedProdTypeOfLastValidCombination,
							props.discount.appliedProdCatOfLastValidCombination
					);
	
					if (shouldApplyDiscount) {
						period === SUBSCRIPTION_PERIOD.MONTHLY && (isCouponAppliedToMonthly = true);
						period === SUBSCRIPTION_PERIOD.ANNUAL && (isCouponAppliedToAnnualy = true);
						period === SUBSCRIPTION_PERIOD.PERPETUAL && (isCouponAppliedToPerpetual = true);
					}
	
				}
			});
		});

		return { isCouponAppliedToMonthly, isCouponAppliedToAnnualy, isCouponAppliedToPerpetual };
	}	

	get shouldRenderQuantityField() {
		return this.period === SUBSCRIPTION_PERIOD.PERPETUAL ||
			this.isPerpetualOverviewMode && !this.props.company.hasUnlimitedTeamSubscription ||
			!this.hasPlan;
	}

	get allPeriods() {
		const { activeSubscription } = this.state;
		let periods = [];

		if (!this.hasPlan) {
			periods.push(SUBSCRIPTION_PERIOD.ANNUAL, SUBSCRIPTION_PERIOD.MONTHLY);
		}

		if (this.hasPlan) {
			if (activeSubscription.period === SUBSCRIPTION_PERIOD.MONTHLY) {
				this.isScalePlan 
					?
					!this.isPlusOverviewMode && periods.push(SUBSCRIPTION_PERIOD.ANNUAL)
					:
					periods.push(SUBSCRIPTION_PERIOD.MONTHLY, SUBSCRIPTION_PERIOD.ANNUAL);

			} else if (!this.isScalePlan) {
				periods.push(SUBSCRIPTION_PERIOD.ANNUAL);
			}
		}

		if (activeSubscription.plan && !periods.includes(activeSubscription.period)) {
			periods.push(activeSubscription.period);
		}

		this.shouldRenderPerpetualCheckbox && periods.push(SUBSCRIPTION_PERIOD.PERPETUAL);

		return periods;
	}

	get shouldRenderPeriodSelector() {
		// No active subscription
		// or current plan with monthly period and not Team+ monthly -> show period selector
		// (as when active subscription is Team+ monthly then user can only upgrade to Team+ yearly, there are no other options)
		// or current subscription is perpetual
		// If user has perpetual, show period selector so user can buy more
		
		if (this.isPerpetualOverviewMode) return;
		return this.allPeriods.length > 1;
	}

	get shouldRenderAnnualAndMonthlyOptions() {
		const { activeSubscription } = this.state;
		return !this.hasPlan ||
			(activeSubscription.period === SUBSCRIPTION_PERIOD.MONTHLY && !(this.isScalePlan && this.isMonthlyPlan));
	}

	get shouldRenderCurrencySelector() {
		// No active or past subscription -> show currency selector
		return !getCurrencyUsedInCB(this.props.company);
	}

	get hasNonUnlimitedSubscription() {
		const { company } = this.props;
		return !company.hasUnlimitedTeamSubscription && this.hasPlan;
	}

	get canSubscriptionBeUpgraded() {
		const { activeSubscription } = this.state;

		if (this.props.company.hasUnlimitedTeamSubscription) return false;

		if (!this.hasPlan ||
			!_.isEmpty(SUBSCRIPTION_PLAN_UPGRADE_OPTIONS[activeSubscription.plan]) ||
			activeSubscription.period === SUBSCRIPTION_PERIOD.MONTHLY) {
			return true;
		}
	}
	//#endregion

}

Subscription.propTypes = {
	classes: PropTypes.object,
	company: PropTypes.object,
	paymentRedirectUrl: PropTypes.string,
	showPackageDiscontinuedMessage: PropTypes.func.isRequired,
	showRateLimitError: PropTypes.func.isRequired,
	showErrorPopup: PropTypes.func.isRequired,
	getSubscriptionEstimation: PropTypes.func.isRequired,
	getUpcomingInvoiceEstimate: PropTypes.func.isRequired,
	createChargeBeeSession: PropTypes.func.isRequired,
	createChargeBeeSubscription: PropTypes.func.isRequired,
	showPreloader: PropTypes.func.isRequired,
	showChargebeeLoader: PropTypes.func.isRequired,
	hideChargebeeLoader: PropTypes.func.isRequired,
	sendEmailNotification: PropTypes.func.isRequired,
	location: PropTypes.shape({
		pathname: PropTypes.string.isRequired,
		search: PropTypes.string
	}),
	history: PropTypes.object,
	currentPlanId: PropTypes.string,
	match: PropTypes.object.isRequired,
	plusOverview: PropTypes.bool,
	perpetualOverview: PropTypes.bool,
	isAdmin: PropTypes.bool,
	setErrorId: PropTypes.func.isRequired,
	writeUserSettings: PropTypes.func,
	settings: PropTypes.object,
	showModal: PropTypes.func,
	crs: PropTypes.object.isRequired,
	app: PropTypes.object.isRequired,
	discount: PropTypes.object.isRequired,
	writeCompanySettings: PropTypes.func,
	purchaseSeats: PropTypes.func,
	couponId: PropTypes.string,
	isDiscountTakeoverFromWebsite: PropTypes.bool,
	productName: PropTypes.string,
	productSource: PropTypes.string,
	productPeriod: PropTypes.string,
	magixCat: PropTypes.string,
	realEstatePlan: PropTypes.string,
	setAllPackagesShownFlag: PropTypes.func,
	setSubscriptionCategory: PropTypes.func,
	setSubscriptionView: PropTypes.func,
	setSubscriptionPeriod: PropTypes.func,
	setSubscriptionCurrency: PropTypes.func,
	setSeatsQuantity: PropTypes.func,
	setLicensesQuantity: PropTypes.func,
	setAppStateParams: PropTypes.func,
	clearSubscriptionState: PropTypes.func,
	clearAppliedDiscount: PropTypes.func,
	changeCouponType: PropTypes.func,
	currency: PropTypes.string,
	isStandardProductOverview: PropTypes.bool,
	isCBPlanExternalRedirect: PropTypes.bool,
	isCBPlanInternalRedirect: PropTypes.bool,
	selectedCompanyId: PropTypes.string,
	hideModal: PropTypes.func,
	companies: PropTypes.object,
	productQuantity: PropTypes.number,
	couponAppliedWithoutValidation: PropTypes.bool,
	navOpen: PropTypes.bool,
	modalShown: PropTypes.bool,
	hidePreloader: PropTypes.func,
	changeMagixDiscountProdType: PropTypes.func,
	setPendingTriggerCheckout: PropTypes.func,
	setReduceUsersApiErrorState: PropTypes.func,
	clearReduceUsersApiErrorState: PropTypes.func,
	applyDiscountUsingCouponId: PropTypes.func,
	reactivateSubscription: PropTypes.bool,
	wasRenewalPopupShown: PropTypes.bool,
	setRenewalPopupWasShown: PropTypes.func
};

const mapStateToProps = state => ({
	company: state.companies.rawDataById[state.companies.selectedId],
	paymentRedirectUrl: state.companies.paymentRedirectUrl,
	currentPlanId: getCurrentPlanId(state.companies.rawDataById[state.companies.selectedId]),
	isAdmin: isAdmin(state),
	modalShown: state.modal.modalShown,
	settings: state.session.user.settings,
	crs: state.crs,
	discount: state.discount,
	app: state.app,
	selectedCompanyId: state.companies.selectedId,
	companies: state.companies,
	wasRenewalPopupShown: state.app.wasRenewalPopupShown
});

const mapDispatchToProps = dispatch => bindActionCreators({
	getSubscriptionEstimation,
	getUpcomingInvoiceEstimate,
	showPackageDiscontinuedMessage,
	showRateLimitError,
	showErrorPopup,
	createChargeBeeSession,
	createChargeBeeSubscription,
	showPreloader,
	showChargebeeLoader,
	hideChargebeeLoader,
	sendEmailNotification,
	setErrorId,
	writeUserSettings,
	showModal,
	writeCompanySettings,
	purchaseSeats,
	setAllPackagesShownFlag,
	setSubscriptionCategory,
	setSubscriptionView,
	setSubscriptionPeriod,
	setSubscriptionCurrency,
	setSeatsQuantity,
	setLicensesQuantity,
	setAppStateParams,
	clearSubscriptionState,
	clearAppliedDiscount,
	changeCouponType,
	changeMagixDiscountProdType,
	hideModal,
	hidePreloader,
	setPendingTriggerCheckout,
	applyDiscountUsingCouponId,
	setReduceUsersApiErrorState,
	setRenewalPopupWasShown,
	clearReduceUsersApiErrorState
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Subscription);


// WEBPACK FOOTER //
// ./src/containers/Subscription/Subscription.js